import * as tslib_1 from "tslib";
import { Component, NgModule, Input, Injectable, Output, EventEmitter, ViewChild, Inject, Optional, ElementRef, Renderer2, animate, state, style, transition, trigger, ChangeDetectorRef, Directive, Pipe, Injector, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, Validators, NgModel, NG_VALIDATORS, NG_ASYNC_VALIDATORS, NgForm, NG_VALUE_ACCESSOR, ControlContainer } from '@angular/forms';
import { ConfirmationService, ConfirmDialogModule, DropdownModule, CalendarModule, TooltipModule, DialogModule, AutoCompleteModule, FileUpload, FileUploadModule, InputMaskModule, EditorModule, BlockUIModule } from 'primeng/primeng';
import { Observable } from 'rxjs';
import { Table, TableModule } from 'primeng/table';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { PapaParseService, PapaParseModule } from 'ngx-papaparse';
import { saveAs } from 'file-saver/FileSaver';
import { Subject } from 'rxjs/Subject';
import { saveAs as saveAs$1 } from 'file-saver';
import { TreeviewI18n, TreeviewConfig, TreeviewItem, TreeviewHelper, DropdownTreeviewComponent, TreeviewEventParser, TreeviewModule } from 'ngx-treeview';
import { TooltipModule as TooltipModule$1 } from 'primeng/tooltip';
import { PickListModule } from 'primeng/picklist';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable as Observable$1, Subject as Subject$1 } from 'rxjs/Rx';
import { Router, RouterModule } from '@angular/router';
import { map } from 'rxjs/operators';
import { Idle, NgIdleModule } from '@ng-idle/core';
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MainContentComponent = /** @class */ (function () {
    function MainContentComponent() {
    }
    return MainContentComponent;
}());
MainContentComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-main-content',
                template: "\n    <section role=\"main\">\n      <ng-content select=\"pmv-main-content-header\"></ng-content>\n      <ng-content select=\"pmv-main-content-body\"></ng-content>\n    </section>\n  "
            },] },
];
/** @nocollapse */
MainContentComponent.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
SharedModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                ],
                exports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                ],
            },] },
];
/** @nocollapse */
SharedModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MainContentHeaderComponent = /** @class */ (function () {
    function MainContentHeaderComponent() {
    }
    return MainContentHeaderComponent;
}());
MainContentHeaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-main-content-header',
                template: "\n    <header role=\"heading\">\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col-md-8 col-sm-6 col-xs-6\">\n            <h2>{{ title }}</h2>\n            <p class=\"hidden-xs\">{{ subtitle }}</p>\n          </div>\n          <div class=\"col-md-4 col-sm-6 col-xs-6 btn-action\">\n            <ng-content></ng-content>\n          </div>\n        </div>\n      </div>\n    </header>\n  ",
                styles: ["\n    h2 {\n      color: #2D699F;\n    }\n    .btn-action {\n      text-align: right;\n    }\n  "]
            },] },
];
/** @nocollapse */
MainContentHeaderComponent.ctorParameters = function () { return []; };
MainContentHeaderComponent.propDecorators = {
    "title": [{ type: Input },],
    "subtitle": [{ type: Input },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MainContentBodyComponent = /** @class */ (function () {
    function MainContentBodyComponent() {
    }
    return MainContentBodyComponent;
}());
MainContentBodyComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-main-content-body',
                template: "\n    <fieldset class=\"section\">\n      <div class=\"container\" [ngStyle]=\"style\">\n        <ng-content></ng-content>\n      </div>\n    </fieldset>\n  "
            },] },
];
/** @nocollapse */
MainContentBodyComponent.ctorParameters = function () { return []; };
MainContentBodyComponent.propDecorators = {
    "style": [{ type: Input },],
    "styleClass": [{ type: Input },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVMainContentModule = /** @class */ (function () {
    function PMVMainContentModule() {
    }
    return PMVMainContentModule;
}());
PMVMainContentModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                ],
                declarations: [
                    MainContentComponent,
                    MainContentHeaderComponent,
                    MainContentBodyComponent,
                ],
                exports: [
                    MainContentComponent,
                    MainContentHeaderComponent,
                    MainContentBodyComponent,
                ],
            },] },
];
/** @nocollapse */
PMVMainContentModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var FieldsetComponent = /** @class */ (function () {
    function FieldsetComponent() {
    }
    return FieldsetComponent;
}());
FieldsetComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-fieldset',
                template: "<fieldset>\n  <legend *ngIf=\"header\">{{ header }}</legend>\n  <ng-content></ng-content>\n</fieldset>\n",
                styles: ["fieldset{\n  border:2px solid Lightgrey;\n  padding:10px;\n  border-radius:3px; }\nlegend{\n  font-size:13px;\n  width:auto;\n  padding:0 5px;\n  border-bottom:none;\n  font-family:\"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin-bottom:0;\n  letter-spacing:0.2px;\n  font-weight:bold;\n  color:#333; }\n"]
            },] },
];
/** @nocollapse */
FieldsetComponent.ctorParameters = function () { return []; };
FieldsetComponent.propDecorators = {
    "header": [{ type: Input },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVFieldsetModule = /** @class */ (function () {
    function PMVFieldsetModule() {
    }
    return PMVFieldsetModule;
}());
PMVFieldsetModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                ],
                declarations: [
                    FieldsetComponent,
                ],
                exports: [
                    FieldsetComponent,
                ],
            },] },
];
/** @nocollapse */
PMVFieldsetModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ConfirmDialogComponent = /** @class */ (function () {
    function ConfirmDialogComponent() {
        this.header = 'Confirmação';
        this.width = 400;
        this.icon = 'fa fa-question-circle';
    }
    return ConfirmDialogComponent;
}());
ConfirmDialogComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-confirm-dialog',
                template: "<p-confirmDialog [key]=\"key\" [header]=\"header\" [icon]=\"icon\" [width]=\"width\" acceptLabel=\"Sim\" rejectLabel=\"N\u00E3o\" appendTo=\"body\"\n  acceptButtonStyleClass=\"btn btn-size btn-primary\" rejectButtonStyleClass=\"btn btn-size btn-danger\">\n</p-confirmDialog>\n",
                styles: [":host /deep/ .ui-dialog{\n  -webkit-box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.3);\n  box-shadow:0 1px 2px 0 rgba(0, 0, 0, 0.3); }\n:host /deep/ .ui-dialog .ui-dialog-titlebar{\n  padding:1em;\n  border-bottom:1px solid #c7c7c7; }\n:host /deep/ .ui-dialog .ui-dialog-titlebar .ui-dialog-title{\n  margin:0;\n  float:none;\n  font-size:1.5em;\n  font-weight:bold; }\n:host /deep/ .ui-dialog .ui-dialog-titlebar .ui-dialog-titlebar-icon{\n  color:#767b7f;\n  border:0 none;\n  -webkit-transition:color 0.3s;\n  transition:color 0.3s;\n  padding:0; }\n:host /deep/ .ui-dialog .ui-dialog-titlebar .ui-dialog-titlebar-icon:hover{\n  color:#2d353c; }\n:host /deep/ .ui-dialog .ui-dialog-content{\n  padding:1em; }\n:host /deep/ .ui-dialog .ui-dialog-buttonpane{\n  padding:0.375em 0.75em;\n  text-align:right; }\n:host /deep/ .ui-dialog.ui-confirm-dialog .ui-dialog-content > span{\n  display:inline-block;\n  vertical-align:middle;\n  line-height:1em;\n  margin:0; }\n:host /deep/ .btn-size{\n  padding-top:2px !important;\n  height:34px !important; }\n"],
            },] },
];
/** @nocollapse */
ConfirmDialogComponent.ctorParameters = function () { return []; };
ConfirmDialogComponent.propDecorators = {
    "key": [{ type: Input },],
    "header": [{ type: Input },],
    "width": [{ type: Input },],
    "icon": [{ type: Input },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @record
 */
/**
 * Serviço para chamada da caixa de diálogo de confirmação do sistema.
 */
var ConfirmDialogService = /** @class */ (function () {
    /**
     * @param {?} confirmationService
     */
    function ConfirmDialogService(confirmationService) {
        this.confirmationService = confirmationService;
    }
    /**
     * Exibe a caixa de confirmação do sistema.
     *
     * @param {?} confirmation parâmetros para exibição da caixa de confirmação
     * @return {?}
     */
    ConfirmDialogService.prototype.confirm = function (confirmation) {
        this.confirmationService.confirm(confirmation);
    };
    return ConfirmDialogService;
}());
ConfirmDialogService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ConfirmDialogService.ctorParameters = function () { return [
    { type: ConfirmationService, },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVConfirmDialogModule = /** @class */ (function () {
    function PMVConfirmDialogModule() {
    }
    /**
     * @return {?}
     */
    PMVConfirmDialogModule.forRoot = function () {
        return {
            ngModule: PMVConfirmDialogModule,
            providers: [
                ConfirmationService,
                ConfirmDialogService,
            ]
        };
    };
    return PMVConfirmDialogModule;
}());
PMVConfirmDialogModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    ConfirmDialogModule
                ],
                declarations: [
                    ConfirmDialogComponent,
                ],
                exports: [
                    ConfirmDialogComponent
                ],
            },] },
];
/** @nocollapse */
PMVConfirmDialogModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @abstract
 */
var ValueAccessorBase = /** @class */ (function () {
    function ValueAccessorBase() {
        this.changedListeners = new Array();
        this.touchedListeners = new Array();
    }
    Object.defineProperty(ValueAccessorBase.prototype, "value", {
        /**
         * @return {?}
         */
        get: function () {
            return this.innerValue;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this.innerValue !== value) {
                this.innerValue = value;
                this.changedListeners.forEach(function (f) { return f(value); });
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    ValueAccessorBase.prototype.writeValue = function (value) {
        this.innerValue = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    ValueAccessorBase.prototype.registerOnChange = function (fn) {
        this.changedListeners.push(fn);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    ValueAccessorBase.prototype.registerOnTouched = function (fn) {
        this.touchedListeners.push(fn);
    };
    /**
     * @return {?}
     */
    ValueAccessorBase.prototype.touch = function () {
        this.touchedListeners.forEach(function (f) { return f(); });
    };
    return ValueAccessorBase;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeValidator(validator) {
    var /** @type {?} */ func = ((validator)).validate.bind(validator);
    if (typeof func === 'function') {
        return function (c) { return func(c); };
    }
    else {
        return /** @type {?} */ (validator);
    }
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeValidators(validators) {
    if (validators == null || validators.length === 0) {
        return null;
    }
    var /** @type {?} */ normalizedValidators = validators.map(normalizeValidator);
    return Validators.compose(normalizedValidators);
}
/**
 * @param {?} validators
 * @param {?} asyncValidators
 * @return {?}
 */
function validate(validators, asyncValidators) {
    return function (control) {
        var /** @type {?} */ synchronousValid = function () { return composeValidators(validators)(control); };
        if (asyncValidators) {
            var /** @type {?} */ asyncValidator = composeValidators(asyncValidators);
            return asyncValidator(control)["map"](function (v) {
                var /** @type {?} */ secondary = synchronousValid();
                if (secondary || v) {
                    // compose async and sync validator results
                    return Object.assign({}, secondary, v);
                }
            });
        }
        if (validators) {
            return Observable.of(synchronousValid());
        }
        return Observable.of(null);
    };
}
/**
 * @param {?} validator
 * @param {?} key
 * @return {?}
 */
function message(validator, key) {
    switch (key) {
        case 'pattern':
            return 'O valor não corresponde ao padrão.';
        case 'minlength':
            return 'O valor deve ter no mínimo N caracteres.';
        case 'maxlength':
            return 'Digite menos caracteres. Está ultrapassando o valor máximo de caracteres.';
    }
    switch (typeof validator[key]) {
        case 'string':
            return /** @type {?} */ (validator[key]);
        default: {
            if (key === 'required') {
                return 'O campo é obrigatório.';
            }
            return "Falha de valida\u00E7\u00E3o: " + key;
        }
    }
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @abstract
 */
var ElementBase = /** @class */ (function (_super) {
    tslib_1.__extends(ElementBase, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function ElementBase(validators, asyncValidators, ngForm) {
        var _this = _super.call(this) || this;
        _this.validators = validators;
        _this.asyncValidators = asyncValidators;
        _this.ngForm = ngForm;
        return _this;
    }
    /**
     * @return {?}
     */
    ElementBase.prototype.validate = function () {
        return this.model
            ? validate(this.validators, this.asyncValidators)(this.model.control)
            : Observable.of(null);
    };
    Object.defineProperty(ElementBase.prototype, "invalid", {
        /**
         * @return {?}
         */
        get: function () {
            return this.validate().map(function (v) { return Object.keys(v || {}).length > 0; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementBase.prototype, "failures", {
        /**
         * @return {?}
         */
        get: function () {
            return this.validate().map(function (v) {
                if (!v) {
                    return [];
                }
                return Object.keys(v).map(function (k) { return message(v, k); });
            });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    ElementBase.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    Object.defineProperty(ElementBase.prototype, "touched", {
        /**
         * @return {?}
         */
        get: function () {
            return this.model && this.model.touched;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementBase.prototype, "untouched", {
        /**
         * @return {?}
         */
        get: function () {
            return this.model && this.model.untouched;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementBase.prototype, "pristine", {
        /**
         * @return {?}
         */
        get: function () {
            return this.model && this.model.pristine;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementBase.prototype, "dirty", {
        /**
         * @return {?}
         */
        get: function () {
            return this.model && this.model.dirty;
        },
        enumerable: true,
        configurable: true
    });
    return ElementBase;
}(ValueAccessorBase));
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InputSearchComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputSearchComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function InputSearchComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.typingDelay = 300;
        _this.complete = new EventEmitter();
        _this.identifier = "form-input-search-" + identifier++;
        return _this;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    InputSearchComponent.prototype.ngOnChanges = function (changes) {
        if (changes && changes["value"]) {
            this.onInput();
        }
    };
    /**
     * @return {?}
     */
    InputSearchComponent.prototype.onInput = function () {
        var _this = this;
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(function (_) {
            _this.complete.emit(_this.value);
            _this.timeout = null;
        }, this.typingDelay);
    };
    return InputSearchComponent;
}(ElementBase));
InputSearchComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-input-search',
                template: "<div>\n  <label *ngIf=\"label\" [attr.for]=\"identifier\">{{label}}</label>\n  <div class=\"input-group\">\n    <input type=\"text\" class=\"form-control\" [placeholder]=\"placeholder || ''\" [(ngModel)]=\"value\" [id]=\"identifier\" [disabled]=\"disabled\"\n      (input)=\"onInput()\" />\n    <validation [elementBase]=\"this\"></validation>\n    <div class=\"input-group-addon\">\n      <span class=\"glyphicon glyphicon-search\"></span>\n    </div>\n  </div>\n</div>\n",
                styles: [".input-group-addon{\n  border-width:2px;\n  border-color:#ddd; }\n"]
            },] },
];
/** @nocollapse */
InputSearchComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
InputSearchComponent.propDecorators = {
    "label": [{ type: Input },],
    "placeholder": [{ type: Input },],
    "disabled": [{ type: Input },],
    "typingDelay": [{ type: Input },],
    "complete": [{ type: Output },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
};
var identifier = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DatatableComponent = /** @class */ (function () {
    /**
     * @param {?} el
     * @param {?} renderer
     */
    function DatatableComponent(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        // Paginação
        this.paginator = true;
        this.rows = 10;
        this.first = 0;
        this.onRowSelect = new EventEmitter();
        this.selectedChange = new EventEmitter();
        // Exibição
        this.showHeader = true;
        this.showTooltipOnRows = false;
        // Ações
        this.onAction = new EventEmitter();
        this.lazyLoad = new EventEmitter();
        this.onPageChange = new EventEmitter();
        // Mensagem para tabela vazia
        this.emptyMessage = 'Nenhum registro encontrado';
    }
    Object.defineProperty(DatatableComponent.prototype, "selected", {
        /**
         * @return {?}
         */
        get: function () { return this._selected; },
        /**
         * @param {?} selected
         * @return {?}
         */
        set: function (selected) {
            if (this._selected !== selected) {
                this._selected = selected;
                this.selectedChange.emit(selected);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    DatatableComponent.prototype.ngOnChanges = function (changes) {
        if (changes.first) {
            this.indexFirstObjectPage = (this.first || 0) + 1;
        }
        if (changes.values) {
            if (!this.lazy) {
                this.totalRecords = this.values && this.values.length || 0;
            }
        }
    };
    /**
     * @return {?}
     */
    DatatableComponent.prototype.ngOnInit = function () {
        this.indexFirstObjectPage = 1;
    };
    /**
     * @return {?}
     */
    DatatableComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var /** @type {?} */ tableElement = this.el.nativeElement.querySelector('table');
        this.renderer.addClass(tableElement, 'table');
        this.renderer.addClass(tableElement, 'table-striped');
        this.renderer.addClass(tableElement, 'table-hover');
        this.renderer.addClass(tableElement.parentElement, 'table-responsive');
        if (this.filter) {
            this.filterSearchInput.complete.asObservable().subscribe(function (query) {
                _this.table.filterGlobal(query, 'contains');
            });
        }
    };
    /**
     * Dispara um evento de uma ação da tabela.
     *
     * @param {?} action ação realizada
     * @param {?} object objeto na qual a ação foi realizada
     * @param {?} index
     * @return {?}
     */
    DatatableComponent.prototype.actionEvent = function (action, object, index) {
        if (action.action) {
            action.action(object, index);
        }
        else {
            this.onAction.emit({ action: action.title, object: object, index: index });
        }
    };
    /**
     * @param {?} action
     * @param {?} obj
     * @return {?}
     */
    DatatableComponent.prototype.getIcon = function (action, obj) {
        return "glyphicon " + (typeof action.icon === 'string' ? action.icon : action.icon(obj));
    };
    /**
     * @param {?} col
     * @param {?} obj
     * @return {?}
     */
    DatatableComponent.prototype.displayValue = function (col, obj) {
        if (col.valueDisplayFn) {
            return col.field
                ? col.valueDisplayFn(obj[col.field])
                : col.valueDisplayFn(obj);
        }
        return obj[col.field];
    };
    /**
     * @param {?} col
     * @param {?} obj
     * @return {?}
     */
    DatatableComponent.prototype.displayTitle = function (col, obj) {
        if (col.editable) {
            return null;
        }
        if (col.tooltipValue) {
            return col.tooltipValue(obj);
        }
        if (!this.showTooltipOnRows) {
            return null;
        }
        return this.displayValue(col, obj);
    };
    /**
     * Listener do evento de carregamento dinâmico de dados da tabela.
     * @param {?} event
     * @return {?}
     */
    DatatableComponent.prototype.onLazyLoad = function (event) {
        event = Object.assign({}, event);
        event.page = event ? Math.floor((event.first || 0) / this.rows) + 1 : 1;
        this.lazyLoad.emit(event);
        this.indexFirstObjectPage = event.first + 1;
    };
    Object.defineProperty(DatatableComponent.prototype, "indexLastObjectPage", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ indexLastObjectPage = this.indexFirstObjectPage + this.rows - 1;
            if (this.values && this.values.length && indexLastObjectPage > this.totalRecords) {
                return this.totalRecords;
            }
            return indexLastObjectPage;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    DatatableComponent.prototype.onPage = function (event) {
        if (!this.lazy) {
            this.indexFirstObjectPage = event.first + 1;
        }
        this.onPageChange.emit(event);
    };
    /**
     * @return {?}
     */
    DatatableComponent.prototype.reset = function () {
        this.table.reset();
    };
    return DatatableComponent;
}());
DatatableComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-datatable',
                template: "<pmv-input-search *ngIf=\"filter\" placeholder=\"Pesquisar\" #filterSearchInput></pmv-input-search>\n<p-table #table [columns]=\"columns\" [value]=\"values\" [loading]=\"loading\" loadingIcon=\"fa-spinner\" [paginator]=\"paginator\"\n  [rows]=\"rows\" [first]=\"first\" [totalRecords]=\"totalRecords\" [sortMode]=\"multipleSort ? 'multiple' : 'single'\" [selectionMode]=\"selectionMode\"\n  [(selection)]=\"selected\" [metaKeySelection]=\"metaKeySelection\" [lazy]=\"lazy\" (onLazyLoad)=\"onLazyLoad($event)\" (onPage)=\"onPage($event)\" [ngClass]=\"{'disablepage': !totalRecords || (totalRecords <= rows)}\">\n  <ng-template pTemplate=\"header\">\n    <tr *ngIf=\"showHeader\">\n      <th *ngIf=\"selectWithCheckbox\" style=\"width: 2.25em\">\n        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>\n      </th>\n      <ng-container *ngFor=\"let col of columns\">\n        <div *ngIf=\"col.sortable; then sortableColumn; else notSortableColumn\"></div>\n        <ng-template #sortableColumn>\n          <th [style.width]=\"col.width\" [attr.title]=\"col.tooltipTitle\" [ngClass]=\"col.headerClass\" [pSortableColumn]=\"col.field\">\n            {{col.header}}\n            <p-sortIcon [field]=\"col.field\"></p-sortIcon>\n          </th>\n        </ng-template>\n        <ng-template #notSortableColumn>\n          <th [style.width]=\"col.width\" [attr.title]=\"col.tooltipTitle\" [ngClass]=\"col.headerClass\">\n            {{col.header}}\n          </th>\n        </ng-template>\n      </ng-container>\n      <th *ngIf=\"actions && actions.length\" [style.width.px]=\"actions.length === 1 ? 55 : (actions.length * 30)\">\n        A\u00E7\u00F5es\n      </th>\n    </tr>\n  </ng-template>\n  <ng-template pTemplate=\"body\" let-obj let-index=\"rowIndex\">\n    <tr [pSelectableRow]=\"obj\">\n      <td *ngIf=\"selectWithCheckbox\" style=\"width: 2.25em\">\n        <p-tableCheckbox [value]=\"obj\"></p-tableCheckbox>\n      </td>\n      <td *ngFor=\"let col of columns\" class=\"datatable-cell\" [class.editable]=\"col.editable\" [style.width]=\"col.width\" [ngClass]=\"col.styleClass && col.styleClass(obj)\" [attr.title]=\"displayTitle(col, obj)\">\n        <div *ngIf=\"col.editable; then editableCell; else normalCell\"></div>\n        <ng-template #editableCell>\n          <ng-container [ngSwitch]=\"col.editConfig.inputType\">\n            <ng-container *ngSwitchDefault>\n              <pmv-input-text [(ngModel)]=\"obj[col.field]\"\n                [disabled]=\"col.editConfig.disabled && col.editConfig.disabled(obj)\"\n                [readonly]=\"col.editConfig.readonly && col.editConfig.readonly(obj)\"\n                [maxlength]=\"col.editConfig.textConfig && col.editConfig.textConfig.maxlength\"\n                (keyup)=\"col.editConfig.textConfig.onKeyup && col.editConfig.textConfig.onKeyup(obj)\"\n              ></pmv-input-text>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'text'\">\n              <pmv-input-text [(ngModel)]=\"obj[col.field]\"\n                [disabled]=\"col.editConfig.disabled && col.editConfig.disabled(obj)\"\n                [readonly]=\"col.editConfig.readonly && col.editConfig.readonly(obj)\"\n                [maxlength]=\"col.editConfig.textConfig && col.editConfig.textConfig.maxlength\"\n                (keyup)=\"col.editConfig.textConfig.onKeyup && col.editConfig.textConfig.onKeyup(obj)\"\n              ></pmv-input-text>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'dropdown'\">\n              <pmv-dropdown [(ngModel)]=\"obj[col.field]\"\n                [disabled]=\"col.editConfig.disabled && col.editConfig.disabled(obj)\"\n                [options]=\"col.editConfig.dropdownConfig.options(obj)\"\n                [optionLabelField]=\"col.editConfig.dropdownConfig.optionLabelField\"\n                [optionValueField]=\"col.editConfig.dropdownConfig.optionValueField\"\n                [defaultOption]=\"col.editConfig.dropdownConfig.defaultOption\"\n                [filter]=\"col.editConfig.dropdownConfig.filter\"\n                (onChange)=\"col.editConfig.dropdownConfig.onChange && col.editConfig.dropdownConfig.onChange(obj)\"\n              ></pmv-dropdown>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'decimal'\">\n              <pmv-input-decimal [(ngModel)]=\"obj[col.field]\"\n                [disabled]=\"col.editConfig.disabled && col.editConfig.disabled(obj)\"\n                [readonly]=\"col.editConfig.readonly && col.editConfig.readonly(obj)\"\n                [options]=\"col.editConfig.decimalConfig.options\"\n                (keyup)=\"col.editConfig.decimalConfig.onKeyup && col.editConfig.decimalConfig.onKeyup(obj)\"\n              ></pmv-input-decimal>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'checkbox'\">\n              <div style=\"text-align: center\">\n                <input type=\"checkbox\" [(ngModel)]=\"obj[col.field]\" (ngModelChange)=\"col.editConfig.checkboxConfig.ngModelChange && col.editConfig.checkboxConfig.ngModelChange($event, obj)\" [disabled]=\"col.editConfig.disabled && col.editConfig.disabled(obj)\" />\n              </div>\n            </ng-container>\n            <ng-container *ngSwitchCase=\"'datepicker'\">\n              <pmv-datepicker [(ngModel)]=\"obj[col.field]\" [disabled]=\"col.editConfig.disabled && col.editConfig.disabled(obj)\"\n                [showTime]=\"col.editConfig.datepickerConfig.showTime\" appendTo=\"body\">\n              </pmv-datepicker>\n            </ng-container>\n          </ng-container>\n        </ng-template>\n        <ng-template #normalCell>\n          <span>\n            {{ displayValue(col, obj) }}\n          </span>\n        </ng-template>\n      </td>\n      <td *ngIf=\"actions && actions.length\" [style.width.px]=\"actions.length === 1 ? 55 : (actions.length * 30)\">\n        <ng-container *ngFor=\"let action of actions\">\n          <span class=\"action-icon\" [class.is-hidden]=\"action.isHidden && action.isHidden(obj, index)\" (click)=\"actionEvent(action, obj, index)\"\n            [pTooltip]=\"action.title\" tooltipPosition=\"left\">\n            <span [class]=\"getIcon(action, obj)\"></span>\n          </span>\n        </ng-container>\n      </td>\n    </tr>\n  </ng-template>\n  <ng-template pTemplate=\"emptymessage\">\n    <tr>\n      <td style=\"font-size: 14px !important;\" [attr.colspan]=\"(columns && columns.length || 0) + (actions && actions.length ? 1 : 0) + (selectWithCheckbox ? 1 : 0)\">{{ emptyMessage }}</td>\n    </tr>\n  </ng-template>\n</p-table>\n<span *ngIf=\"paginator && values && values.length\" class=\"database-summary\" [class.compact]=\"compactSummary\">\n  <div *ngIf=\"compactSummary; then compact; else long\"></div>\n  <ng-template #compact>\n    {{ indexFirstObjectPage }} a {{ indexLastObjectPage }} de {{ totalRecords }}\n  </ng-template>\n  <ng-template #long>\n    Listando de {{ indexFirstObjectPage }} a {{ indexLastObjectPage }} - {{ totalRecords }} registros\n  </ng-template>\n</span>\n",
                styles: [":host /deep/ .ui-table-wrapper{\n  overflow:initial; }\n:host /deep/ table{\n  margin-bottom:10px;\n  font-family:\"Helvetica Neue\", Helvetica, Arial, sans-serif; }\n:host /deep/ thead{\n  border-top:1px solid #eee; }\n:host /deep/ th,\n:host /deep/ td{\n  padding:8px !important; }\n:host /deep/ tr.ui-state-highlight,\n:host /deep/ tr.ui-state-highlight td,\n:host /deep/ tr.ui-state-highlight td .glyphicon{\n  background-color:#0275d8 !important;\n  color:#ffffff !important; }\n:host /deep/ .ui-state-active{\n  color:#fff; }\n:host /deep/ .ui-paginator-bottom{\n  border:none; }\n:host /deep/ .glyphicon{\n  margin:0px 2px;\n  cursor:pointer; }\n:host /deep/ tr.ui-state-highlight .ui-chkbox .ui-chkbox-box{\n  border:none; }\n:host /deep/ .ui-chkbox .ui-chkbox-box{\n  border:1px solid #aaa; }\n:host /deep/ .ui-table-hoverable-rows tbody > tr{\n  cursor:pointer; }\n.action-icon{\n  color:#2d699f; }\n.action-icon.is-hidden{\n  visibility:hidden; }\n.database-summary{\n  position:relative;\n  left:7px;\n  bottom:25px;\n  pointer-events:none; }\n  .database-summary.compact{\n    font-size:0.85em; }\n.datatable-cell{\n  overflow:hidden;\n  text-overflow:ellipsis; }\n:host /deep/ .disablepage .ui-paginator-bottom{\n  pointer-events:none; }\n.datatable-cell.editable{\n  padding:3px 5px !important;\n  overflow:initial; }\n  .datatable-cell.editable pmv-input-text /deep/ .form-control{\n    height:29px;\n    padding-left:8px;\n    padding-right:8px; }\n  .datatable-cell.editable pmv-dropdown /deep/ > div{\n    background-color:#fff; }\n    .datatable-cell.editable pmv-dropdown /deep/ > div .ui-dropdown{\n      height:29px; }\n      .datatable-cell.editable pmv-dropdown /deep/ > div .ui-dropdown .ui-dropdown-label{\n        padding:0; }\n      .datatable-cell.editable pmv-dropdown /deep/ > div .ui-dropdown .ui-dropdown-item{\n        padding-top:.25em; }\n  .datatable-cell.editable pmv-input-decimal /deep/ .form-control{\n    height:29px;\n    padding-left:8px;\n    padding-right:8px; }\n"]
            },] },
];
/** @nocollapse */
DatatableComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
DatatableComponent.propDecorators = {
    "filterSearchInput": [{ type: ViewChild, args: ['filterSearchInput',] },],
    "values": [{ type: Input },],
    "columns": [{ type: Input },],
    "actions": [{ type: Input },],
    "table": [{ type: ViewChild, args: [Table,] },],
    "paginator": [{ type: Input },],
    "rows": [{ type: Input },],
    "first": [{ type: Input },],
    "compactSummary": [{ type: Input },],
    "selectionMode": [{ type: Input },],
    "metaKeySelection": [{ type: Input },],
    "selectWithCheckbox": [{ type: Input },],
    "onRowSelect": [{ type: Output },],
    "selected": [{ type: Input },],
    "selectedChange": [{ type: Output },],
    "showHeader": [{ type: Input },],
    "showTooltipOnRows": [{ type: Input },],
    "filter": [{ type: Input },],
    "onAction": [{ type: Output },],
    "lazy": [{ type: Input },],
    "totalRecords": [{ type: Input },],
    "loading": [{ type: Input },],
    "lazyLoad": [{ type: Output },],
    "onPageChange": [{ type: Output },],
    "multipleSort": [{ type: Input },],
    "emptyMessage": [{ type: Input },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ValidationComponent = /** @class */ (function () {
    function ValidationComponent() {
    }
    return ValidationComponent;
}());
ValidationComponent.decorators = [
    { type: Component, args: [{
                selector: 'validation',
                template: "\n    <div role=\"alert\" *ngIf=\"e && !e.disabled && (e.invalid | async) && ((e.ngForm && e.ngForm['validateOnSubmit'] && e.ngForm.submitted) || (!(e.ngForm && e.ngForm['validateOnSubmit']) && (e.dirty || e.touched)))\">\n      <label [ngClass]=\"'label label-danger'\" *ngFor=\"let message of (e.failures | async)\">\n        {{ message }}\n      </label>\n    </div>\n  ",
            },] },
];
/** @nocollapse */
ValidationComponent.ctorParameters = function () { return []; };
ValidationComponent.propDecorators = {
    "e": [{ type: Input, args: ['elementBase',] },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVValidationModule = /** @class */ (function () {
    function PMVValidationModule() {
    }
    return PMVValidationModule;
}());
PMVValidationModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                ],
                declarations: [
                    ValidationComponent,
                ],
                exports: [
                    ValidationComponent,
                ],
            },] },
];
/** @nocollapse */
PMVValidationModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVInputSearchModule = /** @class */ (function () {
    function PMVInputSearchModule() {
    }
    return PMVInputSearchModule;
}());
PMVInputSearchModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    PMVValidationModule,
                ],
                declarations: [
                    InputSearchComponent,
                ],
                exports: [
                    InputSearchComponent,
                ]
            },] },
];
/** @nocollapse */
PMVInputSearchModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var animations = [
    trigger('flyInOut', [
        state('in', style({ transform: 'translateX(0)' })),
        transition('void => *', [
            style({ transform: 'translateX(100%)' }),
            animate(100)
        ]),
        state('out', style({ transform: 'translateX(100%)' })),
        transition('* => void', [
            animate(100, style({ transform: 'translateX(100%)' }))
        ])
    ])
];
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InputTextComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputTextComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function InputTextComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.autocomplete = 'off';
        _this.blur = new EventEmitter();
        _this.identifier = "form-input-text-" + identifier$1++;
        return _this;
    }
    /**
     * Emite o evento de blur.
     * @return {?}
     */
    InputTextComponent.prototype.blurEvent = function () {
        this.blur.emit(this.value);
    };
    /**
     * @return {?}
     */
    InputTextComponent.prototype.focus = function () {
        this.inputtext.nativeElement.focus();
    };
    return InputTextComponent;
}(ElementBase));
InputTextComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-input-text',
                template: "<div>\n  <label *ngIf=\"label\" [attr.for]=\"identifier\">{{label}}\n    <pmv-mini-loading [isLoading]=\"isLoading\"></pmv-mini-loading>\n  </label>\n  <input #inputtext [(ngModel)]=\"value\" [type]=\"type\" [id]=\"identifier\" [placeholder]=\"placeholder || ''\" [ngClass]=\"{'form-control': true, invalid: (invalid | async)}\"\n    [disabled]=\"disabled\" [readonly]=\"readonly\" (blur)=\"blurEvent()\" [autocomplete]=\"autocomplete\" [maxlength]=\"maxlength\"\n  />\n  <validation [elementBase]=\"this\"></validation>\n</div>\n",
                styles: ["input[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button{\n  -webkit-appearance:none;\n  margin:0; }\ninput[type=\"number\"]{\n  -moz-appearance:textfield; }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: InputTextComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
InputTextComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
InputTextComponent.propDecorators = {
    "inputtext": [{ type: ViewChild, args: ['inputtext',] },],
    "label": [{ type: Input },],
    "placeholder": [{ type: Input },],
    "type": [{ type: Input },],
    "disabled": [{ type: Input },],
    "readonly": [{ type: Input },],
    "isLoading": [{ type: Input },],
    "autocomplete": [{ type: Input },],
    "maxlength": [{ type: Input },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
    "blur": [{ type: Output },],
};
var identifier$1 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MiniLoadingComponent = /** @class */ (function () {
    function MiniLoadingComponent() {
    }
    return MiniLoadingComponent;
}());
MiniLoadingComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-mini-loading',
                template: "<i [class.hidden]=\"!isLoading\" class=\"fa fa-spin fa-spinner mini-loading\" style=\"margin-left: 5px\"></i>\n",
                styles: [""]
            },] },
];
/** @nocollapse */
MiniLoadingComponent.ctorParameters = function () { return []; };
MiniLoadingComponent.propDecorators = {
    "isLoading": [{ type: Input },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVMiniLoadingModule = /** @class */ (function () {
    function PMVMiniLoadingModule() {
    }
    return PMVMiniLoadingModule;
}());
PMVMiniLoadingModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                ],
                declarations: [
                    MiniLoadingComponent,
                ],
                exports: [
                    MiniLoadingComponent,
                ],
            },] },
];
/** @nocollapse */
PMVMiniLoadingModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVInputTextModule = /** @class */ (function () {
    function PMVInputTextModule() {
    }
    return PMVInputTextModule;
}());
PMVInputTextModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    PMVValidationModule,
                    PMVMiniLoadingModule,
                ],
                declarations: [
                    InputTextComponent,
                ],
                exports: [
                    InputTextComponent,
                ]
            },] },
];
/** @nocollapse */
PMVInputTextModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} object
 * @param {?} field
 * @return {?}
 */
function resolveFieldData(object, field) {
    if (object && field) {
        if (field.indexOf('.') == -1) {
            return object[field];
        }
        else {
            var /** @type {?} */ fields = field.split('.');
            var /** @type {?} */ value = object;
            for (var /** @type {?} */ i = 0, /** @type {?} */ len = fields.length; i < len; ++i) {
                value = value[fields[i]];
            }
            return value;
        }
    }
    else {
        return null;
    }
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DropdownComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DropdownComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function DropdownComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.emptyFilterMessage = 'Nenhum resultado encontrado';
        _this.onChange = new EventEmitter();
        _this.onBlur = new EventEmitter();
        _this.onFocus = new EventEmitter();
        _this.identifier = "form-dropdown-" + identifier$2++;
        return _this;
    }
    /**
     * @return {?}
     */
    DropdownComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this._options && this._options.length) {
            setTimeout(function (_) {
                if (_this.value === null || _this.value === undefined) {
                    _this.value = _this._options[0].value;
                }
            }, 0);
        }
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    DropdownComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        setTimeout(function (_) {
            if (changes && changes["options"] && changes["options"].currentValue) {
                _this._options = _this.options.map(function (option) {
                    return {
                        label: _this.optionLabelField ? resolveFieldData(option, _this.optionLabelField) : option,
                        value: _this.optionValueField ? resolveFieldData(option, _this.optionValueField) : option,
                    };
                });
                if (_this._options.length && _this.defaultOption) {
                    _this._options.unshift({ label: _this.defaultOption, value: null });
                }
            }
        }, 100);
    };
    /**
     * Dispara um evento quando o dropdown é alterado.
     *
     * @param {?} event evento contendo o novo valor do dropdown
     * @return {?}
     */
    DropdownComponent.prototype.changeEvent = function (event) {
        this.onChange.emit({ selectedOption: event.value });
    };
    /**
     * Dispara um evento quando o dropdown perde o foco.
     * @param {?} event
     * @return {?}
     */
    DropdownComponent.prototype.blurEvent = function (event) {
        this.onBlur.emit(event);
    };
    /**
     * @return {?}
     */
    DropdownComponent.prototype.focusEvent = function () {
        this.onFocus.emit({});
    };
    return DropdownComponent;
}(ElementBase));
DropdownComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-dropdown',
                template: "<div>\n  <label *ngIf=\"label\" [attr.for]=\"identifier\">\n    {{label}}\n    <pmv-mini-loading [isLoading]=\"isLoading\"></pmv-mini-loading>\n  </label>\n  <p-dropdown [options]=\"_options\" [(ngModel)]=\"value\" styleClass=\"form-control\" [id]=\"identifier\" [disabled]=\"disabled || !_options || !_options.length\"\n    [filter]=\"filter\" (onChange)=\"changeEvent($event)\" (onBlur)=\"blurEvent($event)\" (onFocus)=\"focusEvent()\" [emptyFilterMessage]=\"emptyFilterMessage\"></p-dropdown>\n  <validation [elementBase]=\"this\"></validation>\n</div>\n",
                styles: [":host /deep/ .form-control{\n  width:100% !important; }\n:host /deep/ .ui-dropdown .ui-dropdown-label{\n  font-family:\"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size:14px; }\n:host /deep/ .ui-dropdown .ui-dropdown-label-empty{\n  color:transparent; }\n:host /deep/ .ui-state-highlight{\n  background-color:#002146;\n  color:#ffffff !important; }\n:host /deep/ li:hover{\n  background-color:#0275d8;\n  color:#ffffff !important; }\n:host /deep/ .ui-dropdown-panel .ui-dropdown-filter-container .fa{\n  padding-top:4px; }\n:host /deep/ input{\n  width:100% !important;\n  display:block;\n  width:100%;\n  height:34px;\n  padding:6px 12px;\n  font-size:14px;\n  line-height:1.42857143;\n  color:#555;\n  background-color:#fff;\n  background-image:none;\n  border:1px solid #ccc;\n  border-radius:4px;\n  -webkit-box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -webkit-transition:border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;\n  transition:border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;\n  transition:border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  transition:border-color ease-in-out .15s, box-shadow ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;\n  border:3px solid #ddd;\n  -webkit-box-shadow:none;\n          box-shadow:none; }\n:host /deep/ .ui-dropdown .ui-dropdown-trigger .fa{\n  margin-top:7px; }\n:host /deep/ .ui-state-disabled{\n  opacity:unset;\n  cursor:not-allowed !important;\n  background-color:#eee !important; }\n:host /deep/ .ui-widget:disabled{\n  opacity:unset;\n  cursor:not-allowed !important; }\n:host /deep/ li{\n  min-height:20px; }\n:host /deep/ p-dropdown > .ui-dropdown{\n  background-color:transparent; }\n:host /deep/ p-dropdown label{\n  position:absolute;\n  width:calc(100% - 30px) !important;\n  bottom:1px; }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: DropdownComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
DropdownComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
DropdownComponent.propDecorators = {
    "label": [{ type: Input },],
    "options": [{ type: Input },],
    "disabled": [{ type: Input },],
    "filter": [{ type: Input },],
    "optionLabelField": [{ type: Input },],
    "optionValueField": [{ type: Input },],
    "emptyFilterMessage": [{ type: Input },],
    "defaultOption": [{ type: Input },],
    "isLoading": [{ type: Input },],
    "onChange": [{ type: Output },],
    "onBlur": [{ type: Output },],
    "onFocus": [{ type: Output },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
};
var identifier$2 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVDropdownModule = /** @class */ (function () {
    function PMVDropdownModule() {
    }
    return PMVDropdownModule;
}());
PMVDropdownModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    DropdownModule,
                    PMVValidationModule,
                    PMVMiniLoadingModule,
                ],
                declarations: [
                    DropdownComponent,
                ],
                exports: [
                    DropdownComponent,
                ]
            },] },
];
/** @nocollapse */
PMVDropdownModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InputDecimalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputDecimalComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function InputDecimalComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.autocomplete = 'off';
        _this.identifier = "form-input-decimal-" + identifier$3++;
        _this.blur = new EventEmitter();
        _this.keyup = new EventEmitter();
        return _this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    InputDecimalComponent.prototype.correctNaN = function (value) {
        var _this = this;
        if (isNaN(value)) {
            setTimeout(function (_) {
                _this.value = null;
            }, 0);
        }
    };
    return InputDecimalComponent;
}(ElementBase));
InputDecimalComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-input-decimal',
                template: "<div>\n  <label *ngIf=\"label\" [attr.for]=\"identifier\">{{label}}</label>\n  <input [maxlength]=\"tamanhoMaximo\" currencyMask [(ngModel)]=\"value\" [id]=\"identifier\" [readonly]=\"readonly\" [disabled]=\"disabled\"\n    [(ngModel)]=\"value\" [options]=\"options\" [type]=\"type\" [placeholder]=\"placeholder || ''\" [ngClass]=\"{'form-control': true, invalid: (invalid | async)}\"\n    (ngModelChange)=\"correctNaN($event)\" (blur)=\"blur.emit($event)\" (keyup)=\"keyup.emit($event)\" [autocomplete]=\"autocomplete\"\n  />\n  <validation [elementBase]=\"this\"></validation>\n</div>\n",
                styles: [":host /deep/ .form-control{\n  width:100% !important; }\n:host /deep/ .ui-dropdown .ui-dropdown-label{\n  font-family:\"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size:14px; }\n:host /deep/ .ui-dropdown .ui-dropdown-label-empty{\n  color:#fff; }\n:host /deep/ .ui-state-highlight{\n  background-color:#002146;\n  color:#ffffff !important;\n  font-family:\"Helvetica Neue\", Helvetica, Arial, sans-serif; }\n:host /deep/ li:hover{\n  background-color:#0275d8;\n  color:#ffffff !important;\n  font-family:\"Helvetica Neue\", Helvetica, Arial, sans-serif; }\n:host /deep/ .ui-dropdown-panel .ui-dropdown-filter-container .fa{\n  padding-top:4px; }\n:host /deep/ input{\n  width:100% !important;\n  display:block;\n  width:100%;\n  height:34px;\n  padding:6px 12px;\n  font-size:14px;\n  line-height:1.42857143;\n  color:#555;\n  background-color:#fff;\n  background-image:none;\n  border:1px solid #ccc;\n  border-radius:4px;\n  -webkit-box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -webkit-transition:border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;\n  transition:border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;\n  transition:border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  transition:border-color ease-in-out .15s, box-shadow ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;\n  border:3px solid #ddd;\n  -webkit-box-shadow:none;\n          box-shadow:none; }\n:host /deep/ .ui-dropdown .ui-dropdown-trigger .fa{\n  margin-top:7px; }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: InputDecimalComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
InputDecimalComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
InputDecimalComponent.propDecorators = {
    "label": [{ type: Input },],
    "options": [{ type: Input },],
    "type": [{ type: Input },],
    "disabled": [{ type: Input },],
    "readonly": [{ type: Input },],
    "placeholder": [{ type: Input },],
    "tamanhoMaximo": [{ type: Input },],
    "autocomplete": [{ type: Input },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
    "blur": [{ type: Output },],
    "keyup": [{ type: Output },],
};
var identifier$3 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVInputDecimalModule = /** @class */ (function () {
    function PMVInputDecimalModule() {
    }
    return PMVInputDecimalModule;
}());
PMVInputDecimalModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    CurrencyMaskModule,
                    PMVValidationModule,
                ],
                declarations: [
                    InputDecimalComponent,
                ],
                exports: [
                    InputDecimalComponent,
                ]
            },] },
];
/** @nocollapse */
PMVInputDecimalModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DatepickerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DatepickerComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function DatepickerComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.identifier = "form-datepicker-" + identifier$4++;
        return _this;
    }
    /**
     * @return {?}
     */
    DatepickerComponent.prototype.ngOnInit = function () {
        this.config();
    };
    /**
     * @return {?}
     */
    DatepickerComponent.prototype.ngAfterViewInit = function () {
        this.configMask();
    };
    /**
     * Faz as configurações de locale para o componente.
     * @return {?}
     */
    DatepickerComponent.prototype.config = function () {
        this.pt = {
            firstDayOfWeek: 0,
            dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
            dayNamesMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Sx', 'Sa'],
            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            today: 'Hoje',
            clear: 'Limpar'
        };
    };
    /**
     * Configura a máscara associada ao input de data.
     * @param {?=} delay
     * @return {?}
     */
    DatepickerComponent.prototype.configMask = function (delay) {
        var _this = this;
        if (delay === void 0) { delay = 1000; }
        var /** @type {?} */ isJqueryMaskLoaded = function () {
            return Boolean($ && $('').mask);
        };
        var /** @type {?} */ configMask = function () {
            var /** @type {?} */ mask = '00/00/0000';
            if (_this.showTime) {
                mask += ' 00:00';
            }
            $("#" + _this.identifier).mask(mask);
        };
        if (isJqueryMaskLoaded()) {
            configMask();
        }
        else if (delay < 60000) {
            // a minute trying to config
            setTimeout(function (_) { return _this.configMask(2 * delay); }, delay);
        }
    };
    return DatepickerComponent;
}(ElementBase));
DatepickerComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-datepicker',
                template: "<div>\n  <label *ngIf=\"label\" [attr.for]=\"identifier\">{{label}}</label>\n  <p-calendar #calendar [(ngModel)]=\"value\" inputStyleClass=\"form-control\" dateFormat=\"dd/mm/yy\" [showIcon]=\"true\" [showTime]=\"showTime\"\n    [minDate]=\"minDate\" [maxDate]=\"maxDate\" [disabledDates]=\"disabledDates\" [disabledDays]=\"disabledDays\" [locale]=\"pt\" hourFormat=\"24\"\n    [readonlyInput]=\"readonlyInput\" [disabled]=\"disabled\" [inputId]=\"identifier\"></p-calendar>\n  <validation [elementBase]=\"this\"></validation>\n</div>\n",
                styles: [":host /deep/ button{\n  right:-1px;\n  top:0px;\n  background-color:#002146;\n  color:#fff;\n  border:2px solid #cacaca;\n  border-radius:2px; }\n:host /deep/ .ui-calendar{\n  display:block; }\n:host /deep/ .ui-datepicker{\n  background-color:#f6f8fa; }\n:host /deep/ .ui-widget-header{\n  background:#f6f7f9 0 0 repeat-x;\n  background:-webkit-gradient(linear, left top, left bottom, from(#dedede), to(#ebedf0));\n  background:linear-gradient(to bottom, #dedede 0%, #ebedf0 100%); }\n:host /deep/ .ui-state-disabled{\n  cursor:no-drop !important; }\n:host /deep/ .ui-state-disabled a{\n  cursor:no-drop !important; }\n:host /deep/ .ui-datepicker-calendar .ui-state-active{\n  background-color:#002146; }\n:host /deep/ input.ui-state-disabled{\n  opacity:unset;\n  cursor:not-allowed !important;\n  background-color:#eee; }\n:host /deep/ input.ui-widget:disabled{\n  opacity:unset;\n  cursor:not-allowed !important; }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: DatepickerComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
DatepickerComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
DatepickerComponent.propDecorators = {
    "label": [{ type: Input },],
    "disabled": [{ type: Input },],
    "showTime": [{ type: Input },],
    "minDate": [{ type: Input },],
    "maxDate": [{ type: Input },],
    "disabledDates": [{ type: Input },],
    "disabledDays": [{ type: Input },],
    "showButtonBar": [{ type: Input },],
    "readonlyInput": [{ type: Input },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
    "calendar": [{ type: ViewChild, args: ['calendar',] },],
};
var identifier$4 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVDatepickerModule = /** @class */ (function () {
    function PMVDatepickerModule() {
    }
    return PMVDatepickerModule;
}());
PMVDatepickerModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    CalendarModule,
                    PMVValidationModule,
                ],
                declarations: [
                    DatepickerComponent,
                ],
                exports: [
                    DatepickerComponent,
                ]
            },] },
];
/** @nocollapse */
PMVDatepickerModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVDatatableModule = /** @class */ (function () {
    function PMVDatatableModule() {
    }
    return PMVDatatableModule;
}());
PMVDatatableModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    TableModule,
                    TooltipModule,
                    PMVInputSearchModule,
                    PMVInputTextModule,
                    PMVDropdownModule,
                    PMVInputDecimalModule,
                    PMVDatepickerModule
                ],
                declarations: [
                    DatatableComponent,
                ],
                exports: [
                    DatatableComponent,
                ]
            },] },
];
/** @nocollapse */
PMVDatatableModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DateUtils = /** @class */ (function () {
    function DateUtils() {
    }
    /**
     * Converte uma data do tipo Date para uma string do tipo dd/mm/yyyy.
     *
     * @param {?} date data
     * @param {?=} separator
     * @return {?}
     */
    DateUtils.prototype.dateToString = function (date, separator) {
        return [
            ('0' + date.getDate()).slice(-2),
            ('0' + (date.getMonth() + 1)).slice(-2),
            date.getFullYear()
        ].join(separator || '/');
    };
    /**
     * @param {?} date
     * @return {?}
     */
    DateUtils.prototype.dateToStringBackend = function (date) {
        return [
            ('0' + (date.getMonth() + 1)).slice(-2),
            ('0' + date.getDate()).slice(-2),
            date.getFullYear()
        ].join('-');
    };
    return DateUtils;
}());
DateUtils.decorators = [
    { type: Injectable },
];
/** @nocollapse */
DateUtils.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var FileExportService = /** @class */ (function () {
    /**
     * @param {?} papaParseService
     * @param {?} dateUtils
     */
    function FileExportService(papaParseService, dateUtils) {
        this.papaParseService = papaParseService;
        this.dateUtils = dateUtils;
    }
    /**
     * Exporta um array de objetos para um arquivo CSV.
     *
     * @param {?} data array de objetos
     * @param {?=} filename
     * @return {?}
     */
    FileExportService.prototype.exportCsv = function (data, filename) {
        var /** @type {?} */ config = {
            delimiter: ';',
        };
        var /** @type {?} */ stringData = this.papaParseService.unparse(data, config);
        var /** @type {?} */ blob = new Blob(stringData.split('\n'), { type: 'text/csv;charset=utf-8' });
        saveAs(blob, (filename || 'pmv') + "-" + this.dateUtils.dateToString(new Date()) + ".csv");
    };
    return FileExportService;
}());
FileExportService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
FileExportService.ctorParameters = function () { return [
    { type: PapaParseService, },
    { type: DateUtils, },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var FileExportComponent = /** @class */ (function () {
    /**
     * @param {?} fileExportService
     */
    function FileExportComponent(fileExportService) {
        this.fileExportService = fileExportService;
    }
    /**
     * @return {?}
     */
    FileExportComponent.prototype.ngOnInit = function () {
        switch (this.type) {
            case 'csv':
                this.title = 'Exportar CSV';
                break;
            default:
                this.title = 'Exportar';
        }
    };
    /**
     * Método para exportar o arquivo.
     * @return {?}
     */
    FileExportComponent.prototype.exportToFile = function () {
        switch (this.type) {
            case 'csv':
                this.fileExportService.exportCsv(this.objects, this.filename);
                break;
            default:
        }
    };
    return FileExportComponent;
}());
FileExportComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-file-export',
                template: "<button type=\"button\" class=\"btn btn-default\" (click)=\"exportToFile()\">\n  <span class=\"glyphicon glyphicon-download\"></span> {{ title }}\n</button>\n",
                styles: [":host /deep/ .ui-widget-content{\n  border:1px solid #c7c7c7; }\n"]
            },] },
];
/** @nocollapse */
FileExportComponent.ctorParameters = function () { return [
    { type: FileExportService, },
]; };
FileExportComponent.propDecorators = {
    "objects": [{ type: Input },],
    "filename": [{ type: Input },],
    "type": [{ type: Input },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVFileExportModule = /** @class */ (function () {
    function PMVFileExportModule() {
    }
    /**
     * @return {?}
     */
    PMVFileExportModule.forRoot = function () {
        return {
            ngModule: PMVFileExportModule,
            providers: [
                FileExportService,
            ]
        };
    };
    return PMVFileExportModule;
}());
PMVFileExportModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    PapaParseModule,
                ],
                declarations: [
                    FileExportComponent,
                ],
                exports: [
                    FileExportComponent,
                ]
            },] },
];
/** @nocollapse */
PMVFileExportModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var LoadingComponent = /** @class */ (function () {
    function LoadingComponent() {
        this.defaultSize = 55;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    LoadingComponent.prototype.ngOnChanges = function (changes) {
        this.size = this.defaultSize + "px";
        if (changes["sizeMultiplier"]) {
            this.size = this.sizeMultiplier
                ? this.defaultSize * this.sizeMultiplier + "px"
                : this.defaultSize + "px";
        }
    };
    return LoadingComponent;
}());
LoadingComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-loading',
                template: "<div class=\"loading-container\" [class.hidden]=\"!isLoading\">\n  <div class=\"loading\" [style.width]=\"size\" [style.height]=\"size\"></div>\n</div>\n",
                styles: [".loading-container{\n  width:100%;\n  text-align:center; }\n.loading{\n  border:16px solid #EEEEEE;\n  border-top:16px solid #0F86C6;\n  border-radius:50%;\n  width:55px;\n  height:55px;\n  margin-left:auto;\n  margin-right:15px;\n  -webkit-animation:spin 2s linear infinite;\n          animation:spin 2s linear infinite; }\n@-webkit-keyframes spin{\n  from{\n    -webkit-transform:rotate(0deg);\n            transform:rotate(0deg); }\n  to{\n    -webkit-transform:rotate(360deg);\n            transform:rotate(360deg); } }\n@keyframes spin{\n  from{\n    -webkit-transform:rotate(0deg);\n            transform:rotate(0deg); }\n  to{\n    -webkit-transform:rotate(360deg);\n            transform:rotate(360deg); } }\n"],
            },] },
];
/** @nocollapse */
LoadingComponent.ctorParameters = function () { return []; };
LoadingComponent.propDecorators = {
    "isLoading": [{ type: Input },],
    "sizeMultiplier": [{ type: Input },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVLoadingModule = /** @class */ (function () {
    function PMVLoadingModule() {
    }
    return PMVLoadingModule;
}());
PMVLoadingModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                ],
                declarations: [
                    LoadingComponent,
                ],
                exports: [
                    LoadingComponent,
                ],
            },] },
];
/** @nocollapse */
PMVLoadingModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ModalComponent = /** @class */ (function () {
    function ModalComponent() {
        this.width = 300;
        this.closable = true;
        this.dismissableMask = true;
        this.show = new EventEmitter();
        this.hide = new EventEmitter();
        this.visibleChange = new EventEmitter();
    }
    Object.defineProperty(ModalComponent.prototype, "visible", {
        /**
         * @return {?}
         */
        get: function () { return this._visible; },
        /**
         * @param {?} visible
         * @return {?}
         */
        set: function (visible) {
            if (this._visible !== visible) {
                this._visible = visible;
                this.visibleChange.emit(visible);
            }
        },
        enumerable: true,
        configurable: true
    });
    return ModalComponent;
}());
ModalComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-modal',
                template: "<p-dialog [(visible)]=\"visible\" [width]=\"width\" [closable]=\"closable\" [contentStyle]=\"contentStyle\" [draggable]=\"false\" [resizable]=\"false\"\n  [modal]=\"true\" [dismissableMask]=\"dismissableMask\" (onShow)=\"show.emit()\" (onHide)=\"hide.emit()\" [positionTop]=\"positionTop\">\n  <p-header>\n    {{ header }}\n  </p-header>\n  <ng-content></ng-content>\n  <p-footer>\n    <ng-content select=\"[pmv-footer]\"></ng-content>\n  </p-footer>\n</p-dialog>\n",
                styles: [":host /deep/ .ui-dialog-titlebar{\n  border-bottom:1px solid #cacaca; }\n:host /deep/ .ui-dialog-titlebar .ui-dialog-title{\n  font-size:1.5em; }\n:host /deep/ .ui-dialog-footer{\n  border-left:none;\n  border-right:none;\n  border-bottom:none;\n  padding:10px 5px; }\np-footer /deep/ button:focus{\n  -webkit-box-shadow:none !important;\n          box-shadow:none !important; }\n"],
            },] },
];
/** @nocollapse */
ModalComponent.ctorParameters = function () { return []; };
ModalComponent.propDecorators = {
    "header": [{ type: Input },],
    "width": [{ type: Input },],
    "contentStyle": [{ type: Input },],
    "closable": [{ type: Input },],
    "positionTop": [{ type: Input },],
    "dismissableMask": [{ type: Input },],
    "show": [{ type: Output },],
    "hide": [{ type: Output },],
    "footer": [{ type: ViewChild, args: ['footer',] },],
    "visible": [{ type: Input },],
    "visibleChange": [{ type: Output },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVModalModule = /** @class */ (function () {
    function PMVModalModule() {
    }
    return PMVModalModule;
}());
PMVModalModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    DialogModule,
                ],
                declarations: [
                    ModalComponent,
                ],
                exports: [
                    ModalComponent,
                ],
            },] },
];
/** @nocollapse */
PMVModalModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {number} */
var NotificationType = {
    error: 1,
    success: 2,
    warning: 3,
    info: 4,
};
NotificationType[NotificationType.error] = "error";
NotificationType[NotificationType.success] = "success";
NotificationType[NotificationType.warning] = "warning";
NotificationType[NotificationType.info] = "info";
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Notification = /** @class */ (function () {
    /**
     * @param {?} message
     * @param {?} type
     * @param {?} time
     */
    function Notification(message, type, time) {
        this.message = message;
        this.type = type;
        this.time = time;
        this.cssClass = "alert-" + NotificationType[type];
        switch (type) {
            case NotificationType.success:
                this.icon = 'glyphicon glyphicon-ok-sign';
                this.srOnlyText = 'Sucesso:';
                this.cssClass = 'alert-success';
                break;
            case NotificationType.error:
                this.icon = 'glyphicon glyphicon-remove-sign';
                this.srOnlyText = 'Erro:';
                this.cssClass = 'alert-danger';
                break;
            case NotificationType.warning:
                this.icon = 'glyphicon glyphicon-exclamation-sign';
                this.srOnlyText = 'Atenção:';
                this.cssClass = 'alert-warning';
                break;
            case NotificationType.info:
                this.icon = 'glyphicon glyphicon-info-sign';
                this.srOnlyText = 'Aviso:';
                this.cssClass = 'alert-info';
                break;
        }
    }
    return Notification;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Serviço de notificações do sistema.
 */
var NotificationService = /** @class */ (function () {
    function NotificationService() {
        this.notifier = new Subject();
    }
    /**
     * Exibe uma notificação no sistema.
     *
     * @param {?} message texto da mensagem a ser exibida
     * @param {?} type tipo da mensagem a ser exibida
     * @param {?=} time tempo que a mensagem deve ser exibida na tela até que seja fechada automaticamente
     * @return {?}
     */
    NotificationService.prototype.notify = function (message, type, time) {
        this.notifier.next(new Notification(message, type, time));
    };
    /**
     * Exibe uma notificação de sucesso no sistema.
     *
     * @param {?} message texto da mensagem a ser exibida
     * @param {?=} time tempo que a mensagem deve ser exibida na tela até que seja fechada automaticamente
     * @return {?}
     */
    NotificationService.prototype.notifySuccess = function (message, time) {
        this.notify(message, NotificationType.success, time);
    };
    /**
     * Exibe uma notificação de erro no sistema.
     *
     * @param {?} message texto da mensagem a ser exibida
     * @param {?=} time tempo que a mensagem deve ser exibida na tela até que seja fechada automaticamente
     * @return {?}
     */
    NotificationService.prototype.notifyError = function (message, time) {
        this.notify(message, NotificationType.error, time);
    };
    /**
     * Exibe uma notificação de alerta no sistema.
     *
     * @param {?} message texto da mensagem a ser exibida
     * @param {?=} time tempo que a mensagem deve ser exibida na tela até que seja fechada automaticamente
     * @return {?}
     */
    NotificationService.prototype.notifyWarning = function (message, time) {
        this.notify(message, NotificationType.warning, time);
    };
    /**
     * Exibe uma notificação de informação no sistema.
     *
     * @param {?} message texto da mensagem a ser exibida
     * @param {?=} time tempo que a mensagem deve ser exibida na tela até que seja fechada automaticamente
     * @return {?}
     */
    NotificationService.prototype.notifyInfo = function (message, time) {
        this.notify(message, NotificationType.info, time);
    };
    /**
     * Recupera o Observable que coordena as mensagens enviadas no sistema.
     *
     * @return {?} um Observable que avisa aos subscribers sempre que uma nova notificação é enviada no sistema
     */
    NotificationService.prototype.listen = function () {
        return this.notifier.asObservable();
    };
    return NotificationService;
}());
NotificationService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
NotificationService.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SnackbarComponent = /** @class */ (function () {
    /**
     * @param {?} notificationService
     * @param {?} cdr
     */
    function SnackbarComponent(notificationService, cdr) {
        this.notificationService = notificationService;
        this.cdr = cdr;
        this.notifications = [];
    }
    /**
     * @return {?}
     */
    SnackbarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.notificationService.listen().subscribe(function (notification) {
            _this.notifications = tslib_1.__spread(_this.notifications, [notification]);
            setTimeout(function (_) {
                _this.closeNotification(notification);
            }, notification.time || 3000);
            _this.cdr.detectChanges();
        });
    };
    /**
     * Fecha uma notificação do sistema.
     *
     * @param {?} notification notificação a ser fechada
     * @return {?}
     */
    SnackbarComponent.prototype.closeNotification = function (notification) {
        var /** @type {?} */ index = this.notifications.indexOf(notification);
        if (index !== -1) {
            this.notifications = this.notifications.filter(function (n, i) { return i !== index; });
        }
        this.cdr.detectChanges();
    };
    return SnackbarComponent;
}());
SnackbarComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-snackbar',
                template: "<div class=\"snackbar-container\">\n  <div class=\"snackbar\" *ngFor=\"let notification of notifications\">\n    <div role=\"alert\" class=\"alert alert-dismissible fade in\" [ngClass]=\"notification.cssClass\">\n      <button aria-label=\"Close\" class=\"close\" type=\"button\" (click)=\"closeNotification(notification)\">\n        <span aria-hidden=\"true\">\u00D7</span>\n      </button>\n      <span [ngClass]=\"notification.icon\" aria-hidden=\"true\"></span>\n      <span class=\"sr-only\">{{ notification.srOnlyText }}</span>\n      <strong>{{ notification.message }}</strong>\n    </div>\n  </div>\n</div>\n",
                styles: [".snackbar-container{\n  position:fixed;\n  z-index:9999;\n  left:50%;\n  -webkit-transform:translateX(-50%);\n          transform:translateX(-50%);\n  bottom:60px; }\n.snackbar{\n  text-align:center;\n  max-width:500px;\n  min-width:250px; }\n.snackbar .alert .glyphicon{\n  margin-right:10px; }\n"],
            },] },
];
/** @nocollapse */
SnackbarComponent.ctorParameters = function () { return [
    { type: NotificationService, },
    { type: ChangeDetectorRef, },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVSnackbarModule = /** @class */ (function () {
    function PMVSnackbarModule() {
    }
    /**
     * @return {?}
     */
    PMVSnackbarModule.forRoot = function () {
        return {
            ngModule: PMVSnackbarModule,
            providers: [
                NotificationService,
            ]
        };
    };
    return PMVSnackbarModule;
}());
PMVSnackbarModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                ],
                declarations: [
                    SnackbarComponent,
                ],
                exports: [
                    SnackbarComponent,
                ],
            },] },
];
/** @nocollapse */
PMVSnackbarModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TextareaComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TextareaComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function TextareaComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.rows = 5;
        _this.identifier = "form-input-text-" + identifier$5++;
        return _this;
    }
    return TextareaComponent;
}(ElementBase));
TextareaComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-textarea',
                template: "<div>\n  <label *ngIf=\"label\" [attr.for]=\"identifier\">{{label}}</label>\n  <textarea #inputtextarea [rows]=\"rows\" [(ngModel)]=\"value\" [placeholder]=\"placeholder || ''\" [ngClass]=\"{'form-control': true, invalid: (invalid | async), 'no-resize': noResize}\"\n    [id]=\"identifier\" [disabled]=\"disabled\" [readonly]=\"readonly\"></textarea>\n  <validation [elementBase]=\"this\"></validation>\n</div>\n",
                styles: [".no-resize{\n  resize:none; }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: TextareaComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
TextareaComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
TextareaComponent.propDecorators = {
    "label": [{ type: Input },],
    "placeholder": [{ type: Input },],
    "disabled": [{ type: Input },],
    "readonly": [{ type: Input },],
    "rows": [{ type: Input },],
    "noResize": [{ type: Input },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
    "inputtextarea": [{ type: ViewChild, args: ['inputtextarea',] },],
};
var identifier$5 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVTextareaModule = /** @class */ (function () {
    function PMVTextareaModule() {
    }
    return PMVTextareaModule;
}());
PMVTextareaModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    PMVValidationModule,
                ],
                declarations: [
                    TextareaComponent,
                ],
                exports: [
                    TextareaComponent,
                ],
            },] },
];
/** @nocollapse */
PMVTextareaModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var AutocompleteComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AutocompleteComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function AutocompleteComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.forceSelection = true;
        _this.dataKey = 'id';
        _this.complete = new EventEmitter();
        _this.select = new EventEmitter();
        _this.keyUp = new EventEmitter();
        _this.identifier = "form-autocomplete-" + identifier$6++;
        return _this;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    AutocompleteComponent.prototype.completeMethod = function (event) {
        this.complete.emit(event.query);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AutocompleteComponent.prototype.clear = function (event) {
        this.value = null;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AutocompleteComponent.prototype.selectMethod = function (value) {
        this.select.emit(value);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AutocompleteComponent.prototype.keyUpMethod = function (event) {
        this.keyUp.emit(event);
    };
    return AutocompleteComponent;
}(ElementBase));
AutocompleteComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-autocomplete',
                template: "<div>\n  <label *ngIf=\"label\" [attr.for]=\"identifier\">{{label}}</label>\n  <p-autoComplete #primecomplete [(ngModel)]=\"value\" [suggestions]=\"suggestions\" (completeMethod)=\"completeMethod($event)\"\n    [dataKey]=\"dataKey\"\n    [inputId]=\"identifier\"\n    [field]=\"field || ''\"\n    [placeholder]=\"placeholder || ''\"\n    [inputStyleClass]=\"multiple ? '' : 'form-control'\"\n    [dropdown]=\"dropdown\"\n    [disabled]=\"disabled\"\n    [readonly]=\"readonly\"\n    [multiple]=\"multiple\"\n    [forceSelection]=\"forceSelection && !multiple\"\n    (onClear)=\"clear($event)\"\n    (onSelect)=\"selectMethod($event)\"\n    (onKeyUp)=\"keyUpMethod($event)\"\n  ></p-autoComplete>\n  <validation [elementBase]=\"this\"></validation>\n</div>\n",
                styles: [":host /deep/ .ui-autocomplete{\n  width:100%; }\n:host /deep/ .ui-autocomplete-items .ui-state-highlight{\n  color:#fff; }\n:host /deep/ .ui-state-disabled{\n  opacity:unset;\n  cursor:not-allowed !important; }\n:host /deep/ .ui-widget:disabled{\n  opacity:unset;\n  cursor:not-allowed !important; }\n:host /deep/ .ui-autocomplete.ui-autocomplete-multiple{\n  width:100%; }\n  :host /deep/ .ui-autocomplete.ui-autocomplete-multiple .ui-autocomplete-multiple-container{\n    width:100%;\n    border:3px solid #ddd;\n    background-color:#fff; }\n    :host /deep/ .ui-autocomplete.ui-autocomplete-multiple .ui-autocomplete-multiple-container.ui-state-focus{\n      border-color:#66afe9; }\n  :host /deep/ .ui-autocomplete.ui-autocomplete-multiple .ui-autocomplete-token.ui-state-highlight{\n    color:#fff;\n    font-size:0.9em; }\n  :host /deep/ .ui-autocomplete.ui-autocomplete-multiple .ui-autocomplete-token-label{\n    margin-right:1.25em; }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: AutocompleteComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
AutocompleteComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
AutocompleteComponent.propDecorators = {
    "suggestions": [{ type: Input },],
    "dropdown": [{ type: Input },],
    "field": [{ type: Input },],
    "label": [{ type: Input },],
    "placeholder": [{ type: Input },],
    "disabled": [{ type: Input },],
    "readonly": [{ type: Input },],
    "forceSelection": [{ type: Input },],
    "multiple": [{ type: Input },],
    "dataKey": [{ type: Input },],
    "complete": [{ type: Output },],
    "select": [{ type: Output },],
    "keyUp": [{ type: Output },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
    "primecomplete": [{ type: ViewChild, args: ["primecomplete",] },],
};
var identifier$6 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVAutocompleteModule = /** @class */ (function () {
    function PMVAutocompleteModule() {
    }
    return PMVAutocompleteModule;
}());
PMVAutocompleteModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    AutoCompleteModule,
                    PMVValidationModule,
                ],
                declarations: [
                    AutocompleteComponent,
                ],
                exports: [
                    AutocompleteComponent,
                ]
            },] },
];
/** @nocollapse */
PMVAutocompleteModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var CheckboxComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CheckboxComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function CheckboxComponent(validators, asyncValidators, ngForm) {
        return _super.call(this, validators, asyncValidators, ngForm) || this;
    }
    /**
     * Trata o evento de seleção de uma opção na lista dos checkbox.
     *
     * @param {?} option opção selecionada ou desselecionada
     * @return {?}
     */
    CheckboxComponent.prototype.selectOption = function (option) {
        if (!this.value) {
            this.value = [];
        }
        var /** @type {?} */ index = this.value.indexOf(option.value);
        if (index !== -1) {
            this.value.splice(index, 1);
        }
        else {
            this.value.push(option.value);
        }
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    CheckboxComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes && changes["options"] && changes["options"].currentValue) {
            this._options = this.options.map(function (option) {
                return {
                    label: _this.optionLabelField ? option[_this.optionLabelField] : option,
                    value: _this.optionValueField ? option[_this.optionValueField] : option,
                };
            });
            if (this.defaultOption) {
                this._options.unshift({ label: this.defaultOption, value: null });
            }
        }
    };
    return CheckboxComponent;
}(ElementBase));
CheckboxComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-checkbox',
                template: "<pmv-fieldset [header]=\"header\" *ngIf=\"header; else nofieldset\">\n  <ng-container *ngTemplateOutlet=\"checkbox\"></ng-container>\n</pmv-fieldset>\n<ng-template #nofieldset>\n  <ng-container *ngTemplateOutlet=\"checkbox\"></ng-container>\n</ng-template>\n<ng-template #checkbox>\n  <label *ngFor=\"let option of _options\" class=\"checkbox-inline\">\n    <input type=\"checkbox\" [value]=\"option.value\" (click)=\"selectOption(option)\" [disabled]=\"disabled\" /> {{ option.label }}\n  </label>\n</ng-template>\n",
                styles: [":host /deep/ fieldset{\n  padding:0px 6px 9px 8px !important; }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: CheckboxComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
CheckboxComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
CheckboxComponent.propDecorators = {
    "options": [{ type: Input },],
    "header": [{ type: Input },],
    "disabled": [{ type: Input },],
    "optionLabelField": [{ type: Input },],
    "optionValueField": [{ type: Input },],
    "defaultOption": [{ type: Input },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVCheckboxModule = /** @class */ (function () {
    function PMVCheckboxModule() {
    }
    return PMVCheckboxModule;
}());
PMVCheckboxModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    PMVFieldsetModule
                ],
                declarations: [
                    CheckboxComponent,
                ],
                exports: [
                    CheckboxComponent,
                ]
            },] },
];
/** @nocollapse */
PMVCheckboxModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DateIntervalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DateIntervalComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function DateIntervalComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.identifier = "form-dateinterval-" + identifier$7++;
        _this.value = [null, null];
        return _this;
    }
    /**
     * @return {?}
     */
    DateIntervalComponent.prototype.ngOnInit = function () {
        this.config();
    };
    /**
     * @return {?}
     */
    DateIntervalComponent.prototype.ngAfterViewInit = function () {
        this.configMask();
    };
    Object.defineProperty(DateIntervalComponent.prototype, "dataInicial", {
        /**
         * @return {?}
         */
        get: function () {
            return this.value && this.value[0];
        },
        /**
         * @param {?} data
         * @return {?}
         */
        set: function (data) {
            if (this.value) {
                if (!data) {
                    this.dataFinal = null;
                }
                this.value[0] = data;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateIntervalComponent.prototype, "dataFinal", {
        /**
         * @return {?}
         */
        get: function () {
            return this.value && this.value[1];
        },
        /**
         * @param {?} data
         * @return {?}
         */
        set: function (data) {
            if (this.value) {
                this.value[1] = data;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Evento de seleção da data inicial.
     *
     * @param {?} event data selecionada
     * @return {?}
     */
    DateIntervalComponent.prototype.onSelectInitial = function (event) {
        this.dataInicial = event;
    };
    /**
     * Evento de seleção da data final.
     *
     * @param {?} event data selecionada
     * @return {?}
     */
    DateIntervalComponent.prototype.onSelectFinal = function (event) {
        this.dataFinal = event;
    };
    /**
     * Faz as configurações de locale para o componente.
     * @return {?}
     */
    DateIntervalComponent.prototype.config = function () {
        this.pt = {
            firstDayOfWeek: 0,
            dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
            dayNamesMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Sx', 'Sa'],
            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            today: 'Hoje',
            clear: 'Limpar'
        };
    };
    /**
     * Configura a máscara associada ao input de data.
     * @param {?=} delay
     * @return {?}
     */
    DateIntervalComponent.prototype.configMask = function (delay) {
        var _this = this;
        if (delay === void 0) { delay = 1000; }
        var /** @type {?} */ isJqueryMaskLoaded = function () {
            return Boolean($ && $('').mask);
        };
        var /** @type {?} */ configMask = function () {
            var /** @type {?} */ mask = '00/00/0000';
            if (_this.showTime) {
                mask += ' 00:00';
            }
            $("#" + _this.identifier + "i").mask(mask);
            $("#" + _this.identifier + "f").mask(mask);
        };
        if (isJqueryMaskLoaded()) {
            configMask();
        }
        else {
            setTimeout(function (_) { return _this.configMask(2 * delay); }, delay);
        }
    };
    return DateIntervalComponent;
}(ElementBase));
DateIntervalComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-date-interval',
                template: "<pmv-fieldset [header]=\"header\" *ngIf=\"header; else nofieldset\">\n  <ng-container *ngTemplateOutlet=\"dateInterval\"></ng-container>\n</pmv-fieldset>\n<ng-template #nofieldset>\n  <ng-container *ngTemplateOutlet=\"dateInterval\"></ng-container>\n</ng-template>\n<ng-template #dateInterval>\n  <div class=\"date-interval\">\n    <label *ngIf=\"label\">{{ label }}</label>\n    <p-calendar #initialDate [(ngModel)]=\"dataInicial\" inputStyleClass=\"form-control\" dateFormat=\"dd/mm/yy\" [showIcon]=\"false\"\n      [minDate]=\"minDate\" [maxDate]=\"value && value.length == 2 ? value[1] : ''\" [disabledDates]=\"disabledDates\" [disabledDays]=\"disabledDays\"\n      [locale]=\"pt\" hourFormat=\"24\" (onSelect)=\"onSelectInitial($event)\" [disabled]=\"disabled\" [inputId]=\"identifier + 'i'\"></p-calendar>\n    a\n    <p-calendar #finalDate [(ngModel)]=\"dataFinal\" inputStyleClass=\"form-control\" dateFormat=\"dd/mm/yy\" [showIcon]=\"false\" [minDate]=\"value && value.length == 2 ? value[0] : ''\"\n      [maxDate]=\"maxDate\" [disabledDates]=\"disabledDates\" [disabledDays]=\"disabledDays\" [locale]=\"pt\" hourFormat=\"24\" (onSelect)=\"onSelectFinal($event)\"\n      [disabled]=\"disabled || (initialRequiredForFinal && !dataInicial)\" [inputId]=\"identifier + 'f'\"></p-calendar>\n  </div>\n</ng-template>\n",
                styles: [".date-interval{\n  position:relative;\n  top:2px; }\nlabel{\n  display:block !important; }\n:host /deep/ .form-control{\n  width:206px; }\n:host /deep/ .ui-datepicker{\n  background-color:#f6f8fa; }\n:host /deep/ .ui-widget-header{\n  background:#f6f7f9 0 0 repeat-x;\n  background:-webkit-gradient(linear, left top, left bottom, from(#dedede), to(#ebedf0));\n  background:linear-gradient(to bottom, #dedede 0%, #ebedf0 100%); }\n:host /deep/ .ui-state-disabled{\n  cursor:no-drop !important; }\n:host /deep/ .ui-state-disabled a{\n  cursor:no-drop !important; }\n:host /deep/ .ui-datepicker-calendar .ui-state-active{\n  background-color:#cacaca; }\n:host /deep/ fieldset input{\n  width:70px !important;\n  padding:0px 0px 2px 2px;\n  height:27px;\n  font-size:12px; }\n:host /deep/ input{\n  width:90px !important; }\n:host /deep/ fieldset{\n  padding:0px 5px 6px 5px !important;\n  text-align:center;\n  width:174px; }\n:host /deep/ input.ui-state-disabled{\n  opacity:unset;\n  cursor:not-allowed !important;\n  background-color:#eee; }\n:host /deep/ input.ui-widget:disabled{\n  opacity:unset;\n  cursor:not-allowed !important; }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: DateIntervalComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
DateIntervalComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
DateIntervalComponent.propDecorators = {
    "header": [{ type: Input },],
    "label": [{ type: Input },],
    "disabled": [{ type: Input },],
    "showTime": [{ type: Input },],
    "minDate": [{ type: Input },],
    "maxDate": [{ type: Input },],
    "disabledDates": [{ type: Input },],
    "disabledDays": [{ type: Input },],
    "showButtonBar": [{ type: Input },],
    "initialRequiredForFinal": [{ type: Input },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
};
var identifier$7 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVDateIntervalModule = /** @class */ (function () {
    function PMVDateIntervalModule() {
    }
    return PMVDateIntervalModule;
}());
PMVDateIntervalModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    CalendarModule,
                    PMVFieldsetModule,
                ],
                declarations: [
                    DateIntervalComponent,
                ],
                exports: [
                    DateIntervalComponent,
                ]
            },] },
];
/** @nocollapse */
PMVDateIntervalModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var FileUploadComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FileUploadComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function FileUploadComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.remove = new EventEmitter();
        _this.download = new EventEmitter();
        _this.value = [];
        _this.invalidFileSizeMessage = 'Tamanho de arquivo inválido, o tamanho máximo dos arquivos é de {0}.';
        _this.invalidFileTypeMessage = 'Tipo de arquivo inválido, os tipos permitidos são: {0}.';
        return _this;
    }
    /**
     * Método chamado após selecionar arquivos.
     *
     * @param {?} event evento com a lista de arquivos
     * @return {?}
     */
    FileUploadComponent.prototype.selectFiles = function (event) {
        this.checkMaxNumberOfFiles();
    };
    /**
     * Método chamado após remover um arquivo da lista.
     *
     * @param {?} event evento com o arquivo a ser removido
     * @return {?}
     */
    FileUploadComponent.prototype.removeFile = function (event) {
        var /** @type {?} */ index = this.value.map(function (v) { return v.name; }).indexOf(event.file.name);
        if (index !== -1) {
            var /** @type {?} */ file = this.value[index];
            this.remove.emit(file);
            // a remoção do arquivo é feita dentro do componente do PrimeNG
            // this.value.splice(index, 1);
        }
    };
    /**
     * Determina se o tamanho de um arquivo está válido.
     *
     * @param {?} file arquivo a ser analisado
     * @return {?} true se o tamanho estiver válido e false caso contrário
     */
    FileUploadComponent.prototype.isFileSizeValid = function (file) {
        return !this.maxFileSize || file.size <= this.maxFileSize;
    };
    /**
     * Determina se o tipo de um arquivo está válido.
     *
     * @param {?} file arquivo a ser analisado
     * @return {?} true se o tamanho estiver válido e false caso contrário
     */
    FileUploadComponent.prototype.isFileTypeValid = function (file) {
        if (!this.accept)
            return true;
        var /** @type {?} */ acceptableTypes = this.accept.split(',');
        try {
            for (var acceptableTypes_1 = tslib_1.__values(acceptableTypes), acceptableTypes_1_1 = acceptableTypes_1.next(); !acceptableTypes_1_1.done; acceptableTypes_1_1 = acceptableTypes_1.next()) {
                var type = acceptableTypes_1_1.value;
                var /** @type {?} */ isSameFileTypeClass = this.getTypeClass(file.type) === this.getTypeClass(type);
                var /** @type {?} */ isSameFileType = file.type == type || this.getFileExtension(file).toLowerCase() === type.toLowerCase();
                var /** @type {?} */ acceptable = this.isWildcard(type) ? isSameFileTypeClass : isSameFileType;
                if (acceptable) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (acceptableTypes_1_1 && !acceptableTypes_1_1.done && (_a = acceptableTypes_1.return)) _a.call(acceptableTypes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
        var e_1, _a;
    };
    /**
     * @return {?}
     */
    FileUploadComponent.prototype.checkMaxNumberOfFiles = function () {
        var /** @type {?} */ max = Number(this.maxNumberOfFiles || 0);
        if (max) {
            var /** @type {?} */ overflowingFilesLength = this.value.filter(function (_, i) { return i >= max; }).length;
            if (overflowingFilesLength) {
                if (this.value.length > max) {
                    this.value = this.value.slice(0, -overflowingFilesLength);
                }
                this.fileUploadComponent.msgs.push({
                    severity: 'error',
                    summary: "N\u00E3o \u00E9 poss\u00EDvel enviar mais que " + max + " arquivos.",
                });
            }
            return overflowingFilesLength;
        }
        return 0;
    };
    /**
     * @param {?} fileType
     * @return {?}
     */
    FileUploadComponent.prototype.getTypeClass = function (fileType) {
        return fileType.substring(0, fileType.indexOf('/'));
    };
    /**
     * @param {?} fileType
     * @return {?}
     */
    FileUploadComponent.prototype.isWildcard = function (fileType) {
        return fileType.indexOf('*') !== -1;
    };
    /**
     * @param {?} file
     * @return {?}
     */
    FileUploadComponent.prototype.getFileExtension = function (file) {
        return '.' + file.name.split('.').pop();
    };
    /**
     * @param {?} file
     * @return {?}
     */
    FileUploadComponent.prototype.isImage = function (file) {
        return /^image\//.test(file.type);
    };
    /**
     * @param {?} file
     * @return {?}
     */
    FileUploadComponent.prototype.isPdf = function (file) {
        return file.type.indexOf('pdf') !== -1;
    };
    /**
     * @param {?} file
     * @return {?}
     */
    FileUploadComponent.prototype.fileType = function (file) {
        if (this.isImage(file))
            return 'image';
        if (this.isPdf(file))
            return 'pdf';
        return 'file';
    };
    /**
     * @param {?} bytes
     * @return {?}
     */
    FileUploadComponent.prototype.formatSize = function (bytes) {
        if (bytes == 0) {
            return '0 B';
        }
        var /** @type {?} */ k = 1000, /** @type {?} */ dm = 3, /** @type {?} */ sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'], /** @type {?} */ i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    };
    /**
     * @param {?} file
     * @return {?}
     */
    FileUploadComponent.prototype.downloadFile = function (file) {
        saveAs$1(file, file.name);
        this.download.emit(file);
    };
    /**
     * Limpa os arquivos selecionados.
     * @return {?}
     */
    FileUploadComponent.prototype.clear = function () {
        this.fileUploadComponent.clear();
    };
    return FileUploadComponent;
}(ElementBase));
FileUploadComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-file-upload',
                template: "<pmv-fieldset [header]=\"header\" *ngIf=\"header; else nofieldset\">\n  <ng-container *ngTemplateOutlet=\"fileUploadTemplate\"></ng-container>\n</pmv-fieldset>\n<ng-template #nofieldset>\n  <ng-container *ngTemplateOutlet=\"fileUploadTemplate\"></ng-container>\n</ng-template>\n<ng-template #fileUploadTemplate>\n  <div class=\"file-upload-main-container\">\n    <pmv-loading [isLoading]=\"loading\"></pmv-loading>\n    <div class=\"blocking-container\" *ngIf=\"loading\"></div>\n    <p-fileUpload chooseLabel=\"Adicionar arquivos\" customUpload=\"true\" (onRemove)=\"removeFile($event)\" (onSelect)=\"selectFiles($event)\"\n      multiple=\"multiple\" [accept]=\"accept\" [showUploadButton]=\"false\" [showCancelButton]=\"false\" [maxFileSize]=\"maxFileSize\"\n      invalidFileSizeMessageSummary=\"{0}:\" [invalidFileSizeMessageDetail]=\"invalidFileSizeMessage\" invalidFileTypeMessageSummary=\"{0}:\"\n      [invalidFileTypeMessageDetail]=\"invalidFileTypeMessage\" [files]=\"value\">\n      <ng-template pTemplate=\"file\" let-file let-i=\"index\">\n        <div class=\"file-upload-flex-container\">\n          <ng-container [ngSwitch]=\"fileType(file)\">\n            <div class=\"file-upload-preview\" *ngSwitchCase=\"'image'\">\n              <img *ngIf=\"file.objectURL\" [src]=\"file.objectURL\" width=\"50\" />\n              <span *ngIf=\"!file.objectURL\" class=\"file-icon fa fa-file-image-o\"></span>\n            </div>\n            <div class=\"file-upload-preview\" *ngSwitchCase=\"'pdf'\">\n              <span class=\"file-icon pdf-icon fa fa-file-pdf-o\"></span>\n            </div>\n            <div class=\"file-upload-preview\" *ngSwitchDefault>\n              <span class=\"file-icon fa fa-file\"></span>\n            </div>\n          </ng-container>\n          <div class=\"file-upload-name\">\n            {{ file.name }}\n          </div>\n          <div class=\"file-upload-size\" *ngIf=\"!loading || file.size\">\n            {{ fileUploadComponent.formatSize(file.size) }}\n          </div>\n          <div class=\"file-upload-remove-btn\" *ngIf=\"!showRemoveButton || showRemoveButton(file)\">\n            <span class=\"file-upload-action-icon\" (click)=\"fileUploadComponent.remove($event, i)\">\n              <span class=\"glyphicon glyphicon-trash\" pTooltip=\"Remover\" tooltipPosition=\"bottom\"></span>\n            </span>\n          </div>\n          <div class=\"file-upload-download-btn\" *ngIf=\"showDownloadButton && showDownloadButton(file)\">\n            <span class=\"file-upload-action-icon\" (click)=\"downloadFile(file)\">\n              <span class=\"glyphicon glyphicon-download-alt\" pTooltip=\"Download\" tooltipPosition=\"bottom\"></span>\n            </span>\n          </div>\n        </div>\n      </ng-template>\n    </p-fileUpload>\n  </div>\n</ng-template>\n",
                styles: [":host /deep/ .ui-fileupload-choose{\n  color:#ffffff;\n  background-color:#002146; }\n:host /deep/ button{\n  background-color:#002146;\n  border:none;\n  color:white; }\n:host /deep/ .ui-widget-header{\n  background:-webkit-gradient(linear, left top, left bottom, from(#f6f7f9), to(#ebedf0));\n  background:linear-gradient(to bottom, #f6f7f9 0%, #ebedf0 100%); }\n:host /deep/ .ui-fileupload-files{\n  display:block; }\n  :host /deep/ .ui-fileupload-files > div{\n    width:100%;\n    display:-webkit-box;\n    display:-ms-flexbox;\n    display:flex;\n    -ms-flex-wrap:wrap;\n        flex-wrap:wrap; }\n.file-upload-main-container{\n  position:relative; }\n  .file-upload-main-container .blocking-container{\n    position:absolute;\n    z-index:1;\n    width:100%;\n    height:100%;\n    background-color:#000;\n    opacity:0.3;\n    border-radius:3.5px; }\n  .file-upload-main-container /deep/ .loading-container{\n    position:absolute;\n    z-index:2;\n    top:0;\n    bottom:0;\n    display:-webkit-box;\n    display:-ms-flexbox;\n    display:flex;\n    -webkit-box-align:center;\n        -ms-flex-align:center;\n            align-items:center; }\n    .file-upload-main-container /deep/ .loading-container .loading{\n      margin-left:auto;\n      margin-right:auto;\n      border-color:transparent;\n      border-top-color:#002146; }\n.file-upload-flex-container{\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-align:center;\n      -ms-flex-align:center;\n          align-items:center;\n  margin:5px 0;\n  padding:0 10px; }\n  .file-upload-flex-container > div{\n    padding:3px 7px; }\n  .file-upload-flex-container .file-upload-preview img{\n    -webkit-box-shadow:2px 2px 6px 1px #ccc;\n            box-shadow:2px 2px 6px 1px #ccc; }\n  .file-upload-flex-container .file-upload-preview .file-icon{\n    font-size:1.2em; }\n  .file-upload-flex-container .file-upload-preview .pdf-icon{\n    color:#e6451f; }\n  .file-upload-flex-container .file-upload-name{\n    -webkit-box-flex:1;\n        -ms-flex-positive:1;\n            flex-grow:1; }\n  .file-upload-flex-container .file-upload-action-icon{\n    color:#2d699f;\n    cursor:pointer; }\n.file-upload-flex-container{\n  width:50%; }\n@media (max-width: 768px){\n  .file-upload-flex-container{\n    width:100%; } }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: FileUploadComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
FileUploadComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
FileUploadComponent.propDecorators = {
    "header": [{ type: Input },],
    "disabled": [{ type: Input },],
    "accept": [{ type: Input },],
    "maxFileSize": [{ type: Input },],
    "loading": [{ type: Input },],
    "invalidFileSizeMessage": [{ type: Input },],
    "invalidFileTypeMessage": [{ type: Input },],
    "maxNumberOfFiles": [{ type: Input },],
    "showRemoveButton": [{ type: Input },],
    "showDownloadButton": [{ type: Input },],
    "remove": [{ type: Output },],
    "download": [{ type: Output },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
    "fileUploadComponent": [{ type: ViewChild, args: [FileUpload,] },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVFileUploadModule = /** @class */ (function () {
    function PMVFileUploadModule() {
    }
    return PMVFileUploadModule;
}());
PMVFileUploadModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    FileUploadModule,
                    PMVFieldsetModule,
                    PMVModalModule,
                    PMVLoadingModule,
                    TooltipModule,
                ],
                declarations: [
                    FileUploadComponent,
                ],
                exports: [
                    FileUploadComponent,
                ]
            },] },
];
/** @nocollapse */
PMVFileUploadModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MaskComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MaskComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function MaskComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.unmask = true;
        _this.blur = new EventEmitter();
        _this.complete = new EventEmitter();
        _this.focus = new EventEmitter();
        _this.identifier = "form-mask-" + identifier$8++;
        return _this;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    MaskComponent.prototype.blurEvent = function (event) {
        // BUGFIX: https://github.com/primefaces/primeng/issues/5531
        // Este problema está sendo corrigido no PrimeNG na versão 5.2.5.
        // Solução temporária enquanto esta versão não for lançada
        if (!event.target.value) {
            this.value = '';
        }
        this.blur.emit(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MaskComponent.prototype.completeEvent = function (event) {
        this.complete.emit(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MaskComponent.prototype.focusEvent = function (event) {
        this.focus.emit(event);
    };
    /**
     * @return {?}
     */
    MaskComponent.prototype.focusFunction = function () {
        if (this.inputMask) {
            this.inputMask.inputViewChild.nativeElement.focus();
        }
    };
    return MaskComponent;
}(ElementBase));
MaskComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-mask',
                template: "<div>\n  <label *ngIf=\"label\" [attr.for]=\"identifier\">{{label}}</label>\n  <p-inputMask #inputMask [(ngModel)]=\"value\" [mask]=\"mask\" (onBlur)=\"blurEvent($event)\" (onComplete)=\"completeEvent($event)\"\n    [slotChar]=\"slotChar || '_'\" [placeholder]=\"placeholder || ''\" [disabled]=\"disabled\" [readonly]=\"readonly\" [inputId]=\"identifier\"\n    styleClass=\"form-control\" [style]=\"style\" [unmask]=\"unmask\" [autoClear]=\"autoClear\" [autoFocus]=\"autoFocus\" (onFocus)=\"focusEvent($event)\">\n  </p-inputMask>\n  <validation [elementBase]=\"this\"></validation>\n</div>\n",
                styles: [":host /deep/ .ui-state-disabled{\n  opacity:unset;\n  cursor:not-allowed !important; }\n:host /deep/ .ui-widget:disabled{\n  opacity:unset;\n  cursor:not-allowed !important; }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: MaskComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
MaskComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
MaskComponent.propDecorators = {
    "mask": [{ type: Input },],
    "slotChar": [{ type: Input },],
    "unmask": [{ type: Input },],
    "autoClear": [{ type: Input },],
    "autoFocus": [{ type: Input },],
    "fluid": [{ type: Input },],
    "label": [{ type: Input },],
    "placeholder": [{ type: Input },],
    "disabled": [{ type: Input },],
    "readonly": [{ type: Input },],
    "style": [{ type: Input },],
    "blur": [{ type: Output },],
    "complete": [{ type: Output },],
    "focus": [{ type: Output },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
    "inputMask": [{ type: ViewChild, args: ['inputMask',] },],
};
var identifier$8 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVMaskModule = /** @class */ (function () {
    function PMVMaskModule() {
    }
    return PMVMaskModule;
}());
PMVMaskModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    InputMaskModule,
                    PMVValidationModule,
                ],
                declarations: [
                    MaskComponent,
                ],
                exports: [
                    MaskComponent,
                ],
            },] },
];
/** @nocollapse */
PMVMaskModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RadioButtonComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RadioButtonComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function RadioButtonComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.identifier = "form-radio-button-" + identifier$9++;
        return _this;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    RadioButtonComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes && changes["options"] && changes["options"].currentValue) {
            this._options = this.options.map(function (option) {
                return {
                    label: _this.optionLabelField ? option[_this.optionLabelField] : option,
                    value: _this.optionValueField ? option[_this.optionValueField] : option,
                };
            });
            if (this.defaultOption) {
                this._options.unshift({ label: this.defaultOption, value: null });
            }
        }
    };
    return RadioButtonComponent;
}(ElementBase));
RadioButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-radio-button',
                template: "<pmv-fieldset [header]=\"header\" *ngIf=\"header; else nofieldset\">\n  <ng-container *ngTemplateOutlet=\"radioButton\"></ng-container>\n</pmv-fieldset>\n<ng-template #nofieldset>\n  <ng-container *ngTemplateOutlet=\"radioButton\"></ng-container>\n</ng-template>\n<ng-template #radioButton>\n  <label *ngFor=\"let option of _options\" class=\"radio-inline\">\n    <input type=\"radio\" [name]=\"identifier\" [value]=\"option.value\" [(ngModel)]=\"value\" [disabled]=\"disabled\"\n    /> {{ option.label }}\n  </label>\n  <validation [elementBase]=\"this\"></validation>\n</ng-template>\n",
                styles: [":host /deep/ fieldset{\n  padding:0px 6px 9px 8px !important; }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: RadioButtonComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
RadioButtonComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
RadioButtonComponent.propDecorators = {
    "options": [{ type: Input },],
    "header": [{ type: Input },],
    "disabled": [{ type: Input },],
    "optionLabelField": [{ type: Input },],
    "optionValueField": [{ type: Input },],
    "defaultOption": [{ type: Input },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
};
var identifier$9 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVRadioButtonModule = /** @class */ (function () {
    function PMVRadioButtonModule() {
    }
    return PMVRadioButtonModule;
}());
PMVRadioButtonModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    PMVFieldsetModule,
                    PMVValidationModule,
                ],
                declarations: [
                    RadioButtonComponent,
                ],
                exports: [
                    RadioButtonComponent,
                ]
            },] },
];
/** @nocollapse */
PMVRadioButtonModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TreeviewConfig$1 = /** @class */ (function () {
    function TreeviewConfig$1() {
        this.hasAllCheckBox = true;
        this.hasFilter = false;
        this.hasCollapseExpand = false;
        this.hideCollapseExpandIcon = false;
        this.decoupleChildFromParent = false;
        this.maxHeight = 500;
        this.canShowSelectedTree = false;
    }
    return TreeviewConfig$1;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TreeviewI18nPT = /** @class */ (function (_super) {
    tslib_1.__extends(TreeviewI18nPT, _super);
    function TreeviewI18nPT() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} selection
     * @return {?}
     */
    TreeviewI18nPT.prototype.getText = function (selection) {
        if (!selection) {
            return this.getFilterNoItemsFoundText();
        }
        if (!selection.uncheckedItems.length) {
            if (selection.checkedItems.length) {
                return selection.checkedItems.length === 1
                    ? selection.checkedItems[0].text
                    : this.getAllCheckboxText();
            }
            else {
                return this.getFilterNoItemsFoundText();
            }
        }
        switch (selection.checkedItems.length) {
            case 0:
                return 'Selecione';
            case 1:
                return selection.checkedItems[0].text;
            default:
                return selection.checkedItems.length + " op\u00E7\u00F5es selecionadas";
        }
    };
    /**
     * @param {?} selectedItems
     * @return {?}
     */
    TreeviewI18nPT.prototype.getTextForDecoupledChild = function (selectedItems) {
        if (!selectedItems) {
            return this.getFilterNoItemsFoundText();
        }
        switch (selectedItems.length) {
            case 0:
                return 'Selecione';
            case 1:
                return selectedItems[0].text;
            default:
                return selectedItems.length + " op\u00E7\u00F5es selecionadas";
        }
    };
    /**
     * @return {?}
     */
    TreeviewI18nPT.prototype.getAllCheckboxText = function () {
        return 'Todos';
    };
    /**
     * @return {?}
     */
    TreeviewI18nPT.prototype.getFilterPlaceholder = function () {
        return 'Filtro';
    };
    /**
     * @return {?}
     */
    TreeviewI18nPT.prototype.getFilterNoItemsFoundText = function () {
        return 'Nenhum item encontrado';
    };
    /**
     * @param {?} isCollapse
     * @return {?}
     */
    TreeviewI18nPT.prototype.getTooltipCollapseExpandText = function (isCollapse) {
        return isCollapse ? 'Abrir' : 'Fechar';
    };
    return TreeviewI18nPT;
}(TreeviewI18n));
TreeviewI18nPT.decorators = [
    { type: Injectable },
];
/** @nocollapse */
TreeviewI18nPT.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var TreeviewComponent = /** @class */ (function () {
    /**
     * @param {?} i18n
     * @param {?} cdr
     */
    function TreeviewComponent(i18n, cdr) {
        this.i18n = i18n;
        this.cdr = cdr;
        this.childrenField = 'children';
        this.showRootsInputs = true;
        this.showParentsInputs = true;
        this.showParentsActions = true;
        this.showCheckbox = true;
        this.showLine = false;
        this.onAction = new EventEmitter();
        this.selectedChange = new EventEmitter();
        this.valuesRelative = new Map();
        this.identifier = "form-treeview-" + identifier$10++;
    }
    Object.defineProperty(TreeviewComponent.prototype, "selected", {
        /**
         * @return {?}
         */
        get: function () { return this._selected; },
        /**
         * @param {?} selected
         * @return {?}
         */
        set: function (selected) {
            if (this._selected !== selected) {
                this._selected = selected;
                this.selectedChange.emit(selected);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    TreeviewComponent.prototype.ngOnChanges = function (changes) {
        if (changes) {
            if (changes["config"]) {
                this.setupConfig();
            }
            if (changes["items"]) {
                this.updateTreeviewItems();
            }
            else if (changes["selected"] && !changes["selected"].firstChange) {
                this.updateSelectedItems();
            }
        }
    };
    /**
     * @return {?}
     */
    TreeviewComponent.prototype.setupConfig = function () {
        this.hideCollapseExpandIcon = this.config && this.config.hideCollapseExpandIcon;
        this._config = this.config
            ? TreeviewConfig.create(this.config)
            : TreeviewConfig.create(new TreeviewConfig$1());
    };
    /**
     * @return {?}
     */
    TreeviewComponent.prototype.collapseAll = function () {
        this.labelCollapse.nativeElement.click();
    };
    /**
     * @return {?}
     */
    TreeviewComponent.prototype.updateTreeviewItems = function () {
        var _this = this;
        if (this.items) {
            var /** @type {?} */ items = this.items;
            if (!Array.isArray(items)) {
                items = [items];
            }
            this._items = items.map(function (item) { return _this.mapToTreeviewItem(item); });
            this.treeviewItemMap = this.createTreeviewItemMap(items, this._items);
            if (this.selected && this.selected.length) {
                this.updateSelectedItems();
            }
            this.cdr.markForCheck();
            this.cdr.detectChanges();
        }
    };
    /**
     * @return {?}
     */
    TreeviewComponent.prototype.updateSelectedItems = function () {
        var _this = this;
        var /** @type {?} */ updateRecursively = function (items, selectedItems) {
            if (items && selectedItems.length) {
                items.forEach(function (item) {
                    var /** @type {?} */ selectedIndex = _this.compareBy
                        ? selectedItems.findIndex(function (selectedItem) { return selectedItem[_this.compareBy] === item.value[_this.compareBy]; })
                        : selectedItems.indexOf(item.value);
                    if (selectedIndex !== -1) {
                        item.checked = true;
                        selectedItems.splice(selectedIndex, 1);
                    }
                    updateRecursively(item.children, selectedItems);
                });
            }
        };
        updateRecursively(this._items, tslib_1.__spread(this.selected));
        if (!this._config.decoupleChildFromParent) {
            this.correctAllChecked(this._items);
        }
        this.selectedTree = this.getSelectedTree(this._items);
        if (this.selectOnlyOne) {
            this.selectedRadioButton = this.selected && this.selected[0];
        }
        setTimeout(function (_) { return _this.setupDropdownTextForDecoupledChild(_this.selected); }, 0);
        this.cdr.markForCheck();
        this.cdr.detectChanges();
    };
    /**
     * @param {?} item
     * @return {?}
     */
    TreeviewComponent.prototype.mapToTreeviewItem = function (item) {
        var _this = this;
        var /** @type {?} */ children = item[this.childrenField]
            ? item[this.childrenField].map(function (child) { return _this.mapToTreeviewItem(child); })
            : null;
        this.valuesRelative.set(this.valueField ? item[this.valueField] : item, item[this.valueRelativeField] ? String(item[this.valueRelativeField]) : null);
        return new TreeviewItem({
            text: this.textField ? String(item[this.textField]) : String(item),
            value: this.valueField ? item[this.valueField] : item,
            children: children,
            checked: false,
            collapsed: this.collapsedField ? item[this.collapsedField] : this.collapsed,
        });
    };
    /**
     * @param {?} originalItems
     * @param {?} treeviewItems
     * @return {?}
     */
    TreeviewComponent.prototype.createTreeviewItemMap = function (originalItems, treeviewItems) {
        var _this = this;
        var /** @type {?} */ createMap = function (map$$1, keyPrefix, originalItems, treeviewItems) {
            if (originalItems) {
                originalItems.forEach(function (originalItem, i) {
                    var /** @type {?} */ newKey = keyPrefix + '-' + i;
                    var /** @type {?} */ treeviewItem = treeviewItems[i];
                    var /** @type {?} */ originalItemChildren = originalItem[_this.childrenField];
                    var /** @type {?} */ treeviewItemChildren = treeviewItem.children;
                    treeviewItem['key'] = newKey;
                    map$$1[newKey] = { originalItem: originalItem, treeviewItem: treeviewItem };
                    createMap(map$$1, newKey, originalItemChildren, treeviewItem.children);
                });
            }
            return map$$1;
        };
        return createMap({}, '', originalItems, treeviewItems);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    TreeviewComponent.prototype.getOriginalItem = function (item) {
        return this.treeviewItemMap[item['key']].originalItem;
    };
    /**
     * @param {?} selected
     * @return {?}
     */
    TreeviewComponent.prototype.onSelectedChange = function (selected) {
        this.selected = selected;
        if (this.dropdownTreeviewComponent) {
            this.dropdownTreeviewComponent.dropdownDirective.close();
            this.setupDropdownTextForDecoupledChild(selected);
        }
    };
    /**
     * @param {?} selected
     * @return {?}
     */
    TreeviewComponent.prototype.setupDropdownTextForDecoupledChild = function (selected) {
        var _this = this;
        if (this.dropdownTreeviewComponent && this.config.decoupleChildFromParent) {
            var /** @type {?} */ items_1 = selected.map(function (anyItem) { return TreeviewHelper.findItemInList(_this._items, anyItem); });
            this.dropdownTreeviewComponent.getText = function () { return _this.i18n.getTextForDecoupledChild(items_1); };
        }
    };
    /**
     * @param {?} item
     * @param {?} onCheckedChange
     * @param {?} onCollapseExpand
     * @return {?}
     */
    TreeviewComponent.prototype.handleLabelClick = function (item, onCheckedChange, onCollapseExpand) {
        if (!this.noInput) {
            if (this.selectOnlyOne) {
                if (!item.children) {
                    if (!this.disabled) {
                        this.selectRadioButton(item.value, onCheckedChange);
                    }
                }
                else {
                    this.handleCollapseExpand(item, onCollapseExpand);
                }
            }
            else {
                if (!this.showParentsInputs && item.children) {
                    this.handleCollapseExpand(item, onCollapseExpand);
                }
                else if (!this.disabled) {
                    item.checked = !item.checked;
                    onCheckedChange();
                }
            }
        }
        else {
            this.handleCollapseExpand(item, onCollapseExpand);
        }
    };
    /**
     * @param {?} item
     * @param {?} onCollapseExpand
     * @return {?}
     */
    TreeviewComponent.prototype.handleCollapseExpand = function (item, onCollapseExpand) {
        onCollapseExpand();
        if (this.collapsedField) {
            var /** @type {?} */ originalItem = this.getOriginalItem(item);
            originalItem[this.collapsedField] = item.collapsed;
        }
    };
    /**
     * @param {?} event
     * @param {?} onCheckedChange
     * @return {?}
     */
    TreeviewComponent.prototype.selectRadioButton = function (event, onCheckedChange) {
        var /** @type {?} */ item = TreeviewHelper.findItemInList(this._items, event);
        if (item) {
            this.uncheckAll(this._items);
            item.checked = true;
            onCheckedChange();
        }
    };
    /**
     * @param {?} items
     * @return {?}
     */
    TreeviewComponent.prototype.uncheckAll = function (items) {
        var _this = this;
        if (items) {
            items.forEach(function (item) {
                item.checked = false;
                _this.uncheckAll(item.children);
            });
        }
    };
    /**
     * @param {?} items
     * @return {?}
     */
    TreeviewComponent.prototype.correctAllChecked = function (items) {
        var _this = this;
        if (items) {
            items.forEach(function (item) {
                if (item.children && item.children.length) {
                    _this.correctAllChecked(item.children);
                }
                item.correctChecked();
            });
        }
    };
    /**
     * @param {?} items
     * @return {?}
     */
    TreeviewComponent.prototype.getSelectedTree = function (items) {
        var _this = this;
        if (items) {
            var /** @type {?} */ selectedTree = items.reduce(function (selectedItems, item) {
                var /** @type {?} */ isSelected = (item.checked === undefined || item.checked === true);
                if (isSelected) {
                    selectedItems.push(new TreeviewItem({
                        text: item.text,
                        value: item.value,
                        children: _this.getSelectedTree(item.children),
                        checked: item.checked,
                        collapsed: item.collapsed,
                        disabled: true
                    }));
                }
                return selectedItems;
            }, []);
            return selectedTree;
        }
        return [];
    };
    /**
     * @param {?} item
     * @return {?}
     */
    TreeviewComponent.prototype.isRoot = function (item) {
        if (!this._items)
            return false;
        for (var /** @type {?} */ i = 0, /** @type {?} */ n = this._items.length; i < n; i++) {
            var /** @type {?} */ root = this._items[i];
            if (item === root)
                return true;
        }
        return false;
    };
    /**
     * @param {?} action
     * @param {?} obj
     * @return {?}
     */
    TreeviewComponent.prototype.getIcon = function (action, obj) {
        return "glyphicon " + (typeof action.icon === 'string' ? action.icon : action.icon(obj));
    };
    /**
     * Dispara um evento de uma ação do treeview.
     *
     * @param {?} action ação realizada
     * @param {?} object objeto na qual a ação foi realizada
     * @return {?}
     */
    TreeviewComponent.prototype.actionEvent = function (action, object) {
        if (action.action) {
            action.action(object, null);
        }
        else {
            this.onAction.emit({ action: action.title, object: object, index: null });
        }
    };
    return TreeviewComponent;
}());
TreeviewComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-treeview',
                template: "<pmv-fieldset [header]=\"header\" *ngIf=\"header; else nofieldset\">\n  <ng-container *ngTemplateOutlet=\"treeview\"></ng-container>\n</pmv-fieldset>\n<ng-template #nofieldset>\n  <ng-container *ngTemplateOutlet=\"treeview\"></ng-container>\n</ng-template>\n<ng-template #treeview>\n  <div *ngIf=\"dropdown; then drop; else tree\"></div>\n  <ng-template #drop>\n    <div *ngIf=\"showSelectedTree; then selectedTreeDropTemplate; else normalTreeDropTemplate\"></div>\n    <ng-template #selectedTreeDropTemplate>\n      <ngx-dropdown-treeview [config]=\"_config\" [items]=\"selectedTree\" [headerTemplate]=\"customHeaderTemplate\" [itemTemplate]=\"customItemTemplate\"\n        [class.loading]=\"isLoading\" buttonClass=\"form-control\"></ngx-dropdown-treeview>\n    </ng-template>\n    <ng-template #normalTreeDropTemplate>\n      <ngx-dropdown-treeview [config]=\"_config\" [items]=\"_items\" (selectedChange)=\"onSelectedChange($event)\" [headerTemplate]=\"customHeaderTemplate\"\n        [itemTemplate]=\"customItemTemplate\" [class.loading]=\"isLoading\" buttonClass=\"form-control\"></ngx-dropdown-treeview>\n    </ng-template>\n  </ng-template>\n  <ng-template #tree>\n    <div *ngIf=\"showSelectedTree; then selectedTreeTemplate; else normalTreeTemplate\"></div>\n    <ng-template #selectedTreeTemplate>\n      <ngx-treeview [config]=\"_config\" [items]=\"selectedTree\" [headerTemplate]=\"customHeaderTemplate\" [itemTemplate]=\"customItemTemplate\"\n        [class.loading]=\"isLoading\"></ngx-treeview>\n    </ng-template>\n    <ng-template #normalTreeTemplate>\n      <ngx-treeview [config]=\"_config\" [items]=\"_items\" (selectedChange)=\"onSelectedChange($event)\" [headerTemplate]=\"customHeaderTemplate\"\n        [itemTemplate]=\"customItemTemplate\" [class.loading]=\"isLoading\"></ngx-treeview>\n    </ng-template>\n  </ng-template>\n</ng-template>\n<ng-template #customItemTemplate let-item=\"item\" let-onCollapseExpand=\"onCollapseExpand\" let-onCheckedChange=\"onCheckedChange\">\n  <div class=\"form-inline row-item\">\n    <div class=\"form-check\">\n      <i *ngIf=\"item.children\" (click)=\"handleCollapseExpand(item, onCollapseExpand)\" aria-hidden=\"true\" class=\"fa\" [class.fa-caret-right]=\"item.collapsed\"\n        [class.fa-caret-down]=\"!item.collapsed\"></i>\n      <ng-container *ngIf=\"!noInput && (showRootsInputs || !isRoot(item))\">\n        <div *ngIf=\"selectOnlyOne; then inputRadio; else inputCheckbox\"></div>\n        <ng-template #inputRadio>\n          <input *ngIf=\"(!item.children || (config.decoupleChildFromParent && showParentsInputs))\" style=\"margin: 2px 0 0 15px\" [(ngModel)]=\"selectedRadioButton\" (ngModelChange)=\"selectRadioButton($event, onCheckedChange)\"\n            type=\"radio\" class=\"form-check-input\" [value]=\"item.value\" [name]=\"identifier\" [disabled]=\"item.disabled || disabled\"\n          />\n        </ng-template>\n        <ng-template #inputCheckbox>\n          <input *ngIf=\"(!item.children || showParentsInputs) && showCheckbox\" [(ngModel)]=\"item.checked\" (ngModelChange)=\"onCheckedChange()\"\n            type=\"checkbox\" class=\"form-check-input\" [disabled]=\"item.disabled || disabled\" [indeterminate]=\"item.indeterminate\"\n          />\n        </ng-template>\n      </ng-container>\n      <label [style.color]=\"colorFn && colorFn(item.value)\" class=\"form-check-label\" (click)=\"handleLabelClick(item, onCheckedChange, onCollapseExpand)\">\n        {{item.text}}\n      </label>\n      <div class=\"line-separator\" [style.display]=\"!showLine ? 'none' : null\"></div>\n      <div class=\"value-right\" *ngIf=\"valuesRelative.get(item.value)\">\n        {{valuesRelative.get(item.value)}}\n      </div>\n      <div class=\"action-icon-container\" *ngIf=\"!item.children || showParentsActions\">\n        <span *ngFor=\"let action of actions\" class=\"action-icon\" [class.is-hidden]=\"action.isHidden && action.isHidden(item.value, null)\"\n          (click)=\"actionEvent(action, item.value)\" [pTooltip]=\"action.title\" tooltipPosition=\"left\">\n          <span [class]=\"getIcon(action, item.value)\"></span>\n        </span>\n      </div>\n    </div>\n  </div>\n</ng-template>\n<ng-template #customHeaderTemplate let-cfg=\"config\" let-item=\"item\" let-onCollapseExpand=\"onCollapseExpand\" let-onCheckedChange=\"onCheckedChange\"\n  let-onFilterTextChange=\"onFilterTextChange\">\n  <ng-container *ngIf=\"cfg\">\n    <div *ngIf=\"cfg.hasFilter\" class=\"row row-filter\">\n      <div class=\"col-12\">\n        <input class=\"form-control\" type=\"text\" [placeholder]=\"i18n.getFilterPlaceholder()\" [(ngModel)]=\"filterText\" (ngModelChange)=\"onFilterTextChange($event)\"\n        />\n      </div>\n    </div>\n    <div>\n      <div *ngIf=\"(cfg.hasAllCheckBox && !selectOnlyOne) || cfg.hasCollapseExpand || cfg.canShowSelectedTree\" class=\"row row-all\">\n        <div class=\"col-12\">\n          <div class=\"form-check\">\n            <input *ngIf=\"cfg.hasAllCheckBox && !selectOnlyOne\" type=\"checkbox\" class=\"form-check-input\" [(ngModel)]=\"item.checked\" (ngModelChange)=\"onCheckedChange($event)\"\n              [indeterminate]=\"item.indeterminate\" />\n            <label *ngIf=\"cfg.hasAllCheckBox && !selectOnlyOne\" class=\"form-check-label\">\n              {{ i18n.getAllCheckboxText() }}\n            </label>\n            <input *ngIf=\"cfg.canShowSelectedTree\" type=\"checkbox\" class=\"form-check-input\" [(ngModel)]=\"showSelectedTree\" />\n            <label *ngIf=\"cfg.canShowSelectedTree\" class=\"form-check-label\">\n              Mostrar somente itens selecionados\n            </label>\n            <label #labelCollapse *ngIf=\"cfg.hasCollapseExpand\" class=\"pull-right form-check-label\" [class.hidden]=\"hideCollapseExpandIcon\"\n              (click)=\"onCollapseExpand()\">\n              <i [title]=\"i18n.getTooltipCollapseExpandText(item.collapsed)\" aria-hidden=\"true\" class=\"fa\" [class.fa-expand]=\"item.collapsed\"\n                [class.fa-compress]=\"!item.collapsed\"></i>\n            </label>\n          </div>\n        </div>\n      </div>\n      <div *ngIf=\"cfg.hasDivider\" class=\"dropdown-divider\"></div>\n    </div>\n  </ng-container>\n</ng-template>\n",
                styles: [":host /deep/ .treeview-header .row{\n  margin-left:0;\n  margin-right:0; }\n:host /deep/ .row-item .form-check{\n  display:inline-block; }\n.loading /deep/ legend{\n  color:rgba(0, 0, 0, 0.4); }\n.loading /deep/ .treeview-text,\n.loading /deep/ .dropdown{\n  color:rgba(0, 0, 0, 0.2); }\n.loading /deep/ .dropdown:hover{\n  cursor:default;\n  color:rgba(0, 0, 0, 0.2); }\n.action-icon-container{\n  float:right;\n  margin-left:5px; }\n.action-icon{\n  color:#2d699f;\n  cursor:pointer;\n  font-size:12px; }\n.action-icon.is-hidden{\n  visibility:hidden; }\n:host /deep/ .row-item .form-check{\n  width:98%;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-align:baseline;\n      -ms-flex-align:baseline;\n          align-items:baseline; }\n:host /deep/ .treeview-container .row-item .fa{\n  width:0px !important;\n  cursor:pointer !important;\n  margin-right:-3px !important; }\n:host /deep/ .dropdown button.form-control:focus{\n  border-color:#ddd; }\n.hidden{\n  display:none; }\n.line-separator{\n  -webkit-box-flex:1;\n      -ms-flex-positive:1;\n          flex-grow:1;\n  border-top:1px dashed black;\n  height:1px;\n  margin-top:8px;\n  margin-left:10px;\n  margin-right:10px; }\n:host /deep/ label{\n  margin-left:12px; }\n:host /deep/ .value-right{\n  font-size:12px;\n  font-weight:bold; }\n"],
                providers: [
                    { provide: TreeviewI18n, useClass: TreeviewI18nPT }
                ]
            },] },
];
/** @nocollapse */
TreeviewComponent.ctorParameters = function () { return [
    { type: TreeviewI18nPT, },
    { type: ChangeDetectorRef, },
]; };
TreeviewComponent.propDecorators = {
    "config": [{ type: Input },],
    "items": [{ type: Input },],
    "header": [{ type: Input },],
    "textField": [{ type: Input },],
    "valueField": [{ type: Input },],
    "childrenField": [{ type: Input },],
    "collapsedField": [{ type: Input },],
    "valueRelativeField": [{ type: Input },],
    "compareBy": [{ type: Input },],
    "dropdown": [{ type: Input },],
    "collapsed": [{ type: Input },],
    "disabled": [{ type: Input },],
    "noInput": [{ type: Input },],
    "showRootsInputs": [{ type: Input },],
    "showParentsInputs": [{ type: Input },],
    "showParentsActions": [{ type: Input },],
    "showCheckbox": [{ type: Input },],
    "showLine": [{ type: Input },],
    "selectOnlyOne": [{ type: Input },],
    "isLoading": [{ type: Input },],
    "actions": [{ type: Input },],
    "onAction": [{ type: Output },],
    "colorFn": [{ type: Input },],
    "selected": [{ type: Input },],
    "selectedChange": [{ type: Output },],
    "dropdownTreeviewComponent": [{ type: ViewChild, args: [DropdownTreeviewComponent,] },],
    "labelCollapse": [{ type: ViewChild, args: ['labelCollapse',] },],
};
var identifier$10 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MyTreeviewEventParser = /** @class */ (function (_super) {
    tslib_1.__extends(MyTreeviewEventParser, _super);
    function MyTreeviewEventParser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} component
     * @return {?}
     */
    MyTreeviewEventParser.prototype.getSelectedChange = function (component) {
        var /** @type {?} */ config = component.config;
        var /** @type {?} */ decoupleChildFromParent = config && config.decoupleChildFromParent;
        if (decoupleChildFromParent) {
            var /** @type {?} */ items = component.items;
            if (items && Array.isArray(items)) {
                return this.getAllChecked(items, []);
            }
        }
        else {
            var /** @type {?} */ checkedItems = component.selection.checkedItems;
            if (checkedItems && Array.isArray(checkedItems)) {
                return checkedItems.map(function (item) { return item.value; });
            }
        }
        return [];
    };
    /**
     * @param {?} items
     * @param {?} checkedItems
     * @return {?}
     */
    MyTreeviewEventParser.prototype.getAllChecked = function (items, checkedItems) {
        var _this = this;
        if (items && Array.isArray(items)) {
            items.forEach(function (item) {
                if (item.checked) {
                    checkedItems.push(item.value);
                }
                _this.getAllChecked(item.children, checkedItems);
            });
        }
        return checkedItems;
    };
    return MyTreeviewEventParser;
}(TreeviewEventParser));
MyTreeviewEventParser.decorators = [
    { type: Injectable },
];
/** @nocollapse */
MyTreeviewEventParser.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVTreeviewModule = /** @class */ (function () {
    function PMVTreeviewModule() {
    }
    /**
     * @return {?}
     */
    PMVTreeviewModule.forRoot = function () {
        return {
            ngModule: PMVTreeviewModule,
            providers: tslib_1.__spread(TreeviewModule.forRoot().providers, [
                TreeviewI18nPT,
                { provide: TreeviewEventParser, useClass: MyTreeviewEventParser },
            ])
        };
    };
    return PMVTreeviewModule;
}());
PMVTreeviewModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    TreeviewModule,
                    TooltipModule$1,
                    PMVFieldsetModule,
                ],
                declarations: [
                    TreeviewComponent,
                ],
                exports: [
                    TreeviewComponent,
                ],
            },] },
];
/** @nocollapse */
PMVTreeviewModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var HexadecimalValueValidator = /** @class */ (function () {
    function HexadecimalValueValidator() {
    }
    /**
     * @param {?} control
     * @return {?}
     */
    HexadecimalValueValidator.prototype.validate = function (control) {
        var /** @type {?} */ expression = /^([0-9a-fA-F]+)$/i;
        if (!control.value) {
            // the [required] validator will check presence, not us
            return null;
        }
        var /** @type {?} */ value = control.value.trim();
        if (expression.test(value)) {
            return null;
        }
        return { hexadecimal: this.validationMessage || 'Digite um valor hexadecimal (números ou letras de A a F)' };
    };
    return HexadecimalValueValidator;
}());
HexadecimalValueValidator.decorators = [
    { type: Directive, args: [{
                selector: '[hexadecimal][ngModel]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: HexadecimalValueValidator, multi: true }
                ]
            },] },
];
/** @nocollapse */
HexadecimalValueValidator.ctorParameters = function () { return []; };
HexadecimalValueValidator.propDecorators = {
    "validationMessage": [{ type: Input, args: ['hexadecimal',] },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MaxLengthValueValidator = /** @class */ (function () {
    function MaxLengthValueValidator() {
    }
    /**
     * @param {?} control
     * @return {?}
     */
    MaxLengthValueValidator.prototype.validate = function (control) {
        if (!control.value) {
            return null;
        }
        var /** @type {?} */ value = String(control.value);
        if (value.length <= this.maxChars) {
            return null;
        }
        return { maxLength: "O tamanho m\u00E1ximo do campo \u00E9 " + this.maxChars + " caracteres" };
    };
    return MaxLengthValueValidator;
}());
MaxLengthValueValidator.decorators = [
    { type: Directive, args: [{
                selector: '[maxLength][ngModel]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: MaxLengthValueValidator, multi: true }
                ]
            },] },
];
/** @nocollapse */
MaxLengthValueValidator.ctorParameters = function () { return []; };
MaxLengthValueValidator.propDecorators = {
    "maxChars": [{ type: Input, args: ['maxLength',] },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var NumberOnlyValueValidator = /** @class */ (function () {
    function NumberOnlyValueValidator() {
    }
    /**
     * @param {?} control
     * @return {?}
     */
    NumberOnlyValueValidator.prototype.validate = function (control) {
        if (!control.value) {
            return null;
        }
        var /** @type {?} */ value = control.value;
        if (Number(value)) {
            return null;
        }
        return { numberOnly: "O campo s\u00F3 permite valor num\u00E9rico." };
    };
    return NumberOnlyValueValidator;
}());
NumberOnlyValueValidator.decorators = [
    { type: Directive, args: [{
                selector: '[numberOnly][ngModel]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: NumberOnlyValueValidator, multi: true }
                ]
            },] },
];
/** @nocollapse */
NumberOnlyValueValidator.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} form
 * @return {?}
 */
function returnForm(form) {
    return form;
}
var ProvideParentFormDirective = /** @class */ (function () {
    function ProvideParentFormDirective() {
    }
    return ProvideParentFormDirective;
}());
ProvideParentFormDirective.decorators = [
    { type: Directive, args: [{
                selector: '[provide-parent-form]',
                providers: [{
                        provide: ControlContainer,
                        useFactory: returnForm,
                        deps: [NgForm]
                    }]
            },] },
];
/** @nocollapse */
ProvideParentFormDirective.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RegexValueValidator = /** @class */ (function () {
    function RegexValueValidator() {
    }
    /**
     * @param {?} control
     * @return {?}
     */
    RegexValueValidator.prototype.validate = function (control) {
        if (!control.value) {
            return null;
        }
        var /** @type {?} */ value = control.value;
        var /** @type {?} */ regexp = new RegExp(this.regexValue);
        if (regexp.test(value)) {
            return null;
        }
        return { regex: 'Formato inválido.' };
    };
    return RegexValueValidator;
}());
RegexValueValidator.decorators = [
    { type: Directive, args: [{
                selector: '[regex][ngModel]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: RegexValueValidator, multi: true }
                ]
            },] },
];
/** @nocollapse */
RegexValueValidator.ctorParameters = function () { return []; };
RegexValueValidator.propDecorators = {
    "regexValue": [{ type: Input, args: ['regex',] },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RequiredValueValidator = /** @class */ (function () {
    function RequiredValueValidator() {
    }
    /**
     * @param {?} control
     * @return {?}
     */
    RequiredValueValidator.prototype.validate = function (control) {
        if (control.value !== null && control.value !== undefined) {
            return null;
        }
        return { required: this.validationMessage || 'O campo é obrigatório.' };
    };
    return RequiredValueValidator;
}());
RequiredValueValidator.decorators = [
    { type: Directive, args: [{
                selector: '[required][ngModel]',
                providers: [
                    { provide: NG_VALIDATORS, useExisting: RequiredValueValidator, multi: true }
                ]
            },] },
];
/** @nocollapse */
RequiredValueValidator.ctorParameters = function () { return []; };
RequiredValueValidator.propDecorators = {
    "validationMessage": [{ type: Input, args: ['required',] },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ValidateOnSubmitDirective = /** @class */ (function () {
    /**
     * @param {?} ngForm
     */
    function ValidateOnSubmitDirective(ngForm) {
        this.ngForm = ngForm;
    }
    /**
     * @return {?}
     */
    ValidateOnSubmitDirective.prototype.ngOnInit = function () {
        this.ngForm['validateOnSubmit'] = true;
    };
    return ValidateOnSubmitDirective;
}());
ValidateOnSubmitDirective.decorators = [
    { type: Directive, args: [{ selector: 'form[validateOnSubmit]' },] },
];
/** @nocollapse */
ValidateOnSubmitDirective.ctorParameters = function () { return [
    { type: NgForm, },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVDirectiveModule = /** @class */ (function () {
    function PMVDirectiveModule() {
    }
    return PMVDirectiveModule;
}());
PMVDirectiveModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    HexadecimalValueValidator,
                    MaxLengthValueValidator,
                    NumberOnlyValueValidator,
                    ProvideParentFormDirective,
                    RegexValueValidator,
                    RequiredValueValidator,
                    ValidateOnSubmitDirective,
                ],
                exports: [
                    HexadecimalValueValidator,
                    MaxLengthValueValidator,
                    NumberOnlyValueValidator,
                    ProvideParentFormDirective,
                    RegexValueValidator,
                    RequiredValueValidator,
                    ValidateOnSubmitDirective,
                ],
            },] },
];
/** @nocollapse */
PMVDirectiveModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Pipe para conversão de segundos para uma data em formato de string.
 */
var SecondsToTimePipe = /** @class */ (function () {
    function SecondsToTimePipe() {
    }
    /**
     * @param {?} seconds
     * @return {?}
     */
    SecondsToTimePipe.prototype.transform = function (seconds) {
        var /** @type {?} */ date = new Date(null);
        date.setSeconds(seconds || null);
        return date.toISOString().substr(14, 5);
    };
    return SecondsToTimePipe;
}());
SecondsToTimePipe.decorators = [
    { type: Pipe, args: [{
                name: 'secondstotime'
            },] },
];
/** @nocollapse */
SecondsToTimePipe.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} value
 * @param {?=} withDollarSign
 * @return {?}
 */
function moneyMask(value, withDollarSign) {
    if (withDollarSign === void 0) { withDollarSign = true; }
    return "" + (withDollarSign ? 'R$ ' : '') + value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Pipe para conversão de segundos para uma data em formato de string.
 */
var MoneyPipe = /** @class */ (function () {
    function MoneyPipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    MoneyPipe.prototype.transform = function (value) {
        return (value
            ? moneyMask(value)
            : null);
    };
    return MoneyPipe;
}());
MoneyPipe.decorators = [
    { type: Pipe, args: [{
                name: 'money'
            },] },
];
/** @nocollapse */
MoneyPipe.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function phoneMask(value) {
    var /** @type {?} */ phone = value.toString();
    if (phone.length === 8) {
        return phone.substring(0, 4) + '-' + phone.substring(4);
    }
    else if (phone.length === 9) {
        return phone.substring(0, 5) + '-' + phone.substring(5);
    }
    else if (phone.length === 10) {
        return '(' + phone.substring(0, 2) + ')' + phone.substring(2, 6) + '-' + phone.substring(6);
    }
    else if (phone.length === 11) {
        return '(' + phone.substring(0, 2) + ')' + phone.substring(2, 7) + '-' + phone.substring(7);
    }
    return '';
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PhonePipe = /** @class */ (function () {
    function PhonePipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    PhonePipe.prototype.transform = function (value) {
        return (value
            ? phoneMask(value)
            : null);
    };
    return PhonePipe;
}());
PhonePipe.decorators = [
    { type: Pipe, args: [{
                name: 'phone-number'
            },] },
];
/** @nocollapse */
PhonePipe.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVPipeModule = /** @class */ (function () {
    function PMVPipeModule() {
    }
    return PMVPipeModule;
}());
PMVPipeModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    SecondsToTimePipe,
                    MoneyPipe,
                    PhonePipe,
                ],
                exports: [
                    SecondsToTimePipe,
                    MoneyPipe,
                    PhonePipe,
                ],
            },] },
];
/** @nocollapse */
PMVPipeModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVUtilModule = /** @class */ (function () {
    function PMVUtilModule() {
    }
    /**
     * @return {?}
     */
    PMVUtilModule.forRoot = function () {
        return {
            ngModule: PMVUtilModule,
            providers: [
                DateUtils,
                TreeviewI18nPT,
            ]
        };
    };
    return PMVUtilModule;
}());
PMVUtilModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                exports: [],
            },] },
];
/** @nocollapse */
PMVUtilModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Serviço de acesso ao SessionStorage do browser.
 */
var SessionStorageService = /** @class */ (function () {
    function SessionStorageService() {
    }
    /**
     * Recupera um valor armazenado no SessionStorage através de sua chave. Caso não seja encontrado, retorna null.
     *
     * @param {?} key chave referente ao valor a ser recuperado
     * @return {?} o objeto caso exista associação no SessionStorage e null, caso contrário
     */
    SessionStorageService.prototype.getItem = function (key) {
        var /** @type {?} */ item = sessionStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    };
    /**
     * Armazena um valor no SessionStorage utilizando a chave passada.
     *
     * @param {?} key chave para o valor a ser armazenado
     * @param {?} item valor a ser armazenado
     * @return {?}
     */
    SessionStorageService.prototype.setItem = function (key, item) {
        sessionStorage.setItem(key, typeof item === 'string' ? item : JSON.stringify(item));
    };
    /**
     * Determina se a chave passada possui um valor associado no SessionStorage.
     *
     * @param {?} key chave a ser verificada
     * @return {?} true caso exista valor para a chave e false, caso contrário
     */
    SessionStorageService.prototype.hasItem = function (key) {
        return this.getItem(key) !== null;
    };
    /**
     * Remove um valor do SessionStorage de acordo com sua chave.
     *
     * @param {?} key chave sobre a qual o valor deve ser removido
     * @return {?}
     */
    SessionStorageService.prototype.removeItem = function (key) {
        sessionStorage.removeItem(key);
    };
    /**
     * Limpa todos os valores armazenados no SessionStorage.
     * @return {?}
     */
    SessionStorageService.prototype.clear = function () {
        sessionStorage.clear();
    };
    return SessionStorageService;
}());
SessionStorageService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
SessionStorageService.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Serviço de acesso ao LocalStorage do browser.
 */
var LocalStorageService = /** @class */ (function () {
    function LocalStorageService() {
    }
    /**
     * Recupera um valor armazenado no LocalStorage através de sua chave. Caso não seja encontrado, retorna null.
     *
     * @param {?} key chave referente ao valor a ser recuperado
     * @return {?} o objeto caso exista associação no LocalStorage e null, caso contrário
     */
    LocalStorageService.prototype.getItem = function (key) {
        var /** @type {?} */ item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    };
    /**
     * Armazena um valor no LocalStorage utilizando a chave passada.
     *
     * @param {?} key chave para o valor a ser armazenado
     * @param {?} item valor a ser armazenado
     * @return {?}
     */
    LocalStorageService.prototype.setItem = function (key, item) {
        localStorage.setItem(key, typeof item === 'string' ? item : JSON.stringify(item));
    };
    /**
     * Determina se a chave passada possui um valor associado no LocalStorage.
     *
     * @param {?} key chave a ser verificada
     * @return {?} true caso exista valor para a chave e false, caso contrário
     */
    LocalStorageService.prototype.hasItem = function (key) {
        return this.getItem(key) !== null;
    };
    /**
     * Remove um valor do LocalStorage de acordo com sua chave.
     *
     * @param {?} key chave sobre a qual o valor deve ser removido
     * @return {?}
     */
    LocalStorageService.prototype.removeItem = function (key) {
        localStorage.removeItem(key);
    };
    /**
     * Limpa todos os valores armazenados no LocalStorage.
     * @return {?}
     */
    LocalStorageService.prototype.clear = function () {
        localStorage.clear();
    };
    return LocalStorageService;
}());
LocalStorageService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
LocalStorageService.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var RouteDataService = /** @class */ (function () {
    function RouteDataService() {
        this.transfers = [];
    }
    /**
     * Armazena os dados a serem transferidos de um componente para outro.
     *
     * @param {?} id   Chave que representa o identificador da transferência a ser executada
     * @param {?} data Os dados a serem transferidos
     * @return {?}
     */
    RouteDataService.prototype.transfer = function (id, data) {
        this.transfers[id] = data;
    };
    /**
     * Recupera os dados armazenados de uma transferência de um componente para outro.
     *
     * @param {?} id Chave que representa o identificador da transferência executada
     *
     * @return {?} Os dados transferidos
     */
    RouteDataService.prototype.retrieve = function (id) {
        var /** @type {?} */ data = this.transfers[id] || null;
        this.remove(id);
        return data;
    };
    /**
     * Remove os dados referentes a uma transferência feita entre dois componentes.
     *
     * @param {?} id Chave que representa o identificador da transferência executada
     * @return {?}
     */
    RouteDataService.prototype.remove = function (id) {
        this.transfers[id] = null;
    };
    return RouteDataService;
}());
RouteDataService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
RouteDataService.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVStorageModule = /** @class */ (function () {
    function PMVStorageModule() {
    }
    /**
     * @return {?}
     */
    PMVStorageModule.forRoot = function () {
        return {
            ngModule: PMVStorageModule,
            providers: [
                SessionStorageService,
                LocalStorageService,
                RouteDataService,
            ]
        };
    };
    return PMVStorageModule;
}());
PMVStorageModule.decorators = [
    { type: NgModule, args: [{},] },
];
/** @nocollapse */
PMVStorageModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var EditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(EditorComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function EditorComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.style = { 'height': '320px' };
        return _this;
    }
    /**
     * @return {?}
     */
    EditorComponent.prototype.modelChange = function () {
        var _this = this;
        if (this.editor.getQuill().getText().trim().length === 0) {
            setTimeout(function (_) {
                _this.value = null;
            }, 0);
        }
    };
    return EditorComponent;
}(ElementBase));
EditorComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-editor',
                template: "<div>\n  <label *ngIf=\"label\">{{label}}</label>\n  <p-editor #editor [(ngModel)]=\"value\" (onTextChange)=\"modelChange()\" [style]=\"style\" [readonly]=\"readonly\" [placeholder]=\"placeholder\">\n    <p-header>\n      <select class=\"ql-size\">\n        <option value=\"small\"></option>\n        <option selected></option>\n        <option value=\"large\"></option>\n        <option value=\"huge\"></option>\n      </select>\n      <button class=\"ql-bold\"></button>\n      <button class=\"ql-italic\"></button>\n      <button class=\"ql-underline\"></button>\n      <select class=\"ql-color\">\n        <option value=\"black\"></option>\n        <option value=\"gray\"></option>\n        <option value=\"white\"></option>\n        <option value=\"red\"></option>\n        <option value=\"orange\"></option>\n        <option value=\"green\"></option>\n        <option value=\"blue\"></option>\n        <option value=\"purple\"></option>\n        <option value=\"yellow\"></option>\n      </select>\n      <select class=\"ql-background\">\n        <option value=\"black\"></option>\n        <option value=\"gray\"></option>\n        <option value=\"white\"></option>\n        <option value=\"red\"></option>\n        <option value=\"orange\"></option>\n        <option value=\"green\"></option>\n        <option value=\"blue\"></option>\n        <option value=\"purple\"></option>\n        <option value=\"yellow\"></option>\n      </select>\n      <button class=\"ql-list\" value=\"bullet\"></button>\n      <button class=\"ql-list\" value=\"ordered\"></button>\n      <button class=\"ql-indent\" value=\"+1\"></button>\n      <button class=\"ql-indent\" value=\"-1\"></button>\n      <select class=\"ql-align\">\n        <option selected></option>\n        <option value=\"right\"></option>\n        <option value=\"center\"></option>\n        <option value=\"justify\"></option>\n      </select>\n      <button class=\"ql-script\" value=\"sub\"></button>\n      <button class=\"ql-script\" value=\"super\"></button>\n    </p-header>\n  </p-editor>\n  <validation [elementBase]=\"this\"></validation>\n</div>\n",
                styles: [":host /deep/ .ql-align-justify{\n  white-space:initial; }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: EditorComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
EditorComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
EditorComponent.propDecorators = {
    "disabled": [{ type: Input },],
    "readonly": [{ type: Input },],
    "placeholder": [{ type: Input },],
    "label": [{ type: Input },],
    "style": [{ type: Input },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
    "editor": [{ type: ViewChild, args: ['editor',] },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVEditorModule = /** @class */ (function () {
    function PMVEditorModule() {
    }
    return PMVEditorModule;
}());
PMVEditorModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    PMVValidationModule,
                    EditorModule,
                ],
                declarations: [
                    EditorComponent,
                ],
                exports: [
                    EditorComponent,
                ]
            },] },
];
/** @nocollapse */
PMVEditorModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DropdownCRUDComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DropdownCRUDComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     * @param {?} notificationService
     * @param {?} confirmationService
     */
    function DropdownCRUDComponent(validators, asyncValidators, ngForm, notificationService, confirmationService) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.notificationService = notificationService;
        _this.confirmationService = confirmationService;
        _this.addEvent = new EventEmitter();
        _this.removeEvent = new EventEmitter();
        _this.selectEvent = new EventEmitter();
        _this.showPlusIcon = true;
        _this.disableButton = true;
        _this.identifier = "form-dropdown-" + identifier$11++;
        return _this;
    }
    /**
     * @return {?}
     */
    DropdownCRUDComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function (_) {
            if (_this.value) {
                _this.disableButton = false;
                _this.selectMethod();
            }
        }, 0);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DropdownCRUDComponent.prototype.modelChange = function (event) {
        if (!this.value) {
            this.disableButton = true;
        }
        else {
            this.disableButton = false;
        }
        if (this.value && typeof this.value === 'object') {
            this.showPlusIcon = false;
        }
        else {
            this.showPlusIcon = true;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DropdownCRUDComponent.prototype.completeMethod = function (event) {
        this.suggestions = this.values.filter(function (v) { return v.descricao.indexOf(event) !== -1; });
    };
    /**
     * @return {?}
     */
    DropdownCRUDComponent.prototype.selectMethod = function () {
        this.showPlusIcon = false;
        this.selectEvent.emit(this.value);
    };
    /**
     * @return {?}
     */
    DropdownCRUDComponent.prototype.addItem = function () {
        var _this = this;
        this.confirmationService.confirm({
            message: 'Deseja salvar o novo registro?',
            accept: function () {
                _this.confirmDialogAdd();
            }
        });
    };
    /**
     * @return {?}
     */
    DropdownCRUDComponent.prototype.removeItem = function () {
        var _this = this;
        this.confirmationService.confirm({
            message: 'Deseja remover o registro?',
            accept: function () {
                _this.confirmDialogRemove();
            }
        });
    };
    /**
     * @return {?}
     */
    DropdownCRUDComponent.prototype.confirmDialogAdd = function () {
        var _this = this;
        if (this.values.find(function (v) { return v.descricao === _this.value; })) {
            this.notificationService.notifyError('Registro já existe.');
        }
        else {
            this.addEvent.emit(this.value);
            this.value = null;
            this.disableButton = true;
        }
    };
    /**
     * @return {?}
     */
    DropdownCRUDComponent.prototype.confirmDialogRemove = function () {
        this.removeEvent.emit(this.value);
        this.value = null;
        this.disableButton = true;
        this.showPlusIcon = true;
    };
    return DropdownCRUDComponent;
}(ElementBase));
DropdownCRUDComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-dropdown-crud',
                template: "<div class=\"dropdown-crud-container\">\n  <div class=\"autocomplete-container\">\n    <pmv-autocomplete [disabled]=\"disabled\" [(ngModel)]=\"value\" [label]=\"label\" [forceSelection]=\"false\" [suggestions]=\"suggestions\"\n      (complete)=\"completeMethod($event)\" [field]=\"field || 'descricao'\" [dropdown]=\"true\" (select)=\"selectMethod()\" (ngModelChange)=\"modelChange($event)\">\n    </pmv-autocomplete>\n  </div>\n  <div class=\"button-container\">\n    <!-- Bot\u00E3o pra adicionar -->\n    <button *ngIf=\"hideRemoveButton || showPlusIcon\" [disabled]=\"disableButton || !showPlusIcon\" type=\"button\" class=\"button-operation btn btn-primary btn-add-dropdown-crud\"\n      (click)=\"addItem()\">\n      <span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span>\n    </button>\n    <!-- Bot\u00E3o pra remover -->\n    <button *ngIf=\"!hideRemoveButton && !showPlusIcon\" [disabled]=\"disableButton || showPlusIcon\" type=\"button\" class=\"button-operation btn btn-danger btn-add-dropdown-crud\"\n      (click)=\"removeItem()\">\n      <span class=\"glyphicon glyphicon-minus\" aria-hidden=\"true\"></span>\n    </button>\n  </div>\n</div>\n",
                styles: [":host /deep/ pmv-autocomplete button{\n  position:absolute;\n  right:-1px;\n  background-color:transparent;\n  top:0px;\n  color:#000;\n  border:0px; }\n:host /deep/ #confirm-dialog{\n  height:100px;\n  color:#000;\n  border:1px solid #000;\n  position:relative;\n  bottom:66px;\n  width:240px;\n  margin:auto;\n  background-color:#fff;\n  z-index:9999; }\n.dropdown-crud-container{\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-align:end;\n      -ms-flex-align:end;\n          align-items:flex-end; }\n.autocomplete-container{\n  -webkit-box-flex:1;\n      -ms-flex-positive:1;\n          flex-grow:1; }\n.button-operation{\n  border-radius:0; }\n"],
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: DropdownCRUDComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
DropdownCRUDComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
    { type: NotificationService, },
    { type: ConfirmDialogService, },
]; };
DropdownCRUDComponent.propDecorators = {
    "label": [{ type: Input },],
    "disabled": [{ type: Input },],
    "suggestions": [{ type: Input },],
    "values": [{ type: Input },],
    "field": [{ type: Input },],
    "hideRemoveButton": [{ type: Input },],
    "addEvent": [{ type: Output },],
    "removeEvent": [{ type: Output },],
    "selectEvent": [{ type: Output },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
};
var identifier$11 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVDropdownCRUDModule = /** @class */ (function () {
    function PMVDropdownCRUDModule() {
    }
    return PMVDropdownCRUDModule;
}());
PMVDropdownCRUDModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    PMVAutocompleteModule,
                    PMVConfirmDialogModule,
                    BlockUIModule,
                ],
                declarations: [
                    DropdownCRUDComponent,
                ],
                exports: [
                    DropdownCRUDComponent,
                ]
            },] },
];
/** @nocollapse */
PMVDropdownCRUDModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PicklistComponent = /** @class */ (function () {
    /**
     * @param {?} el
     * @param {?} renderer
     */
    function PicklistComponent(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.source = null;
        this.target = null;
        this.sourceHeader = null;
        this.targetHeader = null;
        this.showSourceControls = false;
        this.showTargetControls = false;
        this.disabled = false;
        this.onMoveToTarget = new EventEmitter();
        this.onMoveToSource = new EventEmitter();
        this.onMoveAllToTarget = new EventEmitter();
        this.onMoveAllToSource = new EventEmitter();
        this.onSourceReorder = new EventEmitter();
        this.onTargetReorder = new EventEmitter();
        this.onSourceSelect = new EventEmitter();
        this.onTargetSelect = new EventEmitter();
    }
    /**
     * @return {?}
     */
    PicklistComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var /** @type {?} */ buttons = this.el.nativeElement.querySelectorAll('.ui-picklist-buttons-cell button');
        if (buttons) {
            buttons.forEach(function (button) {
                _this.renderer.addClass(button, 'btn');
                _this.renderer.addClass(button, 'btn-primary');
            });
        }
        else {
            console.warn('Não foi possível estilizar os botões do pícklist da tela!');
        }
    };
    /**
     * @param {?} object
     * @param {?} field
     * @return {?}
     */
    PicklistComponent.prototype.resolveFieldData = function (object, field) {
        return resolveFieldData(object, field);
    };
    return PicklistComponent;
}());
PicklistComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-picklist',
                template: "<pmv-fieldset [header]=\"header\" *ngIf=\"header; else nofieldset\">\n  <ng-container *ngTemplateOutlet=\"picklist\"></ng-container>\n</pmv-fieldset>\n<ng-template #nofieldset>\n  <ng-container *ngTemplateOutlet=\"picklist\"></ng-container>\n</ng-template>\n<ng-template #picklist>\n  <p-pickList\n    [source]=\"source\" [target]=\"target\"\n    [sourceHeader]=\"sourceHeader\" [targetHeader]=\"targetHeader\"\n    [showSourceControls]=\"showSourceControls\" [showTargetControls]=\"showTargetControls\"\n    [disabled]=\"disabled\"\n    (onMoveToTarget)=\"onMoveToTarget.emit($event)\" (onMoveToSource)=\"onMoveToSource.emit($event)\"\n    (onMoveAllToTarget)=\"onMoveAllToTarget.emit($event)\" (onMoveAllToSource)=\"onMoveAllToSource.emit($event)\"\n    (onSourceReorder)=\"onSourceReorder.emit($event)\" (onTargetReorder)=\"onTargetReorder.emit($event)\"\n    (onSourceSelect)=\"onSourceSelect.emit($event)\" (onTargetSelect)=\"onTargetSelect.emit($event)\">\n    <ng-template let-object pTemplate=\"item\">\n      {{ field ? resolveFieldData(object, field) : object }}\n    </ng-template>\n  </p-pickList>\n</ng-template>\n",
                styles: [":host /deep/ .ui-picklist{\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex; }\n  :host /deep/ .ui-picklist .ui-picklist-listwrapper{\n    width:calc((100% - 35px) / 2); }\n    :host /deep/ .ui-picklist .ui-picklist-listwrapper .ui-picklist-caption{\n      background-color:#2D699F;\n      color:#fff; }\n    :host /deep/ .ui-picklist .ui-picklist-listwrapper .ui-picklist-list{\n      width:auto; }\n      :host /deep/ .ui-picklist .ui-picklist-listwrapper .ui-picklist-list .ui-picklist-item{\n        padding:.125em 5px;\n        margin:0; }\n        :host /deep/ .ui-picklist .ui-picklist-listwrapper .ui-picklist-list .ui-picklist-item:hover{\n          background-color:#0275d8;\n          color:#fff; }\n        :host /deep/ .ui-picklist .ui-picklist-listwrapper .ui-picklist-list .ui-picklist-item.ui-state-highlight{\n          background-color:#002146;\n          color:#fff; }\n  :host /deep/ .ui-picklist .ui-picklist-buttons{\n    width:35px;\n    height:auto;\n    -ms-flex-item-align:center;\n        align-self:center; }\n"],
            },] },
];
/** @nocollapse */
PicklistComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
PicklistComponent.propDecorators = {
    "header": [{ type: Input },],
    "field": [{ type: Input },],
    "source": [{ type: Input },],
    "target": [{ type: Input },],
    "sourceHeader": [{ type: Input },],
    "targetHeader": [{ type: Input },],
    "showSourceControls": [{ type: Input },],
    "showTargetControls": [{ type: Input },],
    "disabled": [{ type: Input },],
    "onMoveToTarget": [{ type: Output },],
    "onMoveToSource": [{ type: Output },],
    "onMoveAllToTarget": [{ type: Output },],
    "onMoveAllToSource": [{ type: Output },],
    "onSourceReorder": [{ type: Output },],
    "onTargetReorder": [{ type: Output },],
    "onSourceSelect": [{ type: Output },],
    "onTargetSelect": [{ type: Output },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVPickListModule = /** @class */ (function () {
    function PMVPickListModule() {
    }
    return PMVPickListModule;
}());
PMVPickListModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    PickListModule,
                    PMVFieldsetModule,
                    PMVValidationModule,
                ],
                declarations: [
                    PicklistComponent,
                ],
                exports: [
                    PicklistComponent,
                ]
            },] },
];
/** @nocollapse */
PMVPickListModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var InputNumberComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputNumberComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function InputNumberComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.autocomplete = "off";
        _this.blur = new EventEmitter();
        _this.identifier = "form-input-number-" + identifier$12++;
        return _this;
    }
    /**
     * Emite o evento de blur.
     * @return {?}
     */
    InputNumberComponent.prototype.blurEvent = function () {
        this.blur.emit(this.value);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InputNumberComponent.prototype.keyPress = function (event) {
        var _this = this;
        if (!this.readonly && !this.disabled) {
            var /** @type {?} */ charCode = (event.which) ? event.which : event.keyCode;
            if ((charCode === 86 || charCode === 67 || charCode === 65) && this.lastKeyCode === 17) {
                setTimeout(function (_) {
                    var /** @type {?} */ valueInput = _this.inputElement.nativeElement.value;
                    var /** @type {?} */ regex = new RegExp('^[0-9]*$');
                    if (!regex.test(valueInput)) {
                        _this.value = null;
                        return false;
                    }
                }, 0);
                return true;
            }
            if (charCode != 46 && charCode > 31
                && (charCode < 48 || charCode > 57)
                && (charCode < 96 || charCode > 105)) {
                this.lastKeyCode = charCode;
                return false;
            }
            this.lastKeyCode = charCode;
            return true;
        }
    };
    return InputNumberComponent;
}(ElementBase));
InputNumberComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-input-number',
                template: "<div>\n  <label *ngIf=\"label\" [attr.for]=\"identifier\">{{label}}\n    <pmv-mini-loading [isLoading]=\"isLoading\"></pmv-mini-loading>\n  </label>\n  <input #inputElement [(ngModel)]=\"value\" [type]=\"type\" [id]=\"identifier\" [placeholder]=\"placeholder || ''\" [ngClass]=\"{'form-control': true, invalid: (invalid | async)}\"\n    [disabled]=\"disabled\" [readonly]=\"readonly\" (blur)=\"blurEvent()\" (keydown)='keyPress($event)' [autocomplete]=\"autocomplete\" />\n  <validation [elementBase]=\"this\"></validation>\n</div>\n",
                styles: ["input[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button{\n  -webkit-appearance:none;\n  margin:0; }\ninput[type=\"number\"]{\n  -moz-appearance:textfield; }\n"],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: InputNumberComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
InputNumberComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
InputNumberComponent.propDecorators = {
    "label": [{ type: Input },],
    "placeholder": [{ type: Input },],
    "type": [{ type: Input },],
    "customType": [{ type: Input },],
    "disabled": [{ type: Input },],
    "readonly": [{ type: Input },],
    "isLoading": [{ type: Input },],
    "autocomplete": [{ type: Input },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
    "inputElement": [{ type: ViewChild, args: ['inputElement',] },],
    "blur": [{ type: Output },],
};
var identifier$12 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVInputNumberModule = /** @class */ (function () {
    function PMVInputNumberModule() {
    }
    return PMVInputNumberModule;
}());
PMVInputNumberModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    PMVValidationModule,
                    PMVMiniLoadingModule,
                ],
                declarations: [
                    InputNumberComponent,
                ],
                exports: [
                    InputNumberComponent,
                ]
            },] },
];
/** @nocollapse */
PMVInputNumberModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MaskCPFCNPJComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MaskCPFCNPJComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     */
    function MaskCPFCNPJComponent(validators, asyncValidators, ngForm) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.blur = new EventEmitter();
        _this.showCpfMask = true;
        return _this;
    }
    /**
     * @return {?}
     */
    MaskCPFCNPJComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.model.valueChanges.subscribe(function (a) {
            setTimeout(function (_) {
                if (_this.value) {
                    if (_this.value.length < 11) {
                        _this.showCnpjMask = false;
                        _this.showCpfMask = true;
                    }
                    else if (_this.value.length > 11 && _this.value.length < 14) {
                        _this.showCnpjMask = true;
                        _this.showCpfMask = false;
                    }
                    else {
                        if (/^([0-9]{11})$/.test(_this.value)) {
                            _this.showCnpjMask = false;
                            _this.showCpfMask = true;
                        }
                        else if (/^([0-9]{14})$/.test(_this.value)) {
                            _this.showCnpjMask = true;
                            _this.showCpfMask = false;
                        }
                    }
                }
            }, 0);
        });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    MaskCPFCNPJComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        setTimeout(function (_) {
            if (_this.value) {
                if (/^([0-9]{11})$/.test(_this.value)) {
                    _this.showCnpjMask = false;
                    _this.showCpfMask = true;
                }
                else if (/^([0-9]{14})$/.test(_this.value)) {
                    _this.showCnpjMask = true;
                    _this.showCpfMask = false;
                }
            }
        }, 0);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MaskCPFCNPJComponent.prototype.keyPress = function (event) {
        var _this = this;
        setTimeout(function (_) {
            if (_this.value) {
                if (_this.value.length < 11) {
                    _this.showCnpjMask = false;
                    _this.showCpfMask = true;
                    setTimeout(function (_) {
                        _this.cpfMask.focusFunction();
                    }, 0);
                }
                else if (_this.value.length > 11 && _this.value.length < 14) {
                    _this.showCnpjMask = true;
                    _this.showCpfMask = false;
                    setTimeout(function (_) {
                        _this.cnpjMask.focusFunction();
                    }, 0);
                }
            }
        }, 0);
        if (this.showCpfMask && this.value && this.value.toString().length === 11) {
            this.showCnpjMask = true;
            this.showCpfMask = false;
            if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
                this.value += event.key;
                setTimeout(function (_) {
                    _this.cnpjMask.focusFunction();
                }, 0);
            }
        }
        if (this.showCnpjMask && this.value && this.value.toString().length === 11) {
            this.showCnpjMask = false;
            this.showCpfMask = true;
            setTimeout(function (_) {
                _this.cpfMask.focusFunction();
            }, 0);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MaskCPFCNPJComponent.prototype.blurEventCpf = function (event) {
        if (!this.showCnpjMask) {
            if (!/^([0-9]{11})$/.test(this.value) || !event.currentTarget.value) {
                this.showCnpjMask = false;
                this.showCpfMask = true;
            }
            this.blur.emit(event);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MaskCPFCNPJComponent.prototype.blurEventCnpj = function (event) {
        if (!this.showCpfMask) {
            if (!/^([0-9]{14})$/.test(this.value) || !event.currentTarget.value) {
                this.showCnpjMask = false;
                this.showCpfMask = true;
            }
            this.blur.emit(event);
        }
    };
    return MaskCPFCNPJComponent;
}(ElementBase));
MaskCPFCNPJComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-mask-cpf-cnpj',
                template: "<pmv-mask #cpfMask [disabled]=\"disabled\" *ngIf=\"showCpfMask\" [(ngModel)]=\"value\" [label]=\"label || 'CPF/CNPJ'\" mask=\"999.999.999-99?9999\"\n  (keydown)=\"keyPress($event)\" [autoClear]=\"false\" (blur)=\"blurEventCpf($event)\" slotChar=\" \"></pmv-mask>\n<pmv-mask #cnpjMask [disabled]=\"disabled\" *ngIf=\"showCnpjMask\" [(ngModel)]=\"value\" [label]=\"label || 'CPF/CNPJ'\" mask=\"99.999.999/9999-99\"\n  (keyup)=\"keyPress($event)\" [autoClear]=\"false\" (blur)=\"blurEventCnpj($event)\" slotChar=\" \"></pmv-mask>\n",
                styles: [""],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: MaskCPFCNPJComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
MaskCPFCNPJComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
]; };
MaskCPFCNPJComponent.propDecorators = {
    "disabled": [{ type: Input },],
    "required": [{ type: Input },],
    "label": [{ type: Input },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
    "cpfMask": [{ type: ViewChild, args: ['cpfMask',] },],
    "cnpjMask": [{ type: ViewChild, args: ['cnpjMask',] },],
    "blur": [{ type: Output, args: ['blur',] },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVMaskCPFCNPJModule = /** @class */ (function () {
    function PMVMaskCPFCNPJModule() {
    }
    return PMVMaskCPFCNPJModule;
}());
PMVMaskCPFCNPJModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    InputMaskModule,
                    PMVValidationModule,
                    PMVMaskModule,
                ],
                declarations: [
                    MaskCPFCNPJComponent,
                ],
                exports: [
                    MaskCPFCNPJComponent,
                ],
            },] },
];
/** @nocollapse */
PMVMaskCPFCNPJModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SingleFileUploadComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SingleFileUploadComponent, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} ngForm
     * @param {?} sanitizer
     * @param {?} notificationService
     */
    function SingleFileUploadComponent(validators, asyncValidators, ngForm, sanitizer, notificationService) {
        var _this = _super.call(this, validators, asyncValidators, ngForm) || this;
        _this.sanitizer = sanitizer;
        _this.notificationService = notificationService;
        _this._nomeArquivo = null;
        _this.nomeArquivoChange = new EventEmitter();
        _this.download = new EventEmitter();
        _this.identifier = "form-single-file-" + identifier$13++;
        return _this;
    }
    Object.defineProperty(SingleFileUploadComponent.prototype, "nomeArquivo", {
        /**
         * @return {?}
         */
        get: function () { return this._nomeArquivo; },
        /**
         * @param {?} nomeArquivo
         * @return {?}
         */
        set: function (nomeArquivo) {
            if (this._nomeArquivo !== nomeArquivo) {
                this._nomeArquivo = nomeArquivo;
                this.nomeArquivoChange.emit(nomeArquivo);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    SingleFileUploadComponent.prototype.onFileSelect = function (event) {
        var /** @type {?} */ file = event.target.files[0];
        this.value = file;
        if (file) {
            // Validações
            if (this.type && file.type !== this.type) {
                if (this.type == 'application/pdf') {
                    this.notificationService.notifyError('Só é permitido anexar arquivos de extensão PDF');
                    this.inputfile.nativeElement.value = "";
                    return;
                }
                else {
                    this.notificationService.notifyError('Tipo do arquivo inválido!');
                    this.inputfile.nativeElement.value = "";
                    return;
                }
            }
            else if (this.maxSize && file.size > this.maxSize) {
                this.notificationService.notifyError("O anexo n\u00E3o pode exceder " + (this.maxSize / 1000000).toFixed() + "Mb");
                this.inputfile.nativeElement.value = "";
                return;
            }
            // Procedimento
            file.objectURL = this.sanitizer.bypassSecurityTrustUrl((window.URL.createObjectURL(file)));
            this.value = file;
            this.nomeArquivo = file.name;
        }
        else {
            this.value = null;
            this.nomeArquivo = null;
        }
        this.inputfile.nativeElement.value = "";
    };
    /**
     * @return {?}
     */
    SingleFileUploadComponent.prototype.clickEvent = function () {
        this.inputfile.nativeElement.click();
    };
    /**
     * @return {?}
     */
    SingleFileUploadComponent.prototype.downloadEvent = function () {
        this.download.emit({});
    };
    return SingleFileUploadComponent;
}(ElementBase));
SingleFileUploadComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-single-file-upload',
                template: "<div>\n  <label *ngIf=\"label\" [attr.for]=\"identifier\">{{label}}</label>\n  <div>\n    <input style=\"display: inline-block;width: 63%;\" [disabled]=\"true\" type=\"text\" class=\"form-control\" [value]=\"nomeArquivo\"\n    />\n    <input *ngIf=\"!downloadMode || dualMode\" #inputfile style=\"display: inline-block;width: 0px;visibility: hidden;\"\n      type=\"file\" [id]=\"identifier\" [disabled]=\"disabled\" (change)=\"onFileSelect($event)\" />\n    <button *ngIf=\"!downloadMode || dualMode\" style=\"display: inline-block;width: 15%;margin-bottom: 2px;\" type=\"button\" class=\"btn btn-primary\"\n      (click)=\"clickEvent()\" [disabled]=\"disabled\">Selecionar Arquivo</button>\n    <button *ngIf=\"downloadMode || dualMode\" [disabled]=\"!nomeArquivo\" style=\"display: inline-block;width: 15%;margin-bottom: 2px;\" type=\"button\" class=\"btn btn-primary\"\n      (click)=\"downloadEvent()\">Download</button>\n  </div>\n  <validation [elementBase]=\"this\"></validation>\n</div>\n",
                styles: [""],
                animations: animations,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: SingleFileUploadComponent,
                        multi: true,
                    }],
            },] },
];
/** @nocollapse */
SingleFileUploadComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [NG_ASYNC_VALIDATORS,] },] },
    { type: NgForm, decorators: [{ type: Optional },] },
    { type: DomSanitizer, },
    { type: NotificationService, },
]; };
SingleFileUploadComponent.propDecorators = {
    "nomeArquivo": [{ type: Input },],
    "nomeArquivoChange": [{ type: Output },],
    "inputfile": [{ type: ViewChild, args: ['inputfile',] },],
    "disabled": [{ type: Input },],
    "label": [{ type: Input },],
    "type": [{ type: Input },],
    "maxSize": [{ type: Input },],
    "downloadMode": [{ type: Input },],
    "dualMode": [{ type: Input },],
    "download": [{ type: Output },],
    "model": [{ type: ViewChild, args: [NgModel,] },],
};
var identifier$13 = 0;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVSingleFileUploadModule = /** @class */ (function () {
    function PMVSingleFileUploadModule() {
    }
    return PMVSingleFileUploadModule;
}());
PMVSingleFileUploadModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    PMVValidationModule,
                ],
                declarations: [
                    SingleFileUploadComponent,
                ],
                exports: [
                    SingleFileUploadComponent,
                ]
            },] },
];
/** @nocollapse */
PMVSingleFileUploadModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @abstract
 */
var PMVAuthenticationService = /** @class */ (function () {
    function PMVAuthenticationService() {
    }
    return PMVAuthenticationService;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Classe que faz o tratamento de erros global do sistema. Qualquer exceção gerada no sistema que não for tratada, passa
 * por esta classe. Caso o erro seja proveniente do backend, é feito o tratamento apropriado de acordo com o status do
 * erro.
 */
var PMVErrorHandler = /** @class */ (function () {
    /**
     * @param {?} notificationService
     * @param {?} injector
     */
    function PMVErrorHandler(notificationService, injector) {
        this.notificationService = notificationService;
        this.injector = injector;
    }
    Object.defineProperty(PMVErrorHandler.prototype, "authenticationService", {
        /**
         * Retorna o serviço de autenticação a partir do injector do Angular.
         *
         * @return {?} a instância de AuthenticationService provida na aplicação
         */
        get: function () {
            return this.injector.get(PMVAuthenticationService);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Faz o tratamento do erro lançado.
     *
     * @param {?} error erro capturado pelo ErrorHandler
     * @return {?}
     */
    PMVErrorHandler.prototype.handleError = function (error) {
        if (error instanceof HttpErrorResponse
            || (error.error && error.error.erro)) {
            this.handleBackendError(error);
        }
        else {
            throw error;
        }
    };
    /**
     * Faz o tratamento de um erro proveniente da comunicação com o backend do sistema.
     *
     * @param {?} error erro de comunicação Http
     * @return {?}
     */
    PMVErrorHandler.prototype.handleBackendError = function (error) {
        var _this = this;
        if (error.status === 0) {
            this.notificationService.notifyError('Não foi possível se conectar ao servidor.');
            this.authenticationService.logout();
        }
        else {
            var /** @type {?} */ backendError = error.error;
            var /** @type {?} */ message_1 = (backendError ? backendError.erro : null) || this.getDefaultMessage(error.status) || 'Erro Desconhecido';
            message_1.split('</br>').forEach(function (m) {
                _this.notificationService.notifyError(m);
            });
        }
    };
    /**
     * Recupera a mensagem padrão para os determinados status HTTP.
     *
     * @param {?} status status HTTP presente na requisição
     * @return {?} a mensagem associada ao status HTTP
     */
    PMVErrorHandler.prototype.getDefaultMessage = function (status) {
        switch (status) {
            case 401:
                this.authenticationService.logout();
                return 'Usuário não autorizado.';
            case 403:
                return 'Sem registro cadastrado.';
            case 500:
                return 'Erro no servidor.';
        }
    };
    return PMVErrorHandler;
}());
PMVErrorHandler.decorators = [
    { type: Injectable },
];
/** @nocollapse */
PMVErrorHandler.ctorParameters = function () { return [
    { type: NotificationService, },
    { type: Injector, },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ActionEvent = /** @class */ (function () {
    function ActionEvent() {
    }
    return ActionEvent;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Action = /** @class */ (function () {
    function Action() {
    }
    return Action;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Column = /** @class */ (function () {
    function Column() {
    }
    return Column;
}());
var ColumnEditConfig = /** @class */ (function () {
    function ColumnEditConfig() {
    }
    return ColumnEditConfig;
}());
var ColumnEditTextConfig = /** @class */ (function () {
    function ColumnEditTextConfig() {
    }
    return ColumnEditTextConfig;
}());
var ColumnEditDropdownConfig = /** @class */ (function () {
    function ColumnEditDropdownConfig() {
    }
    return ColumnEditDropdownConfig;
}());
var ColumnEditDecimalConfig = /** @class */ (function () {
    function ColumnEditDecimalConfig() {
    }
    return ColumnEditDecimalConfig;
}());
var ColumnCheckboxConfig = /** @class */ (function () {
    function ColumnCheckboxConfig() {
    }
    return ColumnCheckboxConfig;
}());
var ColumnDatepickerConfig = /** @class */ (function () {
    function ColumnDatepickerConfig() {
    }
    return ColumnDatepickerConfig;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SelectItem = /** @class */ (function () {
    function SelectItem() {
    }
    return SelectItem;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {number} */
var FormType = {
    create: 1,
    update: 2,
    view: 3,
};
FormType[FormType.create] = "create";
FormType[FormType.update] = "update";
FormType[FormType.view] = "view";
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var Combobox = /** @class */ (function () {
    function Combobox() {
    }
    return Combobox;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ResultGetPaged = /** @class */ (function () {
    function ResultGetPaged() {
    }
    return ResultGetPaged;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Cria um objeto de rotas padrão para as telas de CRUD dos sistemas da PMV cujo módulo é carregado via lazy loading. As
 * telas de CRUD são compostas por dois componentes - um para a tela de listar e outro para a tela de detalhes. A tela
 * de detalhes pode ser aberta com três configurações diferentes, de acordo com o FormType passado no objeto data da
 * rota: incluir, editar e visualizar.
 *
 * @param {?} mainComponent componente principal da rota (geralmente o componente de listar)
 * @param {?} detailComponent componente de detalhes da rota (geralmente o componente com o formulário)
 * @param {?=} includeRoute nome da rota de incluir (opcional, caso não seja passado, é utilizado "incluir")
 * @param {?=} editRoute nome da rota de editar (opcional, caso não seja passado, é utilizado "editar/:id")
 * @param {?=} detailRoute nome da rota de detalhe (opcional, caso não seja passado, é utilizado "detalhe/:id")
 * @return {?} um objeto Routes com todas as rotas do CRUD configuradas e utilizando o FormType associado
 */
function createCRUDRoutes(mainComponent, detailComponent, includeRoute, editRoute, detailRoute) {
    return [
        { path: '', component: mainComponent },
        { path: includeRoute || 'incluir', component: detailComponent, data: { formType: FormType.create } },
        { path: editRoute || 'editar/:id', component: detailComponent, data: { formType: FormType.update } },
        { path: detailRoute || 'detalhe/:id', component: detailComponent, data: { formType: FormType.view } },
    ];
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} page
 * @param {?} url
 * @return {?}
 */
function page(page, url) {
    var /** @type {?} */ concatChar = url.indexOf('?') === -1 ? '?' : '&';
    return "" + url + concatChar + "pg=" + page;
}
/**
 * @param {?} page
 * @param {?} itemsPerPage
 * @param {?} url
 * @return {?}
 */
function pageWith(page, itemsPerPage, url) {
    var /** @type {?} */ concatChar = url.indexOf('?') === -1 ? '?' : '&';
    return "" + url + concatChar + "pg=" + page + "&itensPg=" + itemsPerPage;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @record
 */
/**
 * @param {?} filter
 * @param {?} url
 * @param {?=} options
 * @return {?}
 */
function filterBy(filter, url, options) {
    var /** @type {?} */ recursive = options && options.recursive;
    var /** @type {?} */ dateSeparator = options && options.dateSeparator || '-';
    var /** @type {?} */ joinParams = function (obj, prepend) {
        var /** @type {?} */ arr = [];
        Object.keys(obj)
            .filter(function (key) {
            var /** @type {?} */ value = obj[key];
            return value !== null && value !== undefined && (value instanceof Date || typeof value !== 'object' || recursive);
        })
            .forEach(function (key) {
            var /** @type {?} */ value = obj[key];
            var /** @type {?} */ str;
            if (typeof value === 'object') {
                str = value instanceof Date
                    ? "" + (prepend || '') + key + "=" + dateToString(value, dateSeparator)
                    : joinParams(value, "" + (prepend || '') + key + ".");
            }
            else {
                str = "" + (prepend || '') + key + "=" + value;
            }
            if (str) {
                arr.push(str);
            }
        });
        return arr.length ? arr.join('&') : null;
    };
    if (!filter || typeof filter !== 'object') {
        return url;
    }
    var /** @type {?} */ filterUrl = joinParams(filter);
    if (!filterUrl) {
        return url;
    }
    var /** @type {?} */ concatChar = url.indexOf('?') === -1 ? '?' : '&';
    return "" + url + concatChar + filterUrl;
}
/**
 * @param {?} date
 * @param {?} separator
 * @return {?}
 */
function dateToString(date, separator) {
    return [
        ('0' + (date.getMonth() + 1)).slice(-2),
        ('0' + date.getDate()).slice(-2),
        date.getFullYear()
    ].join(separator);
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} num
 * @param {?} c
 * @return {?}
 */
function numberExtensive(num, c) {
    var /** @type {?} */ ex = [
        ["zero", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove", "dez", "onze", "doze", "treze", "quatorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"],
        ["dez", "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"],
        ["cem", "cento", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"],
        ["mil", "milhão", "bilhão", "trilhão", "quadrilhão", "quintilhão", "sextilhão", "setilhão", "octilhão", "nonilhão", "decilhão", "undecilhão", "dodecilhão", "tredecilhão", "quatrodecilhão", "quindecilhão", "sedecilhão", "septendecilhão", "octencilhão", "nonencilhão"]
    ];
    var /** @type {?} */ a, /** @type {?} */ n, /** @type {?} */ v, /** @type {?} */ i, /** @type {?} */ n = (num.replace(c ? /[^,\d]/g : /\D/g, "").split(",")), /** @type {?} */ e = " e ", /** @type {?} */ $ = "real", /** @type {?} */ d = "centavo", /** @type {?} */ sl;
    for (var /** @type {?} */ f = n.length - 1, /** @type {?} */ l, /** @type {?} */ j = -1, /** @type {?} */ r = [], /** @type {?} */ s = [], /** @type {?} */ t = ""; ++j <= f; s = []) {
        j && (n[j] = (((".") + n[j]) * 1).toFixed(2).slice(2));
        if (!(a = (v = n[j]).slice((l = v.length) % 3).match(/\d{3}/g), v = l % 3 ? [v.slice(0, l % 3)] : [], v = a ? v.concat(a) : v).length)
            continue;
        for (a = -1, l = v.length; ++a < l; t = "") {
            if (!(i = v[a] * 1))
                continue;
            i % 100 < 20 && (t += ex[0][i % 100]) ||
                i % 100 + 1 && (t += ex[1][(i % 100 / 10 >> 0) - 1] + (i % 10 ? e + ex[0][i % 10] : ""));
            s.push((i < 100 ? t : !(i % 100) ? ex[2][i == 100 ? 0 : i / 100 >> 0] : (ex[2][i / 100 >> 0] + e + t)) +
                ((t = /** @type {?} */ ((l - a - 2))) > -1 ? " " + (i > 1 && /** @type {?} */ (t) > 0 ? ex[3][t].replace("ão", "ões") : ex[3][t]) : ""));
        }
        a = ((sl = s.length) > 1 ? (a = s.pop(), s.join(" ") + e + a) : s.join("") || ((!j && (n[j + 1] * 1 > 0) || r.length) ? "" : ex[0][0]));
        a && r.push(a + (c ? (" " + (v.join("") * 1 > 1 ? j ? d + "s" : (/0{6,}$/.test(n[0]) ? "de " : "") + $.replace("l", "is") : j ? d : $)) : ""));
    }
    return r.join(e);
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} strCPF
 * @return {?}
 */
function validaCPF(strCPF) {
    var /** @type {?} */ soma;
    var /** @type {?} */ resto;
    soma = 0;
    if (strCPF == "00000000000")
        return false;
    for (var /** @type {?} */ i = 1; i <= 9; i++)
        soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;
    if ((resto == 10) || (resto == 11))
        resto = 0;
    if (resto != parseInt(strCPF.substring(9, 10)))
        return false;
    soma = 0;
    for (var /** @type {?} */ i = 1; i <= 10; i++)
        soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;
    if ((resto == 10) || (resto == 11))
        resto = 0;
    if (resto != parseInt(strCPF.substring(10, 11)))
        return false;
    return true;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function cpfCnpjMask(value) {
    if (value.length === 11) {
        return value.substring(0, 3) + '.' + value.substring(3, 6) + '.' + value.substring(6, 9) + '-' + value.substring(9);
    }
    else if (value.length === 14) {
        return value.substring(0, 2) + '.' + value.substring(2, 5) + '.' + value.substring(5, 8) + '/' + value.substring(8, 12) + '-' + value.substring(12);
    }
    return '';
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} err
 * @return {?}
 */
function parseErrorBlob(err) {
    var /** @type {?} */ reader = new FileReader();
    var /** @type {?} */ obs = Observable$1.create(function (observer) {
        reader.onloadend = function (e) {
            observer.error(JSON.parse(reader.result));
            observer.complete();
        };
    });
    reader.readAsText(err.error);
    return obs;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Classe que define o comportamento padrão de uma tela de detalhes. As telas de detalhes dos sistemas contém
 * informações relacionadas aos formulários das telas e dados que indicam o tipo de exibição do formulário.
 * @abstract
 */
var DetailComponent = /** @class */ (function () {
    /**
     * @param {?} activatedRoute
     */
    function DetailComponent(activatedRoute) {
        this.setupFormType(activatedRoute);
    }
    /**
     * Determina o tipo do formulário através dos dados passados na rota ativa.
     *
     * @param {?} activatedRoute dados da rota ativa
     * @return {?}
     */
    DetailComponent.prototype.setupFormType = function (activatedRoute) {
        if (activatedRoute) {
            this.formType = activatedRoute.snapshot.data["formType"];
        }
        if (!this.formType) {
            console.warn('Tipo de formulário não foi definido para o componente!');
        }
    };
    Object.defineProperty(DetailComponent.prototype, "isFormTypeCreate", {
        /**
         * Determina se o formulário é do tipo de criação de dados.
         *
         * @return {?} true se o formulário for do tipo de criação e false caso contrário
         */
        get: function () {
            return this.formType === FormType.create;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailComponent.prototype, "isFormTypeUpdate", {
        /**
         * Determina se o formulário é do tipo de edição de dados.
         *
         * @return {?} true se o formulário for do tipo de edição e false caso contrário
         */
        get: function () {
            return this.formType === FormType.update;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailComponent.prototype, "isFormTypeView", {
        /**
         * Determina se o formulário é do tipo de visualização de dados.
         *
         * @return {?} true se o formulário for do tipo de visualização e false caso contrário
         */
        get: function () {
            return this.formType === FormType.view;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Método listener do evento de submissão do formulário da tela. Normalmente é acessado via HTML fazendo o bind do
     * evento submit de um elemento <form> e passando a variável de template associada ao ngForm do formulário. Exemplo de
     * uso:
     *     <form #form="ngForm" (submit)="onSubmit(form)">
     *
     * @param {?} form instância do NgForm associada ao formulário que está sendo submetido
     * @return {?}
     */
    DetailComponent.prototype.onSubmit = function (form) {
        if (form && form instanceof NgForm) {
            if (form.valid) {
                this.handleValidSubmission(form);
            }
            else {
                this.handleInvalidSubmission(form);
            }
        }
        else {
            console.warn('\n'
                + 'Por favor, passe uma instância de NgForm para o método de submissão do formulário.\n'
                + 'Exemplo de uso:\n'
                + '    <form #form="ngForm" (submit)="onSubmit(form)">\n');
        }
    };
    /**
     * Faz o tratamento de uma submissão inválida do formulário.
     *
     * @param {?} form instância do NgForm associada ao formulário que está sendo submetido
     * @return {?}
     */
    DetailComponent.prototype.handleInvalidSubmission = function (form) {
        // implementação padrão vazia
    };
    return DetailComponent;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var AuthenticationData = /** @class */ (function () {
    function AuthenticationData() {
    }
    return AuthenticationData;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Tela de login do sistema.
 */
var PMVAuthenticationComponent = /** @class */ (function () {
    /**
     * @param {?} authenticationService
     * @param {?} router
     */
    function PMVAuthenticationComponent(authenticationService, router) {
        this.authenticationService = authenticationService;
        this.router = router;
        this.authenticationData = new AuthenticationData();
    }
    /**
     * @return {?}
     */
    PMVAuthenticationComponent.prototype.ngOnInit = function () {
        this.redirectToHomeIfLoggedIn();
    };
    /**
     * Redireciona o usuário para a tela Home caso já esteja autenticado no sistema.
     * @return {?}
     */
    PMVAuthenticationComponent.prototype.redirectToHomeIfLoggedIn = function () {
        if (this.authenticationService.isUserLoggedIn()) {
            this.redirectToHome();
        }
    };
    /**
     * Listener do evento de submissão do formulário.
     * @param {?} isValid
     * @return {?}
     */
    PMVAuthenticationComponent.prototype.onSubmit = function (isValid) {
        var _this = this;
        if (isValid) {
            this.authenticating = true;
            this.authenticationService.login(this.authenticationData).subscribe(function (success) {
                _this.redirectToHome();
                _this.authenticating = false;
            }, function (error) {
                _this.authenticating = false;
                throw error;
            });
        }
    };
    /**
     * Redireciona o usuário para a tela Home.
     * @return {?}
     */
    PMVAuthenticationComponent.prototype.redirectToHome = function () {
        this.router.navigate(['home']);
    };
    return PMVAuthenticationComponent;
}());
PMVAuthenticationComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-authentication',
                template: "<section role=\"main\">\n  <form #form=\"ngForm\" (submit)=\"onSubmit(form.valid)\" validateOnSubmit id=\"login-form\" class=\"form-signin\" role=\"form\">\n    <h2 class=\"form-signin-heading\">Prefeitura Municipal de Vit\u00F3ria</h2>\n    <div class=\"form-signin\" role=\"form\">\n      <div [ngClass]=\"{'has-error': error}\" class=\"form-group username\">\n        <pmv-input-text [(ngModel)]=\"authenticationData.username\" name=\"username\"\n          placeholder=\"Usu\u00E1rio\"\n        ></pmv-input-text>\n      </div>\n      <div [ngClass]=\"{'has-error': error}\" class=\"form-group password\">\n        <pmv-input-text [(ngModel)]=\"authenticationData.password\" name=\"password\"\n          placeholder=\"Senha\" type=\"password\"\n        ></pmv-input-text>\n      </div>\n      <button class=\"btn btn-lg btn-primary btn-block\" type=\"submit\" style=\"position: relative\" [disabled]=\"authenticating\">\n        <span class=\"fa fa-spinner fa-spin pull-left\" style=\"position: absolute; left: 13px; top: 13px;\" *ngIf=\"authenticating\"></span>\n        Autenticar\n      </button>\n    </div>\n  </form>\n</section>\n",
            },] },
];
/** @nocollapse */
PMVAuthenticationComponent.ctorParameters = function () { return [
    { type: PMVAuthenticationService, },
    { type: Router, },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Guarda de proteção das rotas internas do sistema. Só permite o acesso às rotas caso o usuário esteja autenticado no
 * sistema.
 */
var PMVAuthenticationGuard = /** @class */ (function () {
    /**
     * @param {?} authenticationService
     * @param {?} router
     */
    function PMVAuthenticationGuard(authenticationService, router) {
        this.authenticationService = authenticationService;
        this.router = router;
    }
    /**
     * Determina se o usuário pode acessar a próxima rota ou não, dependendo do estado de sua autenticação no sistema.
     *
     * @param {?} next próxima rota a ser ativada ou não
     * @param {?} state estado da rota corrente
     * @return {?} true caso o a rota possa ser ativada e false caso contrário
     */
    PMVAuthenticationGuard.prototype.canActivateChild = function (next, state$$1) {
        var /** @type {?} */ canActivate = this.authenticationService.isUserLoggedIn();
        if (!canActivate) {
            this.redirectToLogin();
        }
        return canActivate;
    };
    /**
     * Redireciona o usuário para a tela de login.
     * @return {?}
     */
    PMVAuthenticationGuard.prototype.redirectToLogin = function () {
        this.router.navigate(['login']);
    };
    return PMVAuthenticationGuard;
}());
PMVAuthenticationGuard.decorators = [
    { type: Injectable },
];
/** @nocollapse */
PMVAuthenticationGuard.ctorParameters = function () { return [
    { type: PMVAuthenticationService, },
    { type: Router, },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Serviço de autenticação do sistema. Controla o acesso do usuário às funcionalidades do sistema e faz o controle das
 * suas informações de acesso.
 */
var PMVDefaultAuthenticationService = /** @class */ (function (_super) {
    tslib_1.__extends(PMVDefaultAuthenticationService, _super);
    /**
     * @param {?} httpClient
     * @param {?} router
     * @param {?} localStorageService
     */
    function PMVDefaultAuthenticationService(httpClient, router, localStorageService) {
        var _this = _super.call(this) || this;
        _this.httpClient = httpClient;
        _this.router = router;
        _this.localStorageService = localStorageService;
        _this.authenticationSubject = new Subject$1();
        _this.localStorageKey = 'pmv.authenticatedUser';
        _this.currentUser = _this.localStorageService.getItem(_this.localStorageKey) || null;
        return _this;
    }
    /**
     * Faz a autenticação do usuário no sistema e salva os dados na sessão.
     *
     * @param {?} authData dados de autenticação
     * @return {?} um Observable que retorna um booleano indicando se a operação foi executada com sucesso
     */
    PMVDefaultAuthenticationService.prototype.login = function (authData) {
        var _this = this;
        return this.httpClient.post(this.getLoginUrl(), authData).pipe(map(function (profile) {
            if (profile && profile.authenticated) {
                _this.currentUser = profile;
                _this.localStorageService.setItem(_this.localStorageKey, profile);
                _this.authenticationSubject.next(true);
                return true;
            }
            return false;
        }));
    };
    /**
     * Faz o logout do usuário no sistema e limpa os dados na sessão.
     * @return {?}
     */
    PMVDefaultAuthenticationService.prototype.logout = function () {
        this.currentUser = null;
        this.localStorageService.removeItem(this.localStorageKey);
        this.authenticationSubject.next(false);
        this.redirectToLoginPage();
    };
    /**
     * Recupear o caminho do serviço de login no backend a ser usado na requisição.
     *
     * @return {?} a string do serviço de login
     */
    PMVDefaultAuthenticationService.prototype.getLoginUrl = function () {
        return '/login';
    };
    /**
     * Determina se o usuário está autenticado no sistema ou não.
     *
     * @return {?} true caso o usuário esteja autenticado e false caso contrário
     */
    PMVDefaultAuthenticationService.prototype.isUserLoggedIn = function () {
        return Boolean(this.getProfile());
    };
    /**
     * Recupera o Observable associado ao emissor de eventos de login e logout do sistema.
     *
     * @return {?} um Observable que envia aos subscribers o status de autenticação do usuário sempre que o mesmo fizer login
     * e logout no sistema
     */
    PMVDefaultAuthenticationService.prototype.listen = function () {
        return this.authenticationSubject.asObservable();
    };
    /**
     * Recupera o perfil do usuário autenticado no sistema.
     *
     * @return {?} o perfil do usuário autenticado no sistema ou null caso o usuário não esteja autenticado
     */
    PMVDefaultAuthenticationService.prototype.getProfile = function () {
        return this.currentUser || null;
    };
    /**
     * Recupera o token do usuário autenticado no sistema.
     *
     * @return {?} o token do usuário autenticado ou null caso o usuário não esteja autenticado
     */
    PMVDefaultAuthenticationService.prototype.getToken = function () {
        return this.currentUser ? this.currentUser.accessToken : null;
    };
    /**
     * Redireciona o usuário para a tela de login do sistema.
     * @return {?}
     */
    PMVDefaultAuthenticationService.prototype.redirectToLoginPage = function () {
        this.router.navigate(['login']);
    };
    return PMVDefaultAuthenticationService;
}(PMVAuthenticationService));
PMVDefaultAuthenticationService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
PMVDefaultAuthenticationService.ctorParameters = function () { return [
    { type: HttpClient, },
    { type: Router, },
    { type: LocalStorageService, },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVAuthenticationModule = /** @class */ (function () {
    function PMVAuthenticationModule() {
    }
    /**
     * @param {?=} config
     * @return {?}
     */
    PMVAuthenticationModule.forRoot = function (config) {
        return {
            ngModule: PMVAuthenticationModule,
            providers: [
                { provide: PMVAuthenticationService, useClass: config && config.customAuthenticationService || PMVDefaultAuthenticationService },
                PMVAuthenticationGuard,
            ]
        };
    };
    return PMVAuthenticationModule;
}());
PMVAuthenticationModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    PMVInputTextModule,
                ],
                declarations: [
                    PMVAuthenticationComponent,
                ],
                exports: [
                    PMVAuthenticationComponent,
                ],
            },] },
];
/** @nocollapse */
PMVAuthenticationModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVAuthenticationConfig = /** @class */ (function () {
    function PMVAuthenticationConfig() {
    }
    return PMVAuthenticationConfig;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var AuthenticationProfile = /** @class */ (function () {
    function AuthenticationProfile() {
    }
    return AuthenticationProfile;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SERVER_PATH_TOKEN = new InjectionToken('pmv.serverPath');
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVInterceptorsModule = /** @class */ (function () {
    function PMVInterceptorsModule() {
    }
    /**
     * @param {?} serverPath
     * @return {?}
     */
    PMVInterceptorsModule.forRoot = function (serverPath) {
        return {
            ngModule: PMVInterceptorsModule,
            providers: [
                { provide: SERVER_PATH_TOKEN, useValue: serverPath },
            ]
        };
    };
    return PMVInterceptorsModule;
}());
PMVInterceptorsModule.decorators = [
    { type: NgModule, args: [{},] },
];
/** @nocollapse */
PMVInterceptorsModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Interceptador de requisições HTTP que preenche a URL padrão dos serviços no backend.
 */
var PMVServerPathInterceptor = /** @class */ (function () {
    /**
     * @param {?} serverPath
     */
    function PMVServerPathInterceptor(serverPath) {
        this.serverPath = serverPath;
    }
    /**
     * Método interceptador das requisições. Recebe a requisição original, faz a alteração e a encaminha na fila de
     * interceptadores.
     *
     * @param {?} req requisição original
     * @param {?} next ponteiro para o próximo estado da requisição na fila de interceptadores
     * @return {?} próximo evento da fila de interceptadores
     */
    PMVServerPathInterceptor.prototype.intercept = function (req, next) {
        var /** @type {?} */ urlReq = req.clone({ url: this.createURL(this.serverPath, req.url) });
        return next.handle(urlReq);
    };
    /**
     * Cria a URL final das requisições do sistema.
     *
     * @param {?} serverPath caminho de acesso ao servidor do backend
     * @param {?} reqURL URL da requisição específica
     * @return {?} a URL completa a ser utilizada
     */
    PMVServerPathInterceptor.prototype.createURL = function (serverPath, reqURL) {
        serverPath = serverPath.endsWith('/') ? serverPath.slice(0, -1) : serverPath;
        reqURL = reqURL.startsWith('/') ? reqURL : "/" + reqURL;
        return serverPath + reqURL;
    };
    return PMVServerPathInterceptor;
}());
PMVServerPathInterceptor.decorators = [
    { type: Injectable },
];
/** @nocollapse */
PMVServerPathInterceptor.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: Inject, args: [SERVER_PATH_TOKEN,] },] },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Interceptador de requisições HTTP que coloca os cabeçalhos padrão da aplicação para usuários autenticados.
 */
var PMVHeadersInterceptor = /** @class */ (function () {
    /**
     * @param {?} injector
     */
    function PMVHeadersInterceptor(injector) {
        this.injector = injector;
    }
    Object.defineProperty(PMVHeadersInterceptor.prototype, "authenticationService", {
        /**
         * Retorna o serviço de autenticação a partir do injector do Angular.
         *
         * @return {?} a instância de AuthenticationService provida na aplicação
         */
        get: function () {
            return this.injector.get(PMVAuthenticationService);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Método interceptador das requisições. Recebe a requisição original, faz a alteração e a encaminha na fila de
     * interceptadores.
     *
     * @param {?} req requisição original
     * @param {?} next ponteiro para o próximo estado da requisição na fila de interceptadores
     * @return {?} próximo evento da fila de interceptadores
     */
    PMVHeadersInterceptor.prototype.intercept = function (req, next) {
        var /** @type {?} */ headers = req.headers;
        headers = this.setAuthorization(headers);
        headers = this.setContentType(headers);
        headers = this.setCodPessoa(headers);
        var /** @type {?} */ authReq = req.clone({ headers: headers });
        return next.handle(authReq);
    };
    /**
     * Configura os cabeçalhos de autorização do usuário no sistema.
     *
     * @param {?} headers cabeçalhos a serem alterados com os dados de autorização
     * @return {?} os cabeçalhos com os dados de autorização caso o usuário esteja autenticado
     */
    PMVHeadersInterceptor.prototype.setAuthorization = function (headers) {
        var /** @type {?} */ token = this.authenticationService.getToken();
        if (token) {
            headers = headers.set('Authorization', "Bearer " + token);
        }
        return headers;
    };
    /**
     * Configura o codPessoa do usuário nos cabeçalhos do sistema.
     *
     * @param {?} headers cabeçalhos a serem alterados com os dados de autorização
     * @return {?} os cabeçalhos com o codPessoa do usuário esteja autenticado
     */
    PMVHeadersInterceptor.prototype.setCodPessoa = function (headers) {
        var /** @type {?} */ profile = this.authenticationService.getProfile();
        if (profile && profile.codPessoa) {
            headers = headers.set('codPessoa', profile.codPessoa.toString());
        }
        return headers;
    };
    /**
     * Configura os cabeçalhos de conteúdo da requisição. Caso a requisição já contenha os cabeçalhos de tipo de conteúdo,
     * os mesmos serão mantidos. Caso os cabeçalhos passados estejam inválidos, os mesmos são removidos da requisição.
     * Caso a requisição não contenha os cabeçalhos de tipo de conteúdo, o tipo 'application/json' é passado por
     * padrão.
     *
     * @param {?} headers cabeçalhos a serem alterados com os dados de tipo de conteúdo
     * @return {?} os cabeçalhos com os dados de tipo de conteúdo
     */
    PMVHeadersInterceptor.prototype.setContentType = function (headers) {
        var /** @type {?} */ contentTypeHeaders = headers.getAll('Content-Type');
        if (!contentTypeHeaders) {
            headers = headers.set('Content-Type', 'application/json');
        }
        else if (contentTypeHeaders[0] === '') {
            headers = headers.delete('Content-Type');
        }
        return headers;
    };
    return PMVHeadersInterceptor;
}());
PMVHeadersInterceptor.decorators = [
    { type: Injectable },
];
/** @nocollapse */
PMVHeadersInterceptor.ctorParameters = function () { return [
    { type: Injector, },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Serviço de controle dos itens do menu de navegação do sistema.
 */
var NavigationService = /** @class */ (function () {
    function NavigationService() {
        this.navItems = [];
        this.navItemsSubject = new Subject$1();
    }
    /**
     * Recupera os itens do menu de navegação do sistema.
     *
     * @return {?} os itens do menu de navegação do sistema
     */
    NavigationService.prototype.getNavItems = function () {
        return this.navItems;
    };
    /**
     * Atribui os determinados itens do menu de navegação.
     *
     * @param {?} navItems itens do menu de navegação atribuídos
     * @return {?}
     */
    NavigationService.prototype.setNavItems = function (navItems) {
        this.navItems = navItems;
        this.navItemsSubject.next(navItems);
    };
    /**
     * Limpa os itens de navegação salvos.
     * @return {?}
     */
    NavigationService.prototype.clearNavItems = function () {
        this.navItems = [];
        this.navItemsSubject.next([]);
    };
    /**
     * Recupera o Observable associado ao Subject dos itens do menu de navegação para acompanhar os eventos de alteração
     * dos mesmos.
     *
     * @return {?} o Observable que emite os eventos de mudança dos itens do menu de navegação do sistema
     */
    NavigationService.prototype.listen = function () {
        return this.navItemsSubject.asObservable();
    };
    return NavigationService;
}());
NavigationService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
NavigationService.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVHeaderComponent = /** @class */ (function () {
    /**
     * @param {?} authenticationService
     * @param {?} titleService
     */
    function PMVHeaderComponent(authenticationService, titleService) {
        this.authenticationService = authenticationService;
        this.titleService = titleService;
    }
    /**
     * @return {?}
     */
    PMVHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isUserLoggedIn = this.authenticationService.isUserLoggedIn();
        this.authenticationService.listen().subscribe(function (isUserLoggedIn) {
            _this.isUserLoggedIn = isUserLoggedIn;
        });
        this.title = this.title;
        this.version = "v " + this.version;
        this.titleService.setTitle(this.title);
    };
    return PMVHeaderComponent;
}());
PMVHeaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-header',
                template: "<header role=\"banner\" class=\"topo-pmv\">\n  <div class=\"container-fluid\"> </div>\n</header>\n<header class=\"topo-cabecalho\">\n  <div class=\"container-fluid\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <ng-container *ngTemplateOutlet=\"headerTemplate || defaultTemplate\"></ng-container>\n      </div>\n    </div>\n  </div>\n  <pmv-navigation *ngIf=\"isUserLoggedIn\"></pmv-navigation>\n</header>\n<ng-template #defaultTemplate>\n  <div [ngClass]=\"{'col-sm-7': bigTitle, 'col-sm-5': !bigTitle}\" class=\"col-xs-11 title\">\n    <h1>\n      <a [routerLink]=\"['home']\">{{ title }}</a>\n    </h1>\n    <p class=\"label-versao\">{{ version }}</p>\n  </div>\n  <div [ngClass]=\"{'col-sm-1': bigTitle, 'col-sm-3': !bigTitle}\" class=\"col-xs-12\">\n    <pmv-idle-timer *ngIf=\"isUserLoggedIn && timeLogout\" [timeLogout]=\"timeLogout\"></pmv-idle-timer>\n  </div>\n  <div class=\"col-sm-4 col-xs-12\" *ngIf=\"isUserLoggedIn\">\n    <ng-content></ng-content>\n  </div>\n</ng-template>\n",
                styles: [""],
            },] },
];
/** @nocollapse */
PMVHeaderComponent.ctorParameters = function () { return [
    { type: PMVAuthenticationService, },
    { type: Title, },
]; };
PMVHeaderComponent.propDecorators = {
    "title": [{ type: Input },],
    "bigTitle": [{ type: Input },],
    "version": [{ type: Input },],
    "timeLogout": [{ type: Input },],
    "headerTemplate": [{ type: Input },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVFooterComponent = /** @class */ (function () {
    function PMVFooterComponent() {
    }
    return PMVFooterComponent;
}());
PMVFooterComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-footer',
                template: "<footer id=\"footer\" class=\"rodext\" role=\"contentinfo\">\n  <div class=\"container\">\n    <address>\n    \u00A9 SUBTI - Subsecretaria de Tecnologia da Informa\u00E7\u00E3o<br />\n    Rua Francisco Rubim, 169, Bento Ferreira, Vit\u00F3ria, ES. CEP 29050-680\n    </address>\n  </div>\n</footer>\n",
                styles: ["#footer{\n  background-color:#002146; }\n"],
            },] },
];
/** @nocollapse */
PMVFooterComponent.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVNavigationComponent = /** @class */ (function () {
    /**
     * @param {?} navigationService
     */
    function PMVNavigationComponent(navigationService) {
        this.navigationService = navigationService;
        this.navItems = [];
    }
    /**
     * @return {?}
     */
    PMVNavigationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.navItems = this.navigationService.getNavItems();
        this.navigationServiceSubscription = this.navigationService.listen().subscribe(function (navItems) {
            _this.navItems = navItems;
        });
    };
    /**
     * @return {?}
     */
    PMVNavigationComponent.prototype.ngOnDestroy = function () {
        if (this.navigationServiceSubscription) {
            this.navigationServiceSubscription.unsubscribe();
        }
    };
    return PMVNavigationComponent;
}());
PMVNavigationComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-navigation',
                template: "<nav class=\"navbar navbar-default\" role=\"navigation\">\n  <div class=\"navbar-header\">\n    <button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\".main-menu\" aria-expanded=\"false\" aria-controls=\"navbar\"> <span class=\"sr-only\">Navega\u00E7\u00E3o</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> </button>\n  </div>\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"main-menu collapse navbar-collapse\">\n          <ul id=\"irmenu\" class=\"nav navbar-nav\">\n            <li pmv-nav-item *ngFor=\"let item of navItems\" [item]=\"item\"></li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n</nav>\n",
                styles: [""]
            },] },
];
/** @nocollapse */
PMVNavigationComponent.ctorParameters = function () { return [
    { type: NavigationService, },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Modelo de um item do menu de navegação da aplicação.
 */
var NavItem = /** @class */ (function () {
    function NavItem() {
    }
    return NavItem;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVNavItemComponent = /** @class */ (function () {
    function PMVNavItemComponent() {
    }
    return PMVNavItemComponent;
}());
PMVNavItemComponent.decorators = [
    { type: Component, args: [{
                selector: 'li[pmv-nav-item]',
                template: "<ng-container *ngIf=\"item.children; else noSubDrop\">\n  <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-expanded=\"false\">{{ item.label }}\n    <span class=\"caret\"></span>\n  </a>\n  <ul class=\"dropdown-menu sub-drop\" role=\"menu\">\n    <li *ngFor=\"let subItem of item.children\" [class.dropdown-submenu]=\"subItem.children\">\n      <ng-container *ngIf=\"subItem.children; else noSubSubDrop\">\n        <a href=\"#\" class=\"sub-start\">{{ subItem.label }}\n          <span class=\"caret\"></span>\n        </a>\n        <ul class=\"dropdown-menu sub-sub-drop\">\n          <li *ngFor=\"let subSubItem of subItem.children\">\n            <a [routerLink]=\"subSubItem.routerLink\" (click)=\"subSubItem.command ? subSubItem.command($event, subSubItem) : false\">{{ subSubItem.label }}</a>\n          </li>\n        </ul>\n      </ng-container>\n      <ng-template #noSubSubDrop>\n        <a [routerLink]=\"subItem.routerLink\" (click)=\"subItem.command ? subItem.command($event, subItem) : false\">{{ subItem.label }}</a>\n      </ng-template>\n    </li>\n  </ul>\n</ng-container>\n<ng-template #noSubDrop>\n  <a [routerLink]=\"item.routerLink\" (click)=\"item.command ? item.command($event, item) : false\">{{ item.label }}</a>\n</ng-template>\n",
                styles: [""]
            },] },
];
/** @nocollapse */
PMVNavItemComponent.ctorParameters = function () { return []; };
PMVNavItemComponent.propDecorators = {
    "item": [{ type: Input },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVProfileComponent = /** @class */ (function () {
    /**
     * @param {?} authenticationService
     */
    function PMVProfileComponent(authenticationService) {
        this.authenticationService = authenticationService;
    }
    /**
     * @return {?}
     */
    PMVProfileComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setUsername();
        this.authenticationService.listen().subscribe(function (_) { return _this.setUsername(); });
    };
    /**
     * @return {?}
     */
    PMVProfileComponent.prototype.setUsername = function () {
        var /** @type {?} */ profile = this.authenticationService.getProfile();
        this.username = profile ? profile.username : null;
    };
    /**
     * @return {?}
     */
    PMVProfileComponent.prototype.logout = function () {
        this.authenticationService.logout();
    };
    return PMVProfileComponent;
}());
PMVProfileComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-profile',
                template: "<div class=\"navbar-header pull-right\">\n  <div class=\"dropdown drop-perfil\">\n    <button class=\"btn btn-default dropdown-toggle\" type=\"button\" id=\"dropdownMenu1\" data-toggle=\"dropdown\" aria-expanded=\"false\">\n    <span class=\"glyphicon glyphicon-user\"></span>\n    <label>{{ username }}</label>\n    <span class=\"glyphicon glyphicon-cog\"></span>\n    </button>\n    <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dropdownMenu1\">\n      <!--\n      <li role=\"presentation\">\n        <a role=\"menuitem\" tabindex=\"-1\" href=\"#\">Configura\u00E7\u00F5es do Perfil</a>\n      </li>\n      <li role=\"presentation\">\n        <a role=\"menuitem\" tabindex=\"-1\" href=\"#\">Temas</a>\n      </li>\n      <li role=\"presentation\" class=\"divider\"></li>\n      <li role=\"presentation\">\n        <a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><span class=\"glyphicon glyphicon-comment\"></span><strong> ABRIR CHAMADO</strong></a>\n      </li>\n      <li role=\"presentation\">\n        <a role=\"menuitem\" tabindex=\"-1\" href=\"#\"><span class=\"glyphicon glyphicon-question-sign\"></span><strong> AJUDA</strong></a>\n      </li>\n      <li role=\"presentation\" class=\"divider\"></li>\n      -->\n      <ng-content></ng-content>\n      <li role=\"presentation\">\n        <a role=\"menuitem\" tabindex=\"-1\" (click)=\"logout()\">Sair</a>\n      </li>\n    </ul>\n  </div>\n</div>\n",
                styles: [""]
            },] },
];
/** @nocollapse */
PMVProfileComponent.ctorParameters = function () { return [
    { type: PMVAuthenticationService, },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Componente de controle do tempo ocioso do usuário no sistema. Caso o usuário fique ocioso por x segundos, é
 * automaticamente deslogado do sistema.
 */
var PMVIdleTimerComponent = /** @class */ (function () {
    /**
     * @param {?} idle
     * @param {?} authenticationService
     * @param {?} notificationService
     */
    function PMVIdleTimerComponent(idle, authenticationService, notificationService) {
        this.idle = idle;
        this.authenticationService = authenticationService;
        this.notificationService = notificationService;
    }
    /**
     * @return {?}
     */
    PMVIdleTimerComponent.prototype.ngOnInit = function () {
        this.setupIdleTimer(this.idle, this.authenticationService, this.notificationService, this.timeLogout);
    };
    /**
     * Configura os listeners de eventos que indicam a não-ociosidade do usuário no sistema.
     * @param {?} idle
     * @param {?} authenticationService
     * @param {?} notificationService
     * @param {?} timeLogout
     * @return {?}
     */
    PMVIdleTimerComponent.prototype.setupIdleTimer = function (idle, authenticationService, notificationService, timeLogout) {
        var _this = this;
        idle.setIdle(0.1);
        idle.setTimeout(timeLogout);
        // idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        idle.onTimeout.subscribe(function () {
            _this.countdown = null;
            notificationService.notifyWarning('Tempo de sessão expirado.');
            authenticationService.logout();
        });
        idle.onTimeoutWarning.subscribe(function (countdown) {
            if (authenticationService.isUserLoggedIn()) {
                _this.countdown = countdown;
            }
            else {
                _this.countdown = null;
            }
        });
        idle.watch();
    };
    return PMVIdleTimerComponent;
}());
PMVIdleTimerComponent.decorators = [
    { type: Component, args: [{
                selector: 'pmv-idle-timer',
                template: "<div *ngIf=\"countdown != null\" class=\"timer\" style=\"width: 65px\">\n  <label class=\"label-tempo\" style=\"color:#fff !important\">\n    <span class=\"glyphicon glyphicon-time\"></span>\n    <span>{{ countdown | secondstotime }}s</span>\n  </label>\n</div>\n",
                styles: [""],
            },] },
];
/** @nocollapse */
PMVIdleTimerComponent.ctorParameters = function () { return [
    { type: Idle, },
    { type: PMVAuthenticationService, },
    { type: NotificationService, },
]; };
PMVIdleTimerComponent.propDecorators = {
    "timeLogout": [{ type: Input },],
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVLayoutModule = /** @class */ (function () {
    function PMVLayoutModule() {
    }
    return PMVLayoutModule;
}());
PMVLayoutModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SharedModule,
                    RouterModule,
                    NgIdleModule.forRoot(),
                    PMVPipeModule,
                ],
                declarations: [
                    PMVHeaderComponent,
                    PMVFooterComponent,
                    PMVNavigationComponent,
                    PMVNavItemComponent,
                    PMVProfileComponent,
                    PMVIdleTimerComponent,
                ],
                exports: [
                    PMVHeaderComponent,
                    PMVFooterComponent,
                    PMVProfileComponent,
                ],
                providers: [
                    NavigationService,
                ],
            },] },
];
/** @nocollapse */
PMVLayoutModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var WEB_SOCKET_URL_TOKEN = new InjectionToken('pmv.webSocket.url');
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var WEB_SOCKET_ENABLE_LOG_TOKEN = new InjectionToken('pmv.webSocket.enableLog');
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var WEB_SOCKET_DATA_AS_JSON_TOKEN = new InjectionToken('pmv.webSocket.dataAsJson');
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var WebSocketService = /** @class */ (function () {
    /**
     * @param {?} url
     * @param {?} enableLog
     * @param {?} dataAsJson
     */
    function WebSocketService(url, enableLog, dataAsJson) {
        this.url = url;
        this.enableLog = enableLog;
        this.dataAsJson = dataAsJson;
        this.onOpenEmitter = new Subject$1();
        this.onCloseEmitter = new Subject$1();
        this.onMessageEmitter = new Subject$1();
        this.onErrorEmitter = new Subject$1();
    }
    /**
     * Abre uma conexão socket com o servidor utilizando a URL passada. Caso não seja passada uma URL, é utilizada a URL
     * configurada na importação do módulo WebSocketModule com o método forRoot. Caso nenhuma das URLs tenha sido passada,
     * é lançada uma exceção.
     *
     * @param {?=} url URL do servidor onde a conexão será aberta (opcional)
     * @return {?}
     */
    WebSocketService.prototype.open = function (url) {
        if (!this.socket) {
            url = url || this.url;
            if (!url) {
                throw new Error('Nenhuma URL configurada para a abertura da conexão WebSocket! Passe uma URL válida na chamada '
                    + 'do método ou configure a URL na importação do módulo WebSocketModule.');
            }
            this.socket = new WebSocket(url);
            this.setupSocketListeners(this.socket);
        }
    };
    /**
     * Configura os listeners de cada evento do socket aberto (open, message, close e error).
     *
     * @param {?} socket socket aberto e conectado
     * @return {?}
     */
    WebSocketService.prototype.setupSocketListeners = function (socket) {
        var _this = this;
        socket.onopen = function (event) {
            _this.consoleLog('Conexão com o socket realizada.');
            _this.onOpenEmitter.next(event);
        };
        socket.onmessage = function (event) {
            try {
                var /** @type {?} */ data = event.data;
                if (_this.dataAsJson) {
                    data = JSON.parse(data);
                }
                _this.consoleLog('Mensagem', data, 'recebida via socket.');
                _this.onMessageEmitter.next(data);
            }
            catch (ex) {
                _this.consoleError('Erro ao parsear mensagem recebida via socket. Mensagem:', event.data);
            }
        };
        socket.onclose = function (event) {
            _this.consoleLog('Conexão com o socket fechada.');
            _this.onCloseEmitter.next(event);
        };
        socket.onerror = function (event) {
            _this.consoleError('Erro na conexão com o socket. Evento:', event);
            _this.onErrorEmitter.next(event);
        };
    };
    /**
     * Recupera a instância do websocket.
     *
     * @return {?} instância do websocket criado
     */
    WebSocketService.prototype.getWebSocket = function () {
        return this.socket;
    };
    /**
     * Retorna o Observable que controla as mensagens recebidas via WebSocket.
     *
     * @return {?} um Observable que emite qualquer mensagem de socket recebida
     */
    WebSocketService.prototype.onMessages = function () {
        return this.onMessageEmitter.asObservable();
    };
    /**
     * Retorna o Observable que informa quando uma conexão com o servidor é estabelecida.
     *
     * @return {?} um Observable que emite sempre que a conexão com o socket é aberta
     */
    WebSocketService.prototype.onOpen = function () {
        return this.onOpenEmitter.asObservable();
    };
    /**
     * Retorna o Observable que informa quando uma conexão com o servidor é perdida.
     *
     * @return {?} um Observable que emite sempre que a conexão com o socket é fechada
     */
    WebSocketService.prototype.onClose = function () {
        return this.onCloseEmitter.asObservable();
    };
    /**
     * Retorna o Observable que informa quando acontence um erro na conexão com o servidor.
     *
     * @return {?} um Observable que emite sempre que ocorre um erro na conexão com o socket
     */
    WebSocketService.prototype.onError = function () {
        return this.onErrorEmitter.asObservable();
    };
    /**
     * Envia uma mensagem via socket para o socket conectado. Caso o socket esteja desconectado, não envia nada.
     *
     * @param {?} message mensagem a ser enviada no socket
     * @return {?}
     */
    WebSocketService.prototype.send = function (message) {
        if (this.socket) {
            if (typeof message === 'object') {
                message = JSON.stringify(message);
            }
            this.socket.send(message);
        }
    };
    /**
     * Fecha a conexão socket com o servidor.
     * @return {?}
     */
    WebSocketService.prototype.close = function () {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
    };
    /**
     * Faz o log de uma mensagem relacionada ao WebSocket no console.
     *
     * @param {...?} item itens a serem concatenados na mensagem a ser logada
     * @return {?}
     */
    WebSocketService.prototype.consoleLog = function () {
        var item = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            item[_i] = arguments[_i];
        }
        if (this.enableLog) {
            var /** @type {?} */ now = new Date();
            console.log.apply(console, tslib_1.__spread(["[" + now.toLocaleString() + "] [WebSocketService]"], item));
        }
    };
    /**
     * Faz o log de erro de uma mensagem relacionada ao WebSocket no console.
     *
     * @param {...?} item itens a serem concatenados na mensagem a ser logada
     * @return {?}
     */
    WebSocketService.prototype.consoleError = function () {
        var item = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            item[_i] = arguments[_i];
        }
        if (this.enableLog) {
            var /** @type {?} */ now = new Date();
            console.error.apply(console, tslib_1.__spread(["[" + now.toLocaleString() + "] [WebSocketService]"], item));
        }
    };
    return WebSocketService;
}());
WebSocketService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
WebSocketService.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [WEB_SOCKET_URL_TOKEN,] },] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [WEB_SOCKET_ENABLE_LOG_TOKEN,] },] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [WEB_SOCKET_DATA_AS_JSON_TOKEN,] },] },
]; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PMVWebSocketModule = /** @class */ (function () {
    function PMVWebSocketModule() {
    }
    /**
     * @param {?} webSocketUrl
     * @param {?=} options
     * @return {?}
     */
    PMVWebSocketModule.forRoot = function (webSocketUrl, options) {
        return {
            ngModule: PMVWebSocketModule,
            providers: [
                WebSocketService,
                { provide: WEB_SOCKET_URL_TOKEN, useValue: webSocketUrl },
                { provide: WEB_SOCKET_ENABLE_LOG_TOKEN, useValue: (options && options.enableLog) || false },
                { provide: WEB_SOCKET_DATA_AS_JSON_TOKEN, useValue: (options && options.dataAsJson) || false },
            ]
        };
    };
    return PMVWebSocketModule;
}());
PMVWebSocketModule.decorators = [
    { type: NgModule, args: [{},] },
];
/** @nocollapse */
PMVWebSocketModule.ctorParameters = function () { return []; };
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/* Módulos */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { PMVMainContentModule, PMVFieldsetModule, PMVConfirmDialogModule, PMVDatatableModule, PMVFileExportModule, PMVInputSearchModule, PMVLoadingModule, PMVModalModule, PMVSnackbarModule, PMVTextareaModule, PMVValidationModule, PMVAutocompleteModule, PMVCheckboxModule, PMVDateIntervalModule, PMVDatepickerModule, PMVDropdownModule, PMVFileUploadModule, PMVInputDecimalModule, PMVInputTextModule, PMVMaskModule, PMVRadioButtonModule, PMVTreeviewModule, PMVMiniLoadingModule, PMVDirectiveModule, PMVPipeModule, PMVUtilModule, PMVStorageModule, PMVEditorModule, PMVDropdownCRUDModule, PMVPickListModule, PMVInputNumberModule, PMVMaskCPFCNPJModule, PMVSingleFileUploadModule, PMVErrorHandler, ConfirmDialogService, FileExportService, NotificationService, SessionStorageService, LocalStorageService, RouteDataService, ActionEvent, Action, Column, ColumnEditConfig, ColumnEditTextConfig, ColumnEditDropdownConfig, ColumnEditDecimalConfig, ColumnCheckboxConfig, ColumnDatepickerConfig, SelectItem, NotificationType, FormType, Combobox, ResultGetPaged, SecondsToTimePipe, MoneyPipe, PhonePipe, DateUtils, TreeviewI18nPT, createCRUDRoutes, page, pageWith, filterBy, numberExtensive, validaCPF, moneyMask, phoneMask, cpfCnpjMask, parseErrorBlob, HexadecimalValueValidator, MaxLengthValueValidator, NumberOnlyValueValidator, returnForm, ProvideParentFormDirective, RegexValueValidator, ValidateOnSubmitDirective, TreeviewConfig$1 as TreeviewConfig, DetailComponent, PMVAuthenticationModule, PMVAuthenticationService, PMVAuthenticationConfig, PMVAuthenticationGuard, PMVAuthenticationComponent, AuthenticationData, AuthenticationProfile, PMVInterceptorsModule, PMVServerPathInterceptor, PMVHeadersInterceptor, PMVLayoutModule, NavigationService, NavItem, PMVWebSocketModule, WebSocketService, ValueAccessorBase, DatatableComponent, TreeviewComponent, FileUploadComponent, TextareaComponent, InputTextComponent, PMVDefaultAuthenticationService as ɵbh, animations as ɵm, ElementBase as ɵi, AutocompleteComponent as ɵu, CheckboxComponent as ɵv, ConfirmDialogComponent as ɵf, DateIntervalComponent as ɵw, DatepickerComponent as ɵp, DropdownCRUDComponent as ɵbc, DropdownComponent as ɵn, EditorComponent as ɵbb, FieldsetComponent as ɵe, FileExportComponent as ɵq, InputDecimalComponent as ɵo, InputNumberComponent as ɵbe, InputSearchComponent as ɵh, LoadingComponent as ɵr, MainContentBodyComponent as ɵd, MainContentHeaderComponent as ɵc, MainContentComponent as ɵb, MaskCPFCNPJComponent as ɵbf, MaskComponent as ɵx, MiniLoadingComponent as ɵl, ModalComponent as ɵs, PicklistComponent as ɵbd, RadioButtonComponent as ɵy, SingleFileUploadComponent as ɵbg, SnackbarComponent as ɵt, ValidationComponent as ɵg, RequiredValueValidator as ɵba, SERVER_PATH_TOKEN as ɵbi, PMVFooterComponent as ɵbk, PMVHeaderComponent as ɵbj, PMVIdleTimerComponent as ɵbo, PMVNavItemComponent as ɵbm, PMVNavigationComponent as ɵbl, PMVProfileComponent as ɵbn, WEB_SOCKET_DATA_AS_JSON_TOKEN as ɵbr, WEB_SOCKET_ENABLE_LOG_TOKEN as ɵbq, WEB_SOCKET_URL_TOKEN as ɵbp, SharedModule as ɵa, MyTreeviewEventParser as ɵz };
//# sourceMappingURL=pmv-common.js.map



//////////////////
// WEBPACK FOOTER
// ./src/deps/pmv-common/esm5/pmv-common.js
// module id = ./src/deps/pmv-common/esm5/pmv-common.js
// module chunks = main